(function() {
    'use strict';

    angular
        .module(
            'biolaser',
            [
                'ngAnimate',
                'ngCookies',
                'ngTouch',
                'ngSanitize',
                'ngMessages',
                'ngAria',
                'ngResource',
                'restangular',
                'ui.router',
                'ngMaterial',
                'ngMaterialDatePicker',
                'ui.bootstrap',
                'toastr',
                'uiGmapgoogle-maps',
                'bootstrapLightbox',
                'ngDialog',
                'satellizer',
                'vcRecaptcha',
                'ngRateIt',
                'mgo-angular-wizard',
                'booking',
                'phonefriends',
                'payment'
            ]
        )
    ;
})();


(function() {
    'use strict';

    angular
        .module('biolaser')
        .directive('radioButtons', radioButtons);

    function radioButtons($filter) {
        var directive = {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=',
                model: '=ngModel'
            },
            templateUrl: 'app/components/radio-buttons/radio-buttons.html',
        //             template:   '<div class="btn-group">' +
        // '<a href="javascript:void(0)" class="btn" ng-class="{true:\'active\', false:\'\'}[selectedValue==option.value]" ng-repeat="option in options" ng-click="select(scope, option.value)" value="{{option.value}}">{{option.label}}</a>' +
        //             '</div>',
            replace: true,
            link: linker
        };

        return directive;


        function linker(scope) {
            scope.select = select;
            scope.scope = scope;
            scope.selectedValue = scope.model;
            
            // scope.$watch("model", function() {
            //    $log.info("Changed"); 
            // });
 
        }

        function select(scope, val) {
            scope.selectedValue = val;
            scope.model = val;
            scope.options = $filter('setActiveRadioButtonFilter')(scope.model,scope.options);
        }


    }

})();


(function () {
    'use strict';

    angular
            .module('phonefriends', [])
            .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
                .state('phonefriends-completed', {
                    url: '/pf/completed',
                    templateUrl: 'app/phonefriends/completed.html',
                    controller: 'PhoneFriendsCompletedController',
                    controllerAs: 'completed'
                })
                .state('phonefriends', {
                    url: '/pf?cph&crdid&customer&token&c_role&c_sid',
                    templateUrl: 'app/phonefriends/phonefriends.html',
                    controller: 'PhoneFriendsController',
                    controllerAs: 'phonefriends',
                    resolve: {
                        userPhone: function ($stateParams) {
                            return $stateParams.cph ? $stateParams.cph : ($stateParams.customer ? $stateParams.customer : null);
                        },
                        cardId: function ($stateParams) {
                            return $stateParams.crdid ? $stateParams.crdid : null;
                        },
                        token: function ($stateParams) {
                            return $stateParams.token ? $stateParams.token : null;
                        },
                        userRole: function($stateParams){
                          if($stateParams.c_role){
                            return $stateParams.c_role;
                          } else {
                            return null;
                          }
                        },
                        userSid: function($stateParams){
                          if($stateParams.c_sid != null && $stateParams.c_sid!= 'null'){
                            return parseInt($stateParams.c_sid);
                          } else {
                            return null;
                          }
                        }
                    },
                })
                ;
    }

})();


(function() {
    'use strict';

    angular
        .module('phonefriends')

        .factory('ProspectService', function(Restangular, $filter) {

            var service = {};

            service.save = function(data, isUser){
            	if (isUser) {
            		return Restangular.all('leads_a').post(data);
            	} else {
            		return Restangular.all('leads').post(data);
            	}
            };

            return service;
        })
})();

(function() {
    'use strict';

    angular
        .module('phonefriends')
})();

 
(function () {
    'use strict';
    angular
            .module('phonefriends')
            .controller('PhoneFriendsController', PhoneFriendsController)
            .controller('PhoneFriendsCompletedController', PhoneFriendsCompletedController);
    /** @ngInject */
    function PhoneFriendsController(
            env,
            $log,
            $state,
            ngDialog,
            $scope,
            $rootScope,
            CustomerService,
            ProspectService,
            WizardHandler,
            UserService,
            TokenService,
            userPhone,
            cardId,
            token,
            userRole,
            userSid
            ) {
        var vm = this;
        vm.env = env;
        vm.version = "2.6";
        /**
         * TODO da gestire
         * Utente loggato
         */
        vm.user = null;
        vm.isUser = true;
        vm.token = token;
        //$log.info(token);
        //$log.info(UserService);
        //DEFAULT
        vm.step = 0;
        vm.prospect = {
            firstname: null,
            lastname: null,
            phone: null
        };
        vm.savedProspectFlag = false;
        vm.newCustomer = function (phone) {
            return {
                firstname: null,
                lastname: null,
                phone: phone,
                birthdate: null,
                email: null,
                gender: null,
                referral_code: null,
                overwritten_by_lead: 0,
                change_state_counter: 0,
                credit: 0,
                user_times: 0,
                app_times: 0
            };
        }
        vm.customer = vm.newCustomer(null);
        vm.getErrorMsg = function (response) {
            if (!vm.isUser)
                return null;
            var msg = null;
            if (response.data != null && response.data.message != null) {
                msg = response.data != null && response.data.message != null ? "\n\nERRORE: " + response.data.message : "";
                msg += response.config != null && response.config.url != null ? "\nURL: " + response.config.url : "";
                if (vm.user.id == 20 || vm.user.type == 'admin') {
                    if (response.data != null && response.data.debug != null) {
                        msg += "\n\nCLASS: " + response.data.debug.class;
                        msg += "\nTRACE:";
                        for (var i = 0; i < response.data.debug.trace.length && i < 5; i++) {
                            msg += "\n" + response.data.debug.trace[i];
                        }
                    }
                }
            }
            return msg;
        };
        //---------- customerdata -------------------------------------//

        vm.customerChecking = false;
        vm.customerLoaded = null;
        vm.user_times = 2;
        vm.checkCustomer = function () {
            if (vm.customer.phone == null || vm.customer.phone.trim() == '')
                return;
            vm.customerChecking = true;
            vm.customerLoaded = null;
            /**
             * Devo eseguire solo se il cell è valido
             */
            CustomerService.all({'search': vm.customer.phone, 'searchFields': 'phone:=', 'with': 'lastStore'}, vm.env.API).then(
                    function (data) {
                        vm.customerChecking = false;
                        if (data.length >= 1) {
                            vm.customer = data[0];
                            vm.customerLoaded = true;
                            ga('set', 'page', '/pf/checkcustomer');
                            ga('send', 'pageview');
                        } else {
                        	ga('set', 'page', '/pf/checkcustomer/notfound');
                        	ga('send', 'pageview');
                            vm.customerLoaded = false;
                        }
                    },
                    function (data) {
                        var msg = vm.getErrorMsg(data);
                        alert("C'è stato un problema nel caricamento della cliente." + (msg != null ? " " + msg : ""));
                        vm.customerChecking = false;
                        ga('set', 'page', '/pf/checkcustomer/error');
                    	ga('send', 'pageview');
                    }
            );
        };

        if (userPhone) {
            vm.customer.phone = userPhone;
            vm.checkCustomer();
        }
        if (cardId) {
            vm.cardId = cardId;
        }
        $scope.saving = false;
        $scope.saveProspect = function (step, goBooking) {
            if (vm.customerLoaded) {
            	$scope.saving = true;
            	var lead = {
                        'src_cid': vm.customer.id,
                        'telefono': vm.prospect.phone,
                        'user_first_name': vm.prospect.firstname,
                        'user_last_name': vm.prospect.lastname,
                        'campagna': 'PhoneFriend',
                        'step': step,
                        'card_id': vm.cardId,
                        'c_sid': vm.user.store_id,
                        'c_role': vm.user.type
                    };
            	if (vm.isUser && (vm.user.type == 'callcenter' || vm.user.type == 'admin')) {
            		lead.operator_assign = 'y';
            		lead.operator_email = vm.user.email;
            	}
                ProspectService.save(lead, vm.isUser).then(
                        function (data) {
                        	vm.step = step;
                        	$log.info(data);
                        	$scope.saving = false;
                            if (data.id) {
                            	if (goBooking) {
                            		//alert ("devo andare al booking");
                            		window.location = "/operator?lead="+data.id+"&customer="+data.telefono+"&token="+vm.token;
                            		return;
                            	}
                            	if (step < 5) {
                            		vm.savedProspectFlag = true;
                                    vm.prospect.phone = "";
                                    vm.prospect.firstname = "";
                                    vm.prospect.lastname = "";
                                    WizardHandler.wizard('addProspects').goTo(step);
                                    ga('set', 'page', '/pf/step'+step);
                                    ga('send', 'pageview');
                                } else if (step == 5) {
                                    $rootScope.customer = vm.customer;
                                    if (vm.isUser) {
                                    	vm.back();
                                    } else {
                                    	$state.go('phonefriends-completed');
                                    }
                                }
                            } else {
                                var msg = vm.getErrorMsg(data);
                                alert("C'è stato un problema nel salvataggio." + (msg != null ? " " + msg : ""));
                                vm.savedProspectFlag = false;
								ga('set', 'page', '/pf/step'+step+'/error');
                                ga('send', 'pageview');
                            }
                        },
                        function (data) {
                        	$scope.saving = false;
                            var msg = vm.getErrorMsg(data);
                            alert("C'è stato un problema nel salvataggio." + (msg != null ? " " + msg : ""));
                            vm.savedProspectFlag = false;
							ga('set', 'page', '/pf/step'+step+'/error');
                            ga('send', 'pageview');
                        }
                );
            } else {
                vm.savedProspectFlag = false;
            }
        };

     // Check for User logged-in
        vm.redirectLogout = function() {
            return window.location.replace( env.booking + '/notauthorized' );
        };

        vm.removeLocalStorage = function() {
            localStorage.removeItem( 'Biolaser_token' );
            localStorage.removeItem( 'user' );
        };
        if (!token) {
        	vm.removeLocalStorage();
        }
        vm.doLogout = function() {
            TokenService
                .delete()
                .finally( function() {
                    vm.removeLocalStorage();
                    if (vm.isUser) {
                    	return  vm.redirectLogout();
                    }
                } )
            ;
        };
	    if ( token ) {
            localStorage.setItem( 'Biolaser_token', token );
            UserService
                .logIn()
                .then(
                    function( response ) {
                    	//$log.info(response);
                        if( response.data.user ) {
                            localStorage.setItem( 'user', angular.toJson( response.data.user ) );
                            /* Operatore connesso */
                            var user = angular.fromJson( localStorage.getItem( 'user' ) );
                            if( user ) {
                                //vm.operator = user;
                            	vm.user = user;
                            	vm.isUser = true;
                            	angular.forEach(vm.user.roles, function (r) {
                            	  if (r.active && userRole == r.role && r.store_id == userSid) {
                            	    vm.user.type = userRole;
                            	    vm.user.color = r.color;
                            	    vm.user.store_id = userSid;
                            	  }
                            	});
                            	if (userRole == 'operator' || userRole == 'storemngr' || userRole == 'manager') {
                            	  vm.isStoreUser = true;
                            	} else {
                            	  vm.isStoreUser = false;
                            	}
                            	vm.operatorId = user.id;
                                vm.user_type = user.type;
                                vm.isCallCenter = ( vm.user_type === 'callcenter' ||  vm.user_type === 'admin') ? true : false;
                            } else {
                                vm.doLogout();
                            }
                        }
                    },
                    vm.doLogout
                );
        } else {
            vm.isUser = false;
        };

        vm.back = function () {
          if (vm.user.type == 'callcenter') {
            window.location = env.admin + "/leads";
          } else {
            window.location = env.admin + "/appointments";
          }
        };

    };

    function PhoneFriendsCompletedController($rootScope, $log) {
        var vm = this;
        ga('set', 'page', '/pf/completed');
        ga('send', 'pageview');
        $log.info("PhoneFriend Completed");
    }
    ;
})();

(function() {
  'use strict';

  angular
    .module('booking',[])
    .config(routerConfig);

  /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('booking-completed', {
                url: '/completed',
                templateUrl: 'app/booking/completed.html',
                controller: 'BookingCompletedController',
                controllerAs: 'completed'
            })
            .state('booking-payment-error', {
                url: '/payment-error?type',
                templateUrl: 'app/booking/payment-error.html',
                controller: 'BookingPaymentErrorController',
                controllerAs: 'booking',
                resolve: {
                    type: function($stateParams){
                        if($stateParams.type) {
                            return $stateParams.type;
                        } else {
                            return null;
                        }
                    }
                }
            })
            .state('booking-payment-cancel', {
                url: '/payment-cancel?type',
                templateUrl: 'app/booking/payment-cancel.html',
                controller: 'BookingPaymentCancelController',
                controllerAs: 'booking',
                resolve: {
                    type: function($stateParams){
                        if($stateParams.type) {
                            return $stateParams.type;
                        } else {
                            return null;
                        }
                    }
                }
            })
            .state('booking-payment-success', {
                url: '/payment-success?type',
                templateUrl: 'app/booking/payment-success.html',
                controller: 'BookingPaymentSuccessController',
                controllerAs: 'booking',
                resolve: {
                    type: function($stateParams){
                        if($stateParams.type) {
                            return $stateParams.type;
                        } else {
                            return null;
                        }
                    },
                }
            })
            .state('booking-notauthorized', {
                url: '/notauthorized',
                templateUrl: 'app/booking/notauthorized.html',
                controller: 'BookingNotAuthorizedController',
                controllerAs: 'booking'
            })
            .state('booking-promo-expired', {
                url: '/promoexpired',
                templateUrl: 'app/booking/promoexpired.html',
                controller: 'BookingNotAuthorizedController',
                controllerAs: 'booking'
            })
            .state('booking-promo-already', {
                url: '/promoalready',
                templateUrl: 'app/booking/promoalready.html',
                controller: 'BookingNotAuthorizedController',
                controllerAs: 'booking'
            })
            .state('booking-promo-notvalid', {
                url: '/promonotvalid',
                templateUrl: 'app/booking/promonotvalid.html',
                controller: 'BookingNotAuthorizedController',
                controllerAs: 'booking'
            })
            .state('booking-operator', {
                url: '/operator?kpiCheck&debug&tenant&token&c_role&c_sid&store&customer&lead&tag&campagna&caid&callcenter&appointment&treatment&appointmentDate&wkFlow&wkStateTo&wkStateFrom&wkEntityId',
                templateUrl: 'app/booking/booking.html',
                controller: 'BookingController',
                controllerAs: 'booking',
                resolve: {
                    tenant: function( $stateParams ) {
                        if( $stateParams.tenant ) {
                            return $stateParams.tenant;
                        } else {
                            return null;
                        };
                    },
                    debug: function( $stateParams ) {
                        if( $stateParams.debug ) {
                            return $stateParams.debug;
                        } else {
                            return null;
                        };
                    },
                    kpiCheck: function( $stateParams ) {
                        if( $stateParams.kpiCheck ) {
                            return $stateParams.kpiCheck;
                        } else {
                            return null;
                        };
                    },
                    token: function( $stateParams ) {
                        if( $stateParams.token ) {
                            return $stateParams.token;
                        } else {
                            return null;
                        };
                    },
                    isUser: function(){
                        return true;
                    },
                    userRole: function($stateParams){
                      if($stateParams.c_role){
                        return $stateParams.c_role;
                      } else {
                        return null;
                      }
                    },
                    userSid: function($stateParams){
                      if($stateParams.c_sid != null && $stateParams.c_sid!= 'null'){
                        return parseInt($stateParams.c_sid);
                      } else {
                        return null;
                      }
                    },
                    storeId: function($stateParams){
                        if($stateParams.store){
                            return parseInt($stateParams.store);
                        }else{
                            return null;
                        }
                    },
                    customerId: function($stateParams){
                        if($stateParams.customer){
                            return $stateParams.customer;
                        }else{
                            return null;
                        }
                    },
                    leadId: function($stateParams){
                      if($stateParams.lead) {
                          return $stateParams.lead;
                      } else {
                          return null;
                      }
                    },
                    tag: function($stateParams){
                        if($stateParams.tag) {
                            return $stateParams.tag;
                        } else {
                            return null;
                        }
                    },
                    campagna: function($stateParams){
                        if($stateParams.campagna) {
                            return $stateParams.campagna;
                        } else {
                            return null;
                        }
                    },
                    cusActId: function($stateParams){
                      if($stateParams.caid) {
                          return $stateParams.caid;
                      } else {
                          return null;
                      }
                    },
                    treatmentId: function($stateParams){
                        if($stateParams.treatment) {
                            return $stateParams.treatment;
                        } else {
                            return null;
                        }
                    },
                    appointmentId: function($stateParams){
                        if($stateParams.appointment) {
                            return $stateParams.appointment;
                        } else {
                            return null;
                        }
                    },
                    appointmentDate: function($stateParams){
                        if($stateParams.appointmentDate){
                            return moment($stateParams.appointmentDate).format("DD/MM/YYYY HH:mm");
                        }else{
                            return null;
                        }
                    },
                    callCenter: function($stateParams){
                        if($stateParams.callcenter) {
                            return $stateParams.callcenter!='false' && ($stateParams.callcenter=='true' || parseInt($stateParams.callcenter)>0);
                        } else {
                            return null;
                        }
                    },
                    birthtime: function() {
                        return null;
                    },
                    landing: function(){
                        return null;
                    },
                    source: function(){
                        return null;
                    },
                    couponCode: function(){
                        return null;
                    },
                    appCustomerId: function(){
                        return null;
                    },
                    utmSource: function(){
                        return null;
                    },
                    utmMedium: function(){
                        return null;
                    },
                    utmChannel: function(){
                        return null;
                    },
                    utmRegion: function(){
                        return null;
                    },
                    utmGender: function(){
                        return null;
                    },
                    utmTreatment: function(){
                    },
                    utmCreative: function(){
                        return null;
                    },
                    utmCampaign: function(){
                        return null;
                    },
                    utmAid: function(){
                        return null;
                    },
                    utmPricing: function(){
                        return null;
                    },
                    wkFlow: function($stateParams){
                        if($stateParams.wkFlow) {
                            return $stateParams.wkFlow;
                        } else {
                            return null;
                        }
                    },
                    wkStateFrom: function($stateParams){
                        if($stateParams.wkStateFrom) {
                            return $stateParams.wkStateFrom;
                        } else {
                            return null;
                        }
                    },
                    wkStateTo: function($stateParams){
                        if($stateParams.wkStateTo) {
                            return $stateParams.wkStateTo;
                        } else {
                            return null;
                        }
                    },
                    wkEntityId: function($stateParams){
                        if($stateParams.wkEntityId) {
                            return $stateParams.wkEntityId;
                        } else {
                            return null;
                        }
                    }
                }
            })
            .state('booking', {
                url: '/:code?bt&customer&tag&store&lead&treatment&source&coupon_code&app_customer_id&appointment&appointmentDate&utm_source&utm_medium&utm_campaign&utm_gender&utm_region&utm_treatment&utm_aid&utm_creative&utm_channel&utm_pricing&wkFlow&wkStateTo&wkStateFrom&wkEntityId',
                templateUrl: 'app/booking/booking.html',
                controller: 'BookingController',
                controllerAs: 'booking',
                resolve: {
                    tenant: function(){
                        return null;
                    },
                    debug: function(){
                        return null;
                    },
                    kpiCheck: function(){
                        return null;
                    },
                    token: function(){
                        return null;
                    },
                    isUser: function(){
                        return false;
                    },
                    userRole: function(){
                      return 'guest';
                    },
                    userSid: function(){
                      return null;
                    },
                    storeId: function($stateParams){
                        if($stateParams.store){
                            return parseInt($stateParams.store);
                        }else{
                            return null;
                        }
                    },
                    customerId: function($stateParams){
                        if($stateParams.customer){
                            return $stateParams.customer;
                        }else{
                            return null;
                        }
                    },
                    leadId: function($stateParams){
                      if($stateParams.lead){
                          return $stateParams.lead;
                      }else{
                          return null;
                      }
                    },
                    tag: function($stateParams){
                        if($stateParams.tag){
                            return $stateParams.tag;
                        }else{
                            return null;
                        }
                    },
                    operatorId: function(){
                        return null;
                    },
                    cusActId: function(){
                      return null;
                    },
                    treatmentId: function($stateParams){
                        if($stateParams.treatment){
                            return $stateParams.treatment;
                        }else{
                            return null;
                        }
                    },
                    appointmentId: function($stateParams){
                        if($stateParams.appointment) {
                            return $stateParams.appointment;
                        } else {
                            return null;
                        }
                    },
                    appointmentDate: function($stateParams){
                        if($stateParams.appointmentDate){
                            return moment($stateParams.appointmentDate).format("DD/MM/YYYY HH:mm");
                        }else{
                            return null;
                        }
                    },
                    campagna: function(){
                        return null;
                    },
                    callCenter: function(){
                        return null;
                    },
                    birthtime: function($stateParams) {
                        if ($stateParams.bt) {
                            return $stateParams.bt;
                        } else {
                            return null;
                        }
                    },
                    landing: function($stateParams, LandingService){
                        if($stateParams.code){
                            return LandingService
                                .all({with:'stores;stores.operators',search:$stateParams.code,searchFields:'code:='})
                                .then(function(data){
                                    return data[0];
                                })
                            ;
                        }else{
                            return null;
                        }
                    },
                    source: function($stateParams){
                        if($stateParams.source) {
                            return $stateParams.source;
                        } else {
                            return null;
                        }
                    },
                    couponCode: function($stateParams){
                        if($stateParams.coupon_code) {
                            return $stateParams.coupon_code;
                        } else {
                            return null;
                        }
                    },
                    appCustomerId: function($stateParams){
                        if($stateParams.app_customer_id) {
                            return $stateParams.app_customer_id;
                        } else {
                            return null;
                        }
                    },
                    utmSource: function($stateParams){
                        if($stateParams.utm_source) {
                            return $stateParams.utm_source;
                        } else {
                            return null;
                        }
                    },
                    utmMedium: function($stateParams){
                        if($stateParams.utm_medium) {
                            return $stateParams.utm_medium;
                        } else {
                            return null;
                        }
                    },
                    utmChannel: function($stateParams){
                        if($stateParams.utm_channel) {
                            return $stateParams.utm_channel;
                        } else {
                            return null;
                        }
                    },
                    utmRegion: function($stateParams){
                        if($stateParams.utm_region) {
                            return $stateParams.utm_region;
                        } else {
                            return null;
                        }
                    },
                    utmGender: function($stateParams){
                        if($stateParams.utm_gender) {
                            return $stateParams.utm_gender;
                        } else {
                            return null;
                        }
                    },
                    utmTreatment: function($stateParams){
                        if($stateParams.utm_treatment) {
                            return $stateParams.utm_treatment;
                        } else {
                            return null;
                        }
                    },
                    utmCreative: function($stateParams){
                        if($stateParams.utm_creative) {
                            return $stateParams.utm_creative;
                        } else {
                            return null;
                        }
                    },
                    utmCampaign: function($stateParams){
                        if($stateParams.utm_campaign) {
                            return $stateParams.utm_campaign;
                        } else {
                            return null;
                        }
                    },
                    utmAid: function($stateParams){
                        if($stateParams.utm_aid) {
                            return $stateParams.utm_aid;
                        } else {
                            return null;
                        }
                    },
                    utmPricing: function($stateParams){
                        if($stateParams.utm_pricing) {
                            return $stateParams.utm_pricing;
                        } else {
                            return null;
                        }
                    },
                    wkFlow: function($stateParams){
                        if($stateParams.wkFlow) {
                            return $stateParams.wkFlow;
                        } else {
                            return null;
                        }
                    },
                    wkStateFrom: function($stateParams){
                        if($stateParams.wkStateFrom) {
                            return $stateParams.wkStateFrom;
                        } else {
                            return null;
                        }
                    },
                    wkStateTo: function($stateParams){
                        if($stateParams.wkStateTo) {
                            return $stateParams.wkStateTo;
                        } else {
                            return null;
                        }
                    },
                    wkEntityId: function($stateParams){
                        if($stateParams.wkEntityId) {
                            return $stateParams.wkEntityId;
                        } else {
                            return null;
                        }
                    }
                }
            })
        ;
    }

})();


(function () {
    'use strict';

    angular
        .module('booking')
        .service(
            'CfService',
            [
                '$log',
                'env',
                '$http',
                function(
                    $log,
                    env,
                    $http
                ) {
                    return {
                        computeCf: function(lastname, firstname, birthdate, birthcity, gender) {
                            var apiURI = env.API + '/customers/compute_cf';
                            return $http.post(apiURI, {
                                lastname: lastname,
                                firstname: firstname,
                                birthdate: birthdate,
                                birthcity: birthcity,
                                gender: gender
                            });
                        }
                    };
                }
            ]
        )
        .service('ProvinceService', 
            [ 
                '$log',
                '$http',
                'env', 
                function($log, $http, env) {
                    return {
                        all: function() {
                            var res = [];
                            res.push({ value: "AG", label: "Agrigento" });
                            res.push({ value: "AL", label: "Alessandria" });
                            res.push({ value: "AN", label: "Ancona" });
                            res.push({ value: "AO", label: "Aosta" });
                            res.push({ value: "AR", label: "Arezzo" });
                            res.push({ value: "AP", label: "Ascoli Piceno" });
                            res.push({ value: "AT", label: "Asti" });
                            res.push({ value: "AV", label: "Avellino" });
                            res.push({ value: "BA", label: "Bari" });
                            res.push({ value: "BT", label: "Barletta-Andria-Trani" });
                            res.push({ value: "BL", label: "Belluno" });
                            res.push({ value: "BN", label: "Benevento" });
                            res.push({ value: "BG", label: "Bergamo" });
                            res.push({ value: "BI", label: "Biella" });
                            res.push({ value: "BO", label: "Bologna" });
                            res.push({ value: "BZ", label: "Bolzano" });
                            res.push({ value: "BS", label: "Brescia" });
                            res.push({ value: "BR", label: "Brindisi" });
                            res.push({ value: "CA", label: "Cagliari" });
                            res.push({ value: "CL", label: "Caltanissetta" });
                            res.push({ value: "CB", label: "Campobasso" });
                            res.push({ value: "CI", label: "Carbonia-Iglesias" });
                            res.push({ value: "CE", label: "Caserta" });
                            res.push({ value: "CT", label: "Catania" });
                            res.push({ value: "CZ", label: "Catanzaro" });
                            res.push({ value: "CH", label: "Chieti" });
                            res.push({ value: "CO", label: "Como" });
                            res.push({ value: "CS", label: "Cosenza" });
                            res.push({ value: "CR", label: "Cremona" });
                            res.push({ value: "KR", label: "Crotone" });
                            res.push({ value: "CN", label: "Cuneo" });
                            res.push({ value: "EN", label: "Enna" });
                            res.push({ value: "FM", label: "Fermo" });
                            res.push({ value: "FE", label: "Ferrara" });
                            res.push({ value: "FI", label: "Firenze" });
                            res.push({ value: "FG", label: "Foggia" });
                            res.push({ value: "FC", label: "Forlì-Cesena" });
                            res.push({ value: "FR", label: "Frosinone" });
                            res.push({ value: "GE", label: "Genova" });
                            res.push({ value: "GO", label: "Gorizia" });
                            res.push({ value: "GR", label: "Grosseto" });
                            res.push({ value: "IM", label: "Imperia" });
                            res.push({ value: "IS", label: "Isernia" });
                            res.push({ value: "SP", label: "La Spezia" });
                            res.push({ value: "AQ", label: "L'Aquila" });
                            res.push({ value: "LT", label: "Latina" });
                            res.push({ value: "LE", label: "Lecce" });
                            res.push({ value: "LC", label: "Lecco" });
                            res.push({ value: "LI", label: "Livorno" });
                            res.push({ value: "LO", label: "Lodi" });
                            res.push({ value: "LU", label: "Lucca" });
                            res.push({ value: "MC", label: "Macerata" });
                            res.push({ value: "MN", label: "Mantova" });
                            res.push({ value: "MS", label: "Massa-Carrara" });
                            res.push({ value: "MT", label: "Matera" });
                            res.push({ value: "VS", label: "Medio Campidano" });
                            res.push({ value: "ME", label: "Messina" });
                            res.push({ value: "MI", label: "Milano" });
                            res.push({ value: "MO", label: "Modena" });
                            res.push({ value: "MB", label: "Monza e della Brianza" });
                            res.push({ value: "NA", label: "Napoli" });
                            res.push({ value: "NO", label: "Novara" });
                            res.push({ value: "NU", label: "Nuoro" });
                            res.push({ value: "OG", label: "Ogliastra" });
                            res.push({ value: "OT", label: "Olbia-Tempio" });
                            res.push({ value: "OR", label: "Oristano" });
                            res.push({ value: "PD", label: "Padova" });
                            res.push({ value: "PA", label: "Palermo" });
                            res.push({ value: "PR", label: "Parma" });
                            res.push({ value: "PV", label: "Pavia" });
                            res.push({ value: "PG", label: "Perugia" });
                            res.push({ value: "PU", label: "Pesaro e Urbino" });
                            res.push({ value: "PE", label: "Pescara" });
                            res.push({ value: "PC", label: "Piacenza" });
                            res.push({ value: "PI", label: "Pisa" });
                            res.push({ value: "PT", label: "Pistoia" });
                            res.push({ value: "PN", label: "Pordenone" });
                            res.push({ value: "PZ", label: "Potenza" });
                            res.push({ value: "PO", label: "Prato" });
                            res.push({ value: "RG", label: "Ragusa" });
                            res.push({ value: "RA", label: "Ravenna" });
                            res.push({ value: "RC", label: "Reggio di Calabria" });
                            res.push({ value: "RE", label: "Reggio nell'Emilia" });
                            res.push({ value: "RI", label: "Rieti" });
                            res.push({ value: "RN", label: "Rimini" });
                            res.push({ value: "RM", label: "Roma" });
                            res.push({ value: "RO", label: "Rovigo" });
                            res.push({ value: "SA", label: "Salerno" });
                            res.push({ value: "SS", label: "Sassari" });
                            res.push({ value: "SV", label: "Savona" });
                            res.push({ value: "SI", label: "Siena" });
                            res.push({ value: "SR", label: "Siracusa" });
                            res.push({ value: "SO", label: "Sondrio" });
                            res.push({ value: "TA", label: "Taranto" });
                            res.push({ value: "TE", label: "Teramo" });
                            res.push({ value: "TR", label: "Terni" });
                            res.push({ value: "TO", label: "Torino" });
                            res.push({ value: "TP", label: "Trapani" });
                            res.push({ value: "TN", label: "Trento" });
                            res.push({ value: "TV", label: "Treviso" });
                            res.push({ value: "TS", label: "Trieste" });
                            res.push({ value: "UD", label: "Udine" });
                            res.push({ value: "VA", label: "Varese" });
                            res.push({ value: "VE", label: "Venezia" });
                            res.push({ value: "VB", label: "Verbano-Cusio-Ossola" });
                            res.push({ value: "VC", label: "Vercelli" });
                            res.push({ value: "VR", label: "Verona" });
                            res.push({ value: "VV", label: "Vibo Valentia" });
                            res.push({ value: "VI", label: "Vicenza" });
                            res.push({ value: "VT", label: "Viterbo" });

                            //$log.info('ProvinceService.all',res);
                            return res;
                        }
                    };
                }
            ]
        );
})();

(function () {
    'use strict';

    angular
            .module('payment', [])
            .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
                .state('payment-success', {
                    url: '/payment/success?type',
                    templateUrl: 'app/payment/payment-success.html',
                    controller: 'PaymentSuccessController',
                    controllerAs: 'booking',
                    resolve: {
                        type: function($stateParams){
                            if($stateParams.type) {
                                return $stateParams.type;
                            } else {
                                return null;
                            }
                        },
                    }
                })
                .state('payment', {
                    url: '/payment?appId&start&end&created',
                    templateUrl: 'app/payment/payment.html',
                    controller: 'PaymentController',
                    controllerAs: 'booking',
                    resolve: {
                        appId: function ($stateParams) {
                            return $stateParams.appId ? $stateParams.appId : null;
                        },
                        start: function ($stateParams) {
                            return $stateParams.start ? $stateParams.start : null;
                        },
                        created: function ($stateParams) {
                            return $stateParams.created ? $stateParams.created : null;
                        }
                    },
                })
                ;
    }

})();


(function () {
    'use strict';
    angular
            .module('payment')
            .controller('PaymentController', PaymentController)
            .controller('PaymentSuccessController', PaymentSuccessController);
    /** @ngInject */
    function PaymentController(
            env,
            $log,
            $state,
            ngDialog,
            $scope,
            $rootScope,
            CfService,
            ProvinceService,
            appId,
            start,
            created,
            $http
            ) {
        var vm = this;
        vm.env = env;
        console.log('PaymentController', appId, start, created, env);
        vm.provinces = ProvinceService.all();
        vm.birthProvinces = ProvinceService.all();
        vm.citiesByProvince = [];
        vm.birthCitiesByProvince = [];

        /**
         * Carico i dati dell'appuntamento da pagare
         */
        vm.alreadyPaid = false;
        vm.error = '';
        vm.loading = true;
        if (appId) {
                $http.get(vm.env.API+'/payment-data/'+appId+"/"+start+'/'+created
            ).then(
                function (response) {
                    /**
                     * se recalled devo fare altra chiamata per prendere tutti quelli che hanno stessa origine
                     */
                    vm.deposit = response.data.data.deposit;
                    vm.customer = response.data.data.customer;
                    vm.appointment = response.data.data;
                    var type = 'preauth';
                    vm.alreadyPaid = vm.deposit.preauth_paid;
                    if (vm.appointment.f_deposit) {
                        type = 'deposit';
                        vm.alreadyPaid = vm.deposit.paid;
                    } else if (vm.appointment.f_prepayment) {
                        type = 'prepayment';
                        vm.alreadyPaid = vm.deposit.paid;
                    }
                    vm.appointment.date_start_frmt = moment(vm.appointment.date_start).format('DD/MM/YYYY HH:mm');
                    vm.type = type;
                    if (vm.customer.birthdate) {
                        vm.customer.birthdate = new Date(vm.customer.birthdate);
                    }
                    console.log('PaymentController appointment', vm.appointment);
                    console.log('PaymentController customer', vm.customer);
                    console.log('PaymentController deposit', vm.deposit);
                    
                    // Carica le città se la provincia è già presente
                    if (vm.customer.province) {
                        vm.provinceChange();
                    }
                    
                    if (vm.customer.birthprovince) {
                        vm.birthProvinceChange();
                    }
                    
                    vm.init();
                    vm.loading = false;
                },
                function (error) {
                    console.error(error);
                    vm.error = error.data.message;
                    vm.loading = false;
                }
            );
        }

        vm.computeCf = function() {
            vm.computingCf = true;
            vm.cferror = '';
            CfService.computeCf(
                vm.customer.lastname, vm.customer.firstname, 
                vm.customer.birthdate, vm.customer.birthcity,
                vm.customer.gender
            ).then(
                function(response) {
                    console.log('computeCf', response);
                    vm.computingCf = false;
                    if (!response.data.status) {
                        vm.cferror = response.data.message;
                        return;
                    } else {
                        vm.cferror = response.data.message;
                    }
                    vm.customer.cf = response.data.data.cf;
                },
                function(error) {
                    console.error(error);
                    vm.computingCf = false;
                    vm.cferror = error.data.message;
                }
            )
        };
        vm.computingCf = false;

        // Funzione per caricare le città in base alla provincia selezionata
        vm.loadCitiesByProvince = function(provinceCode) {
            if (!provinceCode) return;
            
            return $http.get(vm.env.API + '/comuni-it?sigla_provincia=' + provinceCode)
                .then(function(response) {
                    console.log('Città caricate:', response.data);
                    // Estrai i nomi delle città dall'array di oggetti
                    var cities = [];
                    if (response.data.data && Array.isArray(response.data.data)) {
                        cities = response.data.data.map(function(city) {
                            return city.denominazione_it;
                        });
                    }
                    return cities;
                }, function(error) {
                    console.error('Errore nel caricamento delle città:', error);
                    vm.error = 'Errore nel caricamento delle città: ' + error.data.message;
                    return [];
                });
        };

        // Funzione chiamata quando cambia la provincia di residenza
        vm.provinceChange = function() {
            if (!vm.customer.province) {
                vm.citiesByProvince = [];
                return;
            }
            
            vm.loadCitiesByProvince(vm.customer.province).then(function(cities) {
                vm.citiesByProvince = cities;
                
                // Verifica case-insensitive se la città attuale è nella lista
                if (vm.customer.city) {
                    var cityFound = false;
                    var cityLower = vm.customer.city.toLowerCase();
                    
                    for (var i = 0; i < cities.length; i++) {
                        if (cities[i].toLowerCase() === cityLower) {
                            // Aggiorna con la versione corretta dal server
                            vm.customer.city = cities[i];
                            cityFound = true;
                            break;
                        }
                    }
                    
                    // Se la città non è stata trovata, la resettiamo
                    if (!cityFound) {
                        vm.customer.city = '';
                    }
                }
            });
        };

        // Funzione chiamata quando cambia la provincia di nascita
        vm.birthProvinceChange = function() {
            if (!vm.customer.birthprovince) {
                vm.birthCitiesByProvince = [];
                return;
            }
            
            vm.loadCitiesByProvince(vm.customer.birthprovince).then(function(cities) {
                vm.birthCitiesByProvince = cities;
                
                // Verifica case-insensitive se la città attuale è nella lista
                if (vm.customer.birthcity) {
                    var cityFound = false;
                    var cityLower = vm.customer.birthcity.toLowerCase();
                    
                    for (var i = 0; i < cities.length; i++) {
                        if (cities[i].toLowerCase() === cityLower) {
                            // Aggiorna con la versione corretta dal server
                            vm.customer.birthcity = cities[i];
                            cityFound = true;
                            break;
                        }
                    }
                    
                    // Se la città non è stata trovata, la resettiamo
                    if (!cityFound) {
                        vm.customer.birthcity = '';
                    }
                }
            });
        };

        vm.init = function() {

            vm.stripe = Stripe(vm.env.stripe.public_key); // Usa la tua chiave pubblica
            vm.elements = vm.stripe.elements();
        
            // Creazione del campo per la carta di credito
            vm.card = vm.elements.create('card');
            vm.card.mount('#card-element');
        
            // Gestione della validazione
            vm.card.addEventListener('change', function(event) {
                if (event.error) {
                    vm.error = event.error.message;
                } else {
                    vm.error = '';
                }
            });

            if (vm.type != 'preauth') {
                var total = vm.deposit.price;
                if (vm.appointment.f_prepayment || vm.appointment.f_deposit) {
                    total = vm.deposit.price;
                } else {
                    total = vm.deposit.preauth_amount;
                }

                var paymentRequest = vm.stripe.paymentRequest({
                    country: 'IT',
                    currency: 'eur',
                    total: {
                        label: 'Totale',
                        amount: Math.round(total * 100),
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,
                    supportedPaymentMethods: [
                        {
                            type: 'card'
                        },
                        {
                            type: 'googlePay'
                        },
                        {
                            type: 'applePay'
                        }
                    ]
                });
                
                var prButton = vm.elements.create('paymentRequestButton', {
                    paymentRequest: paymentRequest
                });

                // Funzione per gestire il pagamento con Google Pay / Apple Pay
                paymentRequest.on('paymentmethod', function(event) {
                    vm.processing = true;
                    console.log('Payment method:', event);
                    var udateC = vm.getCustomerData();
                    $http.post(vm.env.API+'/payment-process', { 
                            token: event.paymentMethod.id, 
                            method: event.paymentMethod.type,
                            methodName: event.methodName,
                            type: vm.type, 
                            appId: vm.appointment.id, 
                            start: vm.appointment.date_start, 
                            created: vm.appointment.created_at,
                            customer: udateC })
                    .then(function(response) {
                        event.complete('success');
                        vm.processing = false;
                        console.log("on paymentmethod success", response);
                        $state.go('payment-success', { type: vm.type, appId: vm.appointment.id, start: vm.appointment.date_start, end: vm.appointment.date_end });
                    }, function(error) {
                        event.complete('fail');
                        vm.processing = false;
                        console.log("on paymentmethod error", error);
                        if(error.data.error) {
                            vm.error = 'Errore nel pagamento: ' + error.data.error;
                        } else {
                            vm.error = 'Errore nel pagamento: ' + error.data.message;
                        }
                    });
                });
                
                // Controlla se il browser supporta Google Pay o Apple Pay
                paymentRequest.canMakePayment().then(function(result) {
                    if (result) {
                        prButton.mount('#payment-request-button');
                    } else {
                        document.getElementById('payment-request-button').style.display = 'none';
                    }
                });
            }
        };

        vm.getCustomerData = function() {
            var udateC = {
                firstname: vm.customer.name,
                lastname: vm.customer.lastname,
                email: vm.customer.email,
                birthdate: vm.customer.birthdate,
                birthcity: vm.customer.birthcity,
                birthprovince: vm.customer.birthprovince,
                cf: vm.customer.cf,
                city: vm.customer.city,
                address: vm.customer.address,
                zip_code: vm.customer.zip_code,
                country: vm.customer.country,
                province: vm.customer.province,
                gender: vm.customer.gender
            };
            return udateC;
        };

        vm.createSetupIntent = function() {
            var cusData = vm.getCustomerData();
            
            return $http.post(vm.env.API + '/create-setup-intent', { appId: vm.appointment.id, start: vm.appointment.date_start, created: vm.appointment.created_at, customer: cusData }).then(
                function(response) {
                    console.log('Setup intent creato con successo:', response.data);
                    return response.data.data.client_secret;
                },
                function(error) {
                    console.error('Errore nella creazione del setup intent:', error);
                    vm.error = 'Errore nella preautorizzazione: ' + error.data.message;
                }   
            );
        };
    
        // Funzione per gestire il pagamento
        vm.processPayment = function() {
            console.log('processPayment', vm.card, vm.stripe, vm.type);
            vm.processing = true;

            if(vm.type=='preauth') {
                // **Caso di preautorizzazione con SetupIntent**
                vm.createSetupIntent().then(function(clientSecret) {
                    vm.stripe.confirmCardSetup(clientSecret, {
                        payment_method: {
                            card: vm.card,
                            billing_details: {
                                name: vm.cardholder // Aggiungiamo il nome qui
                            }
                        }
                    }
                ).then(function(result) {
                        if (result.error) {
                            vm.error = result.error.message;
                            vm.processing = false;
                            console.log('Errore nel pagamento:', result.error.message);
                            console.log("Errore nel pagamento vals: ",vm.customerForm,vm.alreadyPaid,vm.processing,vm.loading,vm.appointment);
                            $scope.$apply();
                        } else {
                            console.log('SetupIntent confermato:', result.setupIntent);
                            vm.error = '';

                            // Invia il setup_intent al backend
                            $http.post(vm.env.API + '/payment-process', { 
                                setup_intent: result.setupIntent.id,
                                method: 'card', 
                                type: vm.type, 
                                appId: vm.appointment.id, 
                                start: vm.appointment.date_start,
                                created: vm.appointment.created_at,
                                customer: vm.getCustomerData(),
                                card_holder_name: vm.cardholder
                            })
                            .then(function(response) {
                                console.log('processPayment (preauth)', response);
                                vm.processing = false;
                                $state.go('payment-success', { type: vm.type, appId: vm.appointment.id, start: vm.appointment.date_start, end: vm.appointment.date_end });
                            }, function(error) {
                                vm.processing = false;
                                console.error('processPayment (preauth)', error);
                                vm.error = 'Errore nella preautorizzazione: ' + error.data.error;
                            });
                        }
                    });
                });
            } else {
                vm.stripe.createToken(vm.card, {name: vm.cardholder}).then(function(result) {
                    if (result.error) {
                        vm.error = result.error.message;
                        vm.processing = false;
                    } else {
                        console.log('Token:', result.token);
                        vm.error = '';
                        // Invia il token al server
                        $http.post(vm.env.API+'/payment-process', { 
                            token: result.token.id, 
                            method: 'card', 
                            type: vm.type, 
                            appId: vm.appointment.id, 
                            start: vm.appointment.date_start,
                            created: vm.appointment.created_at,
                            customer: vm.getCustomerData(),
                            card_holder_name: vm.cardholder
                        })
                        .then(function(response) {
                            console.log('processPayment',response);
                            vm.processing = false;
                            $state.go('payment-success', { type: vm.type, appId: vm.appointment.id, start: vm.appointment.date_start, end: vm.appointment.date_end });
                        }, function(error) {
                            vm.processing = false;
                            console.error('processPayment',error);
                            vm.error = 'Errore nel pagamento: ' + error.data.error;
                        });
                    }
                });
            }
        };
    };

    function PaymentSuccessController(
            env,
            $log,
            $state,
            ngDialog,
            $scope,
            $rootScope,
            $http,
            type
            ) {
        var vm = this;
        vm.env = env;
        console.log('PaymentSuccessController', env);
        vm.type = type;
    };
})();

(function() {
    'use strict';

    angular
        .module('booking')

        .service(
            'SubscriptionService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( options, api ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = api + '/subscriptions';
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        )
        .service(
            'MyAvailabilityService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    availabilitiesCount : function( options, api ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = api + '/appointments-available-count';
                        return $http.get( apiURI, { params: options } );
                    },
                  availabilities: function( options, api ) {
                      if( ! options ) {
                          options = {};
                      }
                      var apiURI = api + '/appointments-available';
                      return $http.get( apiURI, { params: options } );
                  },
                };
            }
        )
        .service(
            'CustomerSubscriptionService',
            function(
                $log,
                env,
                $http
            ) {
                return {
                    all : function( options, api ) {
                        if( ! options ) {
                            options = {};
                        }
                        var apiURI = api + '/customer_subscriptions';
                        return $http.get( apiURI, { params: options } );
                    },
                };
            }
        )

        .filter( 'subscriptionIdtoName', function() {
            return function ( selected, array, quantity_remaining ) {
                if ( angular.isDefined( array ) && angular.isDefined( selected ) && array.length > 0 ) {
                    var value = "";
                    angular.forEach( array, function ( elemArray ) {
                        if ( angular.equals( elemArray.id, selected ) ) {
                            value = '<strong>' + elemArray.name + '</strong> (' + quantity_remaining + ' rimaste)';
                        }
                    });
                    return value;
                }
                return selected;
            };
        })

        .factory('TreatmentService', function(Restangular) {

            var service = {};

            service.categories = function(api){
                Restangular.setBaseUrl(api);
                return Restangular.all('treatments-categories').getList({
                  with: 'treatments'
                });
            };

            return service;
        })

        .factory('StoreService', function(Restangular) {

            var service = {};

            service.all = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('stores').getList(options);
            };

            return service;
        })

        .factory('AppointmentService', function(Restangular) {

            var service = {};

            service.availabilities = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('appointments-available').getList(options);
            };

            service.availabilitiesCount = function(options, api) {
                Restangular.setBaseUrl(api);
                return Restangular.all('appointments-available-count').getList(options);
            };

            service.save = function(data,api) {
                Restangular.setBaseUrl(api);
                delete data.customer;
                delete data.role;
                delete data.user;
                //console.log(data);
                return Restangular.all('appointments').post(data);
            };
            service.get = function(id, options, api) {
                Restangular.setBaseUrl(api);
                return Restangular.one('appointments', id).get(options);
            };

            service.getAnon = function(id, options, api) {
                Restangular.setBaseUrl(api);
                return Restangular.one('appointments_anon', id).get(options);
            };

            service.all = function(options,api) {
                Restangular.setBaseUrl(api);
                return Restangular.all('appointments').getList(options);
            };

            return service;
        })

        .factory( 'TokenService', function( $http, env ) {
            var service = {};

            service.delete = function() {
                var apiURI = env.API + '/invalidate'
                    , data = {
                        token: localStorage.getItem( 'Biolaser_token' ),
                    }
                ;
                return $http.post( apiURI, data );
            };

            return service;
        })

        .factory('UserService', function(Restangular, $http, env) {

            var service = {};

            service.all = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('users').getList(options);
            };

            /**
             * Carica l'utente dal token
             */
            service.logIn = function(token, c_role) {
                var apiURI = env.API + '/auth/user';
                return $http.get( apiURI, {'params': {'c_role': c_role}} );
            };

            return service;
        })

        .factory('CustomerService', function(Restangular, $filter) {

            var service = {};

            service.all = function(options, api){
                Restangular.setBaseUrl(api);
                return Restangular.all('customers/search_by_phone').getList(options);
            };

            service.save = function(data, api){
                Restangular.setBaseUrl(api);
                var new_data = angular.copy(data);
                new_data.birthdate = new_data.birthdate ? $filter('date')( new Date( new_data.birthdate ), 'yyyy-MM-dd' ) : null;

                return Restangular.all('customers').post(new_data);
            };

            return service;
        })

        .factory('LandingService', function(Restangular) {

            var service = Restangular.all('landings');

            service.all = function(options){
                return service.getList(options);
            };

            return service;
        });

})();

(function() {
    'use strict';

    angular
        .module('booking')
  

        // restituisce l'array dei radio con uno selezionato
        .filter( 'setActiveRadioButtonFilter', function() {
            return function(value, values) {
                angular.forEach(values, function(this_value) {
                    if(this_value.value == value){ 
                        this_value.active = true;
                    }
                    else {
                        this_value.active = false;
                    }                   
                });   
                return values;
            }
        })


        // restituisce l'array dei sessi in base al fatto che ci sia almeno un trattamento per ogni sesso
        .filter( 'setGendersFilter', function() {
            return function( treatments, genders ) {
                var gendersList = [];

                angular.forEach(genders, function(one_gender) {
                    angular.forEach(treatments, function(categories) {
                        angular.forEach(categories.treatments.data, function(one_treatment) {
                            if(one_gender.value == one_treatment.gender || one_treatment.gender == 'U'){
                                gendersList.push(one_gender);
                            }
                        });
                    });
                });

                return _.uniq(gendersList);
            }
        })


        // restituisce true se il tab ha almeno un elemento
        .filter( 'showTabFilter', function() {
            return function( tab, gender, treatments_landing ) {
                if(treatments_landing){
                    return _.filter(tab.treatments.data, function(o) { return o.gender==gender || o.gender=='U' && o.id==treatments_landing; }).length;
                }else{
                    return _.filter(tab.treatments.data, function(o) { return o.gender==gender || o.gender=='U'; }).length;
                }
            }
        })

        .filter( 'searchTreatment', function($filter,$log) {
            return function( treatments, currentCategory, selectedTreatment, search ) {
            	var treatmentsList = $filter('filter')(treatments, search);
            	//$log.info (selectedTreatment);
            	if (selectedTreatment==null || selectedTreatment.treatment_category_id != currentCategory ) {
            		//nulla
            	} else if (selectedTreatment.treatment_category_id == currentCategory) {
            		/*var found = false;
            		angular.forEach(treatmentsList, function(t) {
                        if(t.id == selectedTreatment.id) {
                        	found = true;
                        }
                    });
            		if (!found) {
            			treatmentsList.push(selectedTreatment);
            		}*/
            	}
            	return treatmentsList;
            }
        })

        
        // restituisce il trattamento dall id
        .filter( 'getTreatmentFilter', function() {
            return function( categories, id , without_activation) {
                var treatment = {id: id, name: "Trattamento eliminato [tid="+id+"]"};
                angular.forEach(categories, function(one_category) {
                    angular.forEach(one_category.treatments.data, function(one_treatment) {
                        if(one_treatment.id==id){
                        	treatment=one_treatment;
                        	if (!without_activation) {
                        		one_category.active = true;
                        	}
                        } else {
                        	if (!without_activation) {
                        		one_category.active = false;
                        	}
                        }
                    });
                });
                return treatment;

            }
        })

        // restituisce l'array di Trattamenti filtrati per sesso
        .filter( 'getGenderTreatmentsFilter', function() {
            return function( treatments, gender, treatments_landing ) {
                if(treatments_landing){
                    return _.orderBy(_.filter(treatments,  function(o) { 
                        return o.gender==gender || o.gender=='U' && o.id==treatments_landing; 
                    }), ['order']);
                }else{
                    return _.orderBy(_.filter(treatments,  function(o) { return o.gender==gender || o.gender=='U'; }), ['order']);
                }
            }
        })



        // restituisce l'oggetto trattamento dall'id
        /*.filter( 'getTreatmentFilter', function() {
            return function( id, treatments ) {
                var treatmentId;

                angular.forEach(treatments, function(categories) {
                    angular.forEach(categories.treatments.data, function(one_treatment) {
                        if(one_treatment.id == id){
                            treatmentId=one_treatment.id;
                        }
                    });
                });
                return treatmentId;
            }
        })*/

        // restituisce l'oggetto store dall'id
        .filter( 'getStoreFilter', function() {
            return function( id, stores ) {
                return _.find(stores, ['id', id]);
            }
        })


        // restituisce l'oggetto operator dall'id
        .filter( 'getOperatorFilter', function() {
            return function( id, users ) {
                return _.find(users, ['id', id]);
            }
        })


        // filtra tutti gli stores di una city data
        /*
        .filter( 'getCityStoresFilter', function() {
            return function( storesList , city ) {
                city = city.city;
                var cityStores = [];

                angular.forEach(storesList, function(store) {
                    if(store.city == city){
                        cityStores.push(store);
                    }
                });    

                return cityStores;
            }
        })
        */


        // restituisce le city in base agli stores forniti   es. ['Imola', 'Bologna'...]
        .filter( 'getCitiesFilter', function() {
            return function( storesList ) {
                var cities = [];
                var unique_cities = [];

                angular.forEach(storesList, function(store) {
                    cities.push(store.city);
                });    
                
                unique_cities = _.uniq(cities);
                return unique_cities;
            }
        })




        // restituisce solo l'ora da un datetime
        .filter( 'splitTimeFilter', function() {
            return function( datetime ) {
                var time ='';
                if (typeof datetime != "undefined") {
                    var partsOfStr = datetime.split(' ');
                    time = partsOfStr[1];
                }
                return time;
            }
        })
        // restituisce solo l'ora da un datetime
        .filter( 'dateTimeStringToLabel', function() {
            return function( datetime ) {
                var time = moment(datetime);
                return time.format('dddd, D MMMM');
            }
        })

        // spezza i prezzi con virgole
        .filter( 'labelRadioButtonFilter', function() {
            return function( label, type ) {
                var html='';

                if(type == 'euro' && label){
                    var partsOfStr = label.toString().split('.');
                    if(partsOfStr.length > 1){
                        html = '<span class="mini-txt mini-euro">€</span>'+partsOfStr[0]+'<span class="mini-txt">,'+partsOfStr[1]+'0<span>'; 
                    }else{
                        html = '<span class="mini-txt mini-euro">€</span>'+label.toString();
                    }
                }

                else if (type == 'long-txt') {
                    html = '<span class="two-lines-txt">'+label+'</span>';
                }

                else{
                   html=label; 
                }

                return html;
            }
        })


        // restituisce il primo momento della giornata disponibile es. "morning"
        .filter( 'setFirstMomentFilter', function() {
            return function( dayMoments ) {
                var day_moment ='';
                var first = false;

                angular.forEach(dayMoments, function(this_moment) {
                    if(!this_moment.disabled && !first){ 
                        day_moment = this_moment.value;
                        first = true;
                    }                   
                });   
                return day_moment;
            }
        })



        // restituisce il momento della giornata di una disponibilità es. "morning"
        .filter( 'getMomentFilter', function($filter) {
            return function( availability, dayMoments ) {
                var day_moment ='';
                var moment_start ='';
                var moment_end ='';
                var availability_start = moment($filter('splitTimeFilter')(availability.date_start), 'HH:mm');

                angular.forEach(dayMoments, function(this_moment) {
                    moment_start = moment(this_moment.start, 'HH:mm'); 
                    moment_end = moment(this_moment.end, 'HH:mm'); 

                    if(availability_start >= moment_start && availability_start < moment_end){ 
                        day_moment = this_moment.value;
                    }                   
                });   
                return day_moment;
            }
        })


        // restituisce l'array delle disponibilità filtrato in base a che momento della giornata è stato passato (massimo 3 per momento ordinati per rilevanza e poi per ora)
        .filter( 'distributeAvailabilitiesInMomentsFilter', function($filter) {
            return function( availabilitiesList, dayMomentVal, dayMoments, customer ) {
                var filtered_list = [];
                var availability_moment ='';
                //var max_availabilities_per_moment = 3;
                //var count_availabilities_per_moment = 0;
                //ordino l'array per rilevanza al contrario (può anche non servire se l'array mi arriva già ordinato)
                //availabilitiesList = _.sortBy(availabilitiesList, function(o) { return o.relevance; }).reverse();
                //availabilitiesList = _.orderBy(availabilitiesList, function(o) { return o.relevance; },'desc');
                var dayMoment = $filter('filter')(dayMoments, {value: dayMomentVal}, true)[0];
                //controlla la disponibilità è nel momento ora attivo
                var last_min = -1;
                var last_c_comm = -1;
                angular.forEach(availabilitiesList, function(one_availability) {
                  var to_add = customer==null || customer.user_times>0; // se customer non settato o user_times>0 faccio vedere tutti
                  if (!to_add && (last_min!=one_availability.minute || one_availability.role.data.c_capability.comm>=last_c_comm)) {
                    to_add = true;
                    last_min = one_availability.minute;
                    last_c_comm = one_availability.role.data.c_capability.comm;
                  }
                  if (to_add) {
                    if (dayMomentVal==null || dayMomentVal=='') {
                  		filtered_list.push(one_availability);
                  	} else {
                  	    //availability_moment = $filter('getMomentFilter')(one_availability,dayMoments);
  	                    //aggiunge all'array a disponibilità
  	                    if(dayMoment.minute_start<=one_availability.minute && dayMoment.minute_end>one_availability.minute){ 
  	                        filtered_list.push(one_availability);
  	                    }
                  	}
                  }
                });  

                //ordino l'array per ora
                //filtered_list = _.orderBy(filtered_list, function(o) { return moment($filter('splitTimeFilter')(o.date_start), 'HH:mm') },'asc');

                return filtered_list;
            }
        })

        // restituisce i momenti della giornata con i relativi prezzi    
        .filter( 'setDayMomentsFilter', function($filter) {
            return function( availabilitiesList, dayMoments ) {
                // console.log('DENTRO');
                var availability_moment ='';
                var no_availability = true;
                var dayMomentsChanged = [];
                angular.copy(dayMoments,dayMomentsChanged);

                // dayMoments = [
                // { value:'morning', label: '', description:'Mattina', icon: '', active: false, disabled:false, start: '09:00:00', end: '12:00:00', type:'euro' },
                // { value:'lunch', label: '', description:'Pausa Pranzo', icon: '', active: false, disabled:false, start: '12:00:00', end: '14:30:00', type:'euro' },
                // { value:'afternoon', label: '', description:'Pomeriggio', icon: '', active: false, disabled:false, start: '14:30:00', end: '17:00:00', type:'euro' },
                // { value:'evening', label: '', description:'Sera', icon: '', active: false, disabled:false, start: '17:00:00', end: '20:00:00', type:'euro' }                     
                // ];


                //ciclo ogni momento della giornata
                angular.forEach(dayMomentsChanged, function(one_moment) {

                    //controllo ogni disponibilitò ed alla prima di quel momento, setto il prezzo del momento 
                    angular.forEach(availabilitiesList, function(one_availability) {
                        if(no_availability) {
                            availability_moment = $filter('getMomentFilter')(one_availability,dayMoments);

                            if(availability_moment ==  one_moment.value){
                                one_moment.label = one_availability.price;
                                no_availability = false;
                            }
                        }
                    });
                
                    //se per questo momento non ho trovato nessuna disponibilità, lo disabilito e resetto la variabile no_availability per il momento successivo
                    if(no_availability){
                        //console.log(one_moment);
                        one_moment.disabled = true;  
                        one_moment.label = 'posti esauriti';  
                        one_moment.type = 'long-txt';  
                    }

                    no_availability = true;

                });    
                
                return dayMomentsChanged;
            }
        })



})();

 
(function () {
    "use strict";

    angular
        .module("booking")
        .controller("BookingController", BookingController)
        .controller("BookingNotAuthorizedController",BookingNotAuthorizedController)
        .controller("BookingCompletedController", BookingCompletedController)
        .controller('BookingPaymentErrorController', BookingPaymentErrorController)
        .controller('BookingPaymentCancelController', BookingPaymentErrorController)
        .controller('BookingPaymentSuccessController', BookingPaymentSuccessController)
        ;

    /** @ngInject */
    function BookingController(
        env,
        $log,
        $location,
        $state,
        $auth,
        $filter,
        $http,
        ngDialog,
        Lightbox,
        $window,
        $document,
        $scope,
        $rootScope,
        callCenter,
        landing,
        customerId,
        leadId,
        tag,
        campagna,
        cusActId,
        storeId,
        treatmentId,
        appointmentId,
        appointmentDate,
        tenant,
        debug,
        kpiCheck,
        isUser,
        userRole,
        userSid,
        TreatmentService,
        StoreService,
        AppointmentService,
        UserService,
        TokenService,
        CustomerService,
        token,
        SubscriptionService,
        CustomerSubscriptionService,
        MyAvailabilityService,
        birthtime,
        source,
        couponCode,
        appCustomerId,
        utmSource,
        utmMedium,
        utmCampaign,
        utmGender,
        utmRegion,
        utmTreatment,
        utmAid,
        utmCreative,
        utmChannel,
        utmPricing,
        wkFlow,
        wkStateFrom,
        wkStateTo,
        wkEntityId
    ) {
        var vm = this;
        vm.scope = $scope;
        vm.customerForm = {};
        //$log.info('cf',$scope.customerForm);
        // moment.locale('it');
        vm.env = env;
        vm.debug = debug;
        (vm.wkFlow = wkFlow), (vm.wkStateFrom = wkStateFrom);
        vm.wkStateTo = wkStateTo;
        vm.wkEntityId = wkEntityId;
        $log.info("BookingController kpiCheck=" + kpiCheck);
        vm.kpiCheck =
            kpiCheck == null ? true : kpiCheck != "false" && kpiCheck != "0";
        $log.info("BookingController kpiCheck=" + vm.kpiCheck);
        vm.birthtime = null;
        vm.birthdate = null;
        vm.typeApp = 'TRAT_PREZZO_PIENO';
        vm.nearestBirthdate = function () {
            if (vm.birthdate.month() - moment().month() >= 10) {
                //accade solo 12 . 1 e 12 . 2 o 11 1
                return moment(vm.birthdate).year(moment().year() - 1);
            } else {
                return moment(vm.birthdate).year(moment().year());
            }
        };
        if (birthtime) {
            vm.birthtime = birthtime;
            vm.birthdate = moment(birthtime * 1000);

            /*$log.info("promo scaduta: "
                + ( moment().subtract(2,'month')
                    .isAfter( moment(vm.birthdate).year( moment().year() ) )
                  )
                );*/
            if (moment().subtract(1, "months").isAfter(vm.nearestBirthdate())) {
                $state.go("booking-promo-expired");
            }
            //vm.typeApp = "free";
            //console.log("compleanno: "+ vm.birthdate.format('YYYY-MM-DD'));
        }
        vm.initialized = false;
        vm.tenantDataLoaded = false;
        vm.tenantFixed = false;
        if (vm.env.apis) {
            document.title = "Booking Italia";
            if (tenant && vm.env.apis[tenant]) {
                vm.tenant = tenant;
                vm.tenantFixed = true;
                vm.currentAPI = vm.env.apis[tenant];
                vm.currentAPILead = vm.env.apis[tenant];
            } else {
                vm.currentAPI = vm.env.API;
                vm.currentAPILead = vm.env.API;
            }
        } else {
            document.title = "Booking " + vm.env.tenant;
            vm.tenantFixed = true;
            vm.tenant = vm.env.tenant;
            vm.currentAPI = vm.env.API;
            vm.currentAPILead = vm.env.API;
        }
        vm.version = "3.2";
        vm.userRole = userRole;
        vm.source = source;
        vm.couponCode = couponCode;
        vm.appCustomerId = appCustomerId;
        vm.treatmentIdParam = treatmentId;
        vm.storeIdParam = storeId;
        vm.utms = {
            utmCampaign: "utm_campaign",
            utmMedium: "utm_medium",
            utmSource: "utm_source",
            utmAid: "utm_aid",
            utmGender: "utm_gender",
            utmChannel: "utm_channel",
            utmRegion: "utm_region",
            utmCreative: "utm_creative",
            utmPricing: "utm_pricing",
            utmTreatment: "utm_treatment",
        };
        vm.utmsValues = {
            utmCampaign: utmCampaign,
            utmMedium: utmMedium,
            utmSource: utmSource,
            utmAid: utmAid,
            utmGender: utmGender,
            utmChannel: utmChannel,
            utmRegion: utmRegion,
            utmCreative: utmCreative,
            utmPricing: utmPricing,
            utmTreatment: utmTreatment,
        };
        // $log.info('BookingController cusActId=' + cusActId);
        // $log.info('BookingController userRole=' + userRole);
        /**
         * Utente loggato
         */
        vm.user = null;
        vm.canSeeDuration = vm.userRole === 'admin' || vm.userRole === 'callcenter';
        vm.canForceFOper = false;
        vm.forceFOper = false;
        /**
         * Operatore e assistente per il trattamento
         */
        vm.operator = { id: null };
        vm.assist = { id: null };
        vm.commercial = { id: null };

        vm.customer_subscription_id = null;

        // Controllo per reindirizzare al nuovo booking
        vm.checkNewBooking = function(apiURI, options) {
            var request = new XMLHttpRequest();
            request.open("GET", apiURI + '?' + new URLSearchParams(options).toString(), false); // `false` makes the request synchronous
            request.send(null);

            if (request.status === 200 && request.response) {
                // $log.info("2 checkNewBooking result", request.responseText);
                var responseJson = JSON.parse(request.response);
                return (responseJson.enabled) ? true : false;
            }
            return false;
        };

        // $log.info(">>>> tenant", tenant);
        // $log.info(">>>> userRole", userRole);
        // $log.info(">>>> storeId", storeId);

        if (tenant && userRole && storeId >= 0) {
            // $log.info(">>>> env", vm.env);
            // $log.info("$location.search()", $location.search());

            vm.loadingNewBooking = true;

            // $log.info("1 checkNewBooking");

            var resultUseNewBooking = vm.checkNewBooking(
                vm.env.API + "/config/new-booking/can-use",
                {
                    tenant: tenant,
                    c_role: userRole,
                    store: storeId,
                }
            );

            // $log.info("3 checkNewBooking resultUseNewBooking", resultUseNewBooking);

            if (resultUseNewBooking) {
                var urlParams = new URLSearchParams($location.search());

                $window.location.replace(
                    vm.env.newBooking +
                        "/operatore?" +
                        urlParams.toString()
                );
                // $log.info("4 redirect NEW BOOKING")
            } else vm.loadingNewBooking = false;
            // $log.info("5 completato checkNewBooking")
        }

        // DEFAULT
        vm.reservedEnabled = !vm.env.show || vm.env.show.filter_reserved;
        vm.newCustomer = function (phone) {
            return {
                firstname: null,
                lastname: null,
                phone: phone,
                birthdate: null,
                email: null,
                gender: null,
                referral_code: null,
                overwritten_by_lead: 0,
                change_state_counter: 0,
                credit: 0,
                user_times: 0,
                app_times: 0,
                f_guarantee: 0,
                f_oper: 0
            };
        };
        vm.customer = vm.newCustomer(null);

        vm.customerId = customerId;
        vm.treatmentId = treatmentId != null ? treatmentId : null;
        vm.treatmentPrice = null;
        vm.storeId = storeId;
        vm.leadId = leadId;
        vm.lead = null;
        if (leadId) {
            vm.tag = tag && tag != "null" ? tag : null;
            vm.campagna = campagna && campagna != "null" ? campagna : null;
            if (vm.env.apis && tenant && "Italia" != tenant) {
                vm.currentAPILead = vm.env.apis[tenant]; // per spostamento
                // desiderata
                vm.currentLeadTenant = tenant;
            } else {
                vm.currentAPILead = vm.env.API; // per spostamento lead
                // all'area desiderata
                vm.currentLeadTenant = vm.env.apis ? "Italia" : vm.env.tenant;
            }
        }
        vm.cusActId = cusActId;
        vm.appointmentId = appointmentId;
        vm.cantChangeCustomer =
            vm.appointmentId != null || vm.leadId != null || customerId != null;
        vm.appointmentDate = appointmentDate;
        if (vm.appointmentId != null) {
            $log.info("load app isUser: " + vm.isUser);
            if (vm.isUser) {
                AppointmentService.get(
                    appointmentId,
                    { with: "treatment;lead;deposit" },
                    vm.currentAPI
                ).then(function (data) {
                    vm.appointment = data;
                    vm.treatmentOrig = vm.appointment.treatment.data;

                    if (vm.appointment.lead) {
                        vm.lead = vm.appointment.lead.data;
                    }

                    if (vm.appointment.f_oper !== null) {
                        vm.f_oper = vm.appointment.f_oper ? 1 : 0;
                    } else if (vm.treatmentOrig.f_oper !== null) {
                        vm.f_oper = vm.treatmentOrig.f_oper ? 1 : 0;
                    }
                    vm.f_oper_descr = vm.getFlowTypeDescription();

                    console.log('appointmentId', {
                        'appointment': vm.appointment,
                        'treatmentOrig': vm.treatmentOrig,
                        'lead': vm.lead,
                        'f_oper': vm.f_oper,
                        'user_times': vm.user_times,
                        'flow_type': vm.getFlowType(),
                        'description': vm.getFlowTypeDescription()
                    });

                    if (vm.appointment.deposit && vm.appointment.deposit.data) {
                        vm.customer_subscription_id = "";
                        if (vm.appointment.f_prepayment) {
                            vm.f_prepayment = true;
                        } else if (vm.appointment.f_deposit) {
                            vm.f_deposit = true;
                        } else {
                            vm.f_preauth = true;
                        }
                    }

                    vm.refreshRolesList();
                    vm.note = vm.appointment.note;
                });
            } else {
                AppointmentService.getAnon(
                    appointmentId,
                    {
                        date_start: vm.appointmentDate,
                        phone: vm.customerId,
                        with: "treatment;lead;deposit",
                    },
                    vm.currentAPI
                ).then(
                    function (data) {
                        vm.appointment = data;
                        vm.treatmentOrig = vm.appointment.treatment.data;

                        if (vm.appointment.lead) {
                            vm.lead = vm.appointment.lead.data;
                        }

                        if (vm.appointment.f_oper !== null) {
                            vm.f_oper = vm.appointment.f_oper ? 1 : 0;
                        } else if (vm.treatmentOrig.f_oper !== null) {
                            vm.f_oper = vm.treatmentOrig.f_oper ? 1 : 0;
                        }
                        vm.f_oper_descr = vm.getFlowTypeDescription();

                        vm.customer_subscription_id = vm.appointment.customer_subscription_id?vm.appointment.customer_subscription_id:"";

                        if (vm.appointment.deposit && vm.appointment.deposit.data) {
                            vm.customer_subscription_id = "";
                            if (vm.appointment.f_prepayment) {
                                vm.f_prepayment = true;
                            } else if (vm.appointment.f_deposit) {
                                vm.f_deposit = true;
                            } else {
                                vm.f_preauth = true;
                            }
                        }

                        console.log('appointmentIdAnon', {
                            'appointment': vm.appointment,
                            'treatmentOrig': vm.treatmentOrig,
                            'lead': vm.lead,
                            'f_oper': vm.f_oper,
                            'user_times': vm.user_times,
                            'flow_type': vm.getFlowType(),
                            'description': vm.getFlowTypeDescription()
                        });

                        vm.refreshRolesList();
                        vm.note = vm.appointment.note;
                    },
                    function (data) {
                        $log.error(data);
                        if (data.status == 401) {
                            $state.go("booking-notauthorized");
                        }
                    }
                );
            }
        }
        /**
         * Id utente loggato
         */
        vm.operatorId = null;
        vm.isUser = vm.env.apis || isUser || env.anonymous_access === false;
        vm.isCallCenter = callCenter;
        $log.info("isCallCenter: " + callCenter);
        /*
         * Viene inializzato su logon
         */
        vm.priceFromSubscription = false;
        vm.note = "";
        vm.token = token;
        // Landing page
        if (landing) {
            vm.landing = landing;

            if (vm.landing.treatment_id) {
                vm.treatmentId = landing.treatment_id;
            }
            if (vm.landing.price) {
                vm.treatmentPrice = landing.price;
            }
        }
        // steps
        $scope.$watch(
            "booking.isClient",
            function (newValue) {
                if (false && !newValue) {
                    vm.isClientStep = 1;
                    vm.treatmentsStep = 2;
                    vm.storesStep = 3;
                    vm.dateTimeStep = 4;
                    vm.customerDataStep = 5;
                    vm.totalStep = 5;
                } else if (vm.isUser) {
                    vm.isClientStep = 1;
                    vm.treatmentsStep = 4;
                    vm.storesStep = 3;
                    vm.dateTimeStep = 5;
                    vm.customerDataStep = 2;
                    vm.totalStep = 5;
                } else if (vm.birthdate) {
                    vm.storesStep = 2;
                    vm.dateTimeStep = 3;
                    vm.customerDataStep = 1;
                    vm.totalStep = 3;
                } else {
                    vm.treatmentsStep = 4;
                    vm.storesStep = 3;
                    vm.dateTimeStep = 5;
                    vm.isClientStep = 1;
                    vm.customerDataStep = 2;
                    vm.totalStep = 5;
                }
            },
            true
        );

        // ---------- tenantsList ----------------------------------//
        vm.tenantsList = [];
        if (vm.env.apis) {
            angular.forEach(vm.env.apis, function (value, key) {
                vm.tenantsList.push({
                    value: key,
                    label: key.substring(0, 2).toUpperCase(),
                    description: "",
                    icon: "",
                    active: false,
                    disabled: false,
                });
            });
        }

        // ---------- isClient -------------------------------------//
        vm.isClient = false;
        vm.isClientTitle = "Sei già cliente <span>" + env.company + "</span> ?";
        vm.isClientList = [
            {
                value: true,
                label: "SI",
                description: "",
                icon: "",
                active: false,
                disabled: false,
            },
            {
                value: false,
                label: "NO",
                description: "",
                icon: "",
                active: false,
                disabled: false,
            },
        ];
        // vm.isClientList =
        // $filter('setActiveRadioButtonFilter')(vm.isClient,vm.isClientList);

        vm.setUserAlias = function (elem, user) {
            elem.user_alias = "";
            elem.user_alias = (
                (user.firstname != null ? user.firstname : "") + "   "
            )
                .substring(0, 3)
                .trim();
            elem.user_alias += ".";
            elem.user_alias += (
                (user.lastname != null ? user.lastname : "") + "   "
            )
                .substring(0, 3)
                .trim();
        };

        // ---------- treatments -------------------------------------//
        // treatments
        vm.treatmentsTitle = "Scegli il <span>servizio</span>";
        if (vm.landing) {
            vm.treatmentsTitle = "Dettagli del <span>servizio</span>";
            // genders
            // if (!vm.landing.treatment_id) {
            //     vm.gender = "F";
            // }
        }

        vm.gendersList = [
            { value: "F", text: "", description: "Donna", icon: "icon-woman" },
            { value: "M", text: "", description: "Uomo", icon: "icon-man" },
            /*,
                Unisex si vedono sempre
                { value:"U", text:'', description:'Unisex', icon: 'icon-people' },
                */
        ];

        vm.gender = null;
        vm.gendersList = $filter('setActiveRadioButtonFilter')(vm.gender, vm.gendersList);

        vm.typeAppList = [
            // {
            //     value: "",
            //     text: "",
            //     description: "Prezzo pieno",
            //     icon: "icon-attach_money",
            //     active: 1,
            // },
            // {
            //     value: "promo",
            //     text: "",
            //     description: "Promo",
            //     icon: "icon-input",
            // },
            // {
            //     value: "free",
            //     text: "",
            //     description: "Omaggio",
            //     icon: "icon-money_off",
            // },
        ];

        vm.subscriptionsList = [];
        // if (appointmentId == null) {
        SubscriptionService.all(
            { /* search: 1, searchFields: "active:=" */ },
            vm.currentAPI
        ).then(function (response) {
            vm.subscriptionsList = response.data.data;
        });
        // }

        vm.sourcesList = null;
        if (vm.isUser && userRole != "operator" && userRole != "storemngr" && userRole != "manager") {
            var apiURI = env.API + "/customer-sources"; // uso API tanto va
            // su com
            $http.get(apiURI).then(function (response) {
                // $log.info(response);
                vm.sourcesList = response.data.data;
                // $log.info(vm.sourcesList);
            });
        }

        vm.config = {
            data: {},
            get: function (key, defaultValue) {
                return this.data[key] ? this.data[key] : defaultValue;
            },
        };
        var apiURI = env.API + "/config/booking"; // uso API tanto va su
        // com
        $http.get(apiURI).then(function (response) {
            vm.config.data = response.data;
            //console.log("config", vm.config.data);
        });

        // setta il sesso del cliente al cambio di genere
        $scope.$watch(
            "booking.gender",
            function () {
                vm.customer.gender = vm.gender;
            },
            true
        );

        /**
         * Filtro trattamenti TODO
         */
        /*
         * vm.treatmentFilter = undefined; vm.treatmentFilterOptionsList = [ {
         * value:undefined, label: '', description:'Tutti', icon: '',
         * active: true, disabled:false, start: '', end: '', type:'' }, ];
         * vm.isRullo = cusActId!=null; if (vm.isRullo) {
         * vm.treatmentFilterOptionsList.push({ value: 'PROMO', label: '',
         * description:'Promo', icon: '', active: false, disabled:false,
         * start: '', end: '', type:'' }); } else {
         * vm.treatmentFilterOptionsList.push({ value: 'GP', label: '',
         * description:'Groupon', icon: '', active: false, disabled:false,
         * start: '', end: '', type:'' }); } vm.allTreatmentsList = [];
         * vm.treatmentFilterSelected = function() { if (vm.treatmentFiter ==
         * undefined) { vm.treatmentsList = vm.allTreatmentsList; } else if
         * (vm.treatmentFiter=='GP') { angular.forEach(vm.allTreatmentsList,
         * function(tc) { var tmp = []; angular.forEach(tc.treatments.data,
         * function(t) { if (t.name.endsWith(" GP")) { tmp.push(t); } });
         * tc.treatments.data = tmp; }); } };
         */
        vm.back = function () {
            if (vm.isUser) {
                if (vm.leadId != null) {
                    window.location =
                        env.admin +
                        "/lead" +
                        (vm.env.tenant == "Italia" ? "" : "s");
                } else if (vm.cusActId != null) {
                    window.location = env.admin + "/cusacts";
                } else {
                    window.history.back();
                }
            }
        };

        /**
         * Gestione funzioni multiarea
         */
        vm.confirmTenant = function () {
            vm.loading = true;
            // TODO reset caricamento dati app
            $log.info(
                "confirmTenant: " +
                    vm.tenant +
                    " -> " +
                    vm.currentAPI +
                    " -> " +
                    vm.currentAPILead
            );
            if (vm.leadId && vm.env.apis && vm.currentLeadTenant != vm.tenant) {
                vm.tenantMsg =
                    "Spostamento lead da " +
                    vm.currentLeadTenant +
                    " a " +
                    vm.tenant +
                    "...";
                // invio lead al tenant poi carico dati cliente
                var updObj = {
                    id: vm.leadId,
                    move_to: vm.tenant,
                    c_role: vm.user.type,
                    c_sid: vm.user.store_id,
                };
                $http
                    .put(vm.currentAPILead + "/leads/" + updObj.id, updObj)
                    .then(
                        function (response) {
                            // $log.info(response);
                            vm.currentLeadTenant =
                                response.data.data.response.tenant;
                            if (vm.tenant != vm.currentLeadTenant) {
                                vm.tenantMsg =
                                    "Trovato lead in " +
                                    vm.currentLeadTenant +
                                    ", spostamento lead da " +
                                    vm.currentLeadTenant +
                                    " a " +
                                    vm.tenant;
                                vm.currentAPILead =
                                    vm.env.apis[vm.currentLeadTenant];
                                vm.leadId = response.data.data.response.lead_id;
                                updObj.id = vm.leadId;
                                $http
                                    .put(
                                        vm.currentAPILead +
                                            "/leads/" +
                                            updObj.id,
                                        updObj
                                    )
                                    .then(
                                        function (response) {
                                            vm.currentAPI =
                                                vm.env.apis[vm.tenant];
                                            vm.currentAPILead =
                                                vm.env.apis[vm.tenant];
                                            vm.leadId =
                                                response.data.data.response.lead_id;
                                            vm.currentLeadTenant =
                                                response.data.data.response.tenant;
                                            $log.info(
                                                "confirmTenant [newLeadId]: " +
                                                    vm.leadId
                                            );
                                            vm.tenantMsg =
                                                "Lead spostato su " +
                                                vm.tenant +
                                                " lead id = " +
                                                vm.leadId;
                                            vm.customer.phone = vm.customerId;
                                            vm.checkCustomer();
                                            vm.loadStores();
                                        },
                                        function (response) {
                                            $log.error(response);
                                            vm.tenantMsg =
                                                response.data.message;
                                        }
                                    );
                            } else {
                                vm.currentAPI = vm.env.apis[vm.tenant];
                                vm.currentAPILead = vm.env.apis[vm.tenant];
                                vm.leadId = response.data.data.response.lead_id;
                                vm.tenantMsg =
                                    "Lead spostato su " +
                                    vm.tenant +
                                    " lead id = " +
                                    vm.leadId;
                                $log.info(
                                    "confirmTenant [newLeadId]: " + vm.leadId
                                );
                                vm.customer.phone = vm.customerId;
                                vm.checkCustomer();
                                vm.loadStores();
                            }
                        },
                        function (response) {
                            $log.error(response);
                            vm.tenantMsg = response.data.message;
                        }
                    );
            } else {
                if (vm.env.apis) {
                    vm.currentAPI = vm.env.apis[vm.tenant];
                    vm.currentAPILead = vm.env.apis[vm.tenant];
                } else {
                    vm.currentAPI = vm.env.API;
                    vm.currentAPILead = vm.env.API;
                }
                if (vm.customer && vm.customer.id) {
                    vm.checkCustomer();
                } else if (vm.customerId) {
                    vm.customer.phone = vm.customerId;
                    vm.checkCustomer();
                }
                vm.loadStores();
            }
        };
        vm.changeTenant = function () {
            vm.tenantMsg = "";
            vm.tenantDataLoaded = false;
            vm.treatmentsList = [];
            vm.storesList = [];
            vm.rolesList = [];
            vm.rolesListBackup = [];
            vm.monthAvailability.reset();
            vm.customer = vm.newCustomer(null);
            delete vm.store;
        };

        vm.checkTypeApp = function () {
            if (vm.isPromo) {
                vm.typeApp = 'TRAT_PROMO_WEB';
            } else if (!vm.customer_subscription_id) {
                vm.typeApp = 'TRAT_PREZZO_PIENO';
            } else {
                vm.typeApp = null;
            }
        };
        vm.getFlowType = function () {
            console.log('vm.getFlowType', {
                'f_oper': vm.f_oper,
                'lead': vm.lead,
                'user_times': vm.user_times,
                'appointment': vm.appointment,
                'forceFOper': vm.forceFOper,
            });
            if (vm.forceFOper) {
                return 9; //operativo forzato
            }
            if (vm.appointment && vm.appointment.flow_type) {
                return vm.appointment.flow_type;
            }
            if (!vm.f_oper) {
                if ((vm.lead && vm.lead.category.indexOf('non_fidelizzato_') === 0) || (campagna && campagna.toLowerCase().indexOf('non fidelizzato ') === 0)) { //HEADS UP: lasciare lo spazio dopo non fidelizzato
                    return 8; //non fidelizzato area
                }
                if ((vm.lead && vm.lead.category === 'porta') || campagna === 'Porta') {
                    if (vm.user_times >= 1) {
                        return 3; //porta rientro
                    }
                    return 2; //porta prima volta
                }
                if (vm.lead) {
                    if (vm.user_times >= 1) {
                        return 7; //commerciale rientro
                    }
                    return 6; //commerciale prima volta
                }
                if (vm.user_times >= 1) {
                    return 5; //contact center rientro
                }
                return 4; //contact center prima volta
            }
            return 1; //operativo
        };
        vm.getFlowTypeDescription = function () {
            switch (vm.getFlowType()) {
                case 2:
                    return 'Porta 1° volta';
                case 3:
                    return 'Porta rientro';
                case 4:
                    return 'Contact Center 1° volta';
                case 5:
                    return 'Contact Center rientro';
                case 6:
                    return 'Commerciale 1° volta';
                case 7:
                    return 'Commerciale rientro';
                case 8:
                    return 'Non fidelizzato area';
                case 9:
                    return 'Operativo forzato';
            }
            return 'Operativo';
        };
        vm.getFlowTypeCapability = function () {
            switch (vm.getFlowType()) {
                case 2:
                    return 'f_first_time_porta';
                case 3:
                    return 'f_return_porta';
                case 4:
                    return 'f_first_time_porta';
                case 5:
                    return 'f_return_porta';
                case 6:
                    return 'f_first_time';
                case 7:
                    return 'f_return';
                case 8:
                    return 'f_non_fidelizzato';
            }
            return null;
        };
        vm.getTreatmentTypesFromFlow = function () {
            switch (vm.getFlowType()) {
                case 2:
                    return [0, 2];
                case 3:
                    return [0, 2];
                case 4:
                    return [0, 2];
                case 5:
                    return [0, 2];
                case 6:
                    return [0, 2];
                case 7:
                    return [0, 2];
                case 8:
                    return [0, 2];
            }
            return [1];
        };
        vm.refreshRolesList = function () {
            var requiredCapability = vm.getFlowTypeCapability();
            vm.rolesList = $filter('filter')(vm.rolesListBackup, function(item) {
                if (vm.appointmentTypeCheck && requiredCapability && !item[requiredCapability]) {
                    return false;
                }
                return item;
            });
        };
        /**
         * Carico trattamenti e filtro solo pubblici o escludoPromo oppure
         * tutte se sono da rullo
         */
        vm.treatmentsList = [];
        //vm.treatmentsListPlain = [];
        vm.treatmentsListAll = {};
        vm.search_treatmnent = null;
        vm.loadingTreatments = false;
        vm.treatmentsLoaded = false;
        vm.loadTreatments = function () {
            vm.loadingTreatments = true;
            vm.treatmentsList = [];
            vm.treatmentsListOrigin = []; //dopo i vari filtri e prima di filtro operatore
            //vm.treatmentsListPlain = [];
            vm.treatmentsListAll = [];
            vm.tenantMsg = "Caricamento trattamenti " + vm.tenant + " ...";
            TreatmentService.categories(vm.currentAPI).then(
                function (data) {
                    vm.treatmentsList = [];
                    //vm.treatmentsListPlain = [];
                    /*
                     * angular.forEach(data, function(tc) { var tcc = [];
                     * angular.forEach(tc, function(trt) { var tmp = {};
                     * angular.copy(trt,tmp); tcc.push(tmp); });
                     * vm.treatmentsListAll.push(tcc); });
                     */
                    angular.copy(data, vm.treatmentsListAll);

                    if (
                        vm.customer.appointments &&
                        vm.customer.appointments.data
                    ) {
                        angular.forEach(
                            vm.customer.appointments.data,
                            function (app) {
                                var trt = $filter("getTreatmentFilter")(
                                    vm.treatmentsListAll,
                                    app.treatment_id,
                                    true
                                );
                                if (trt == null) {
                                    trt = {
                                        id: app.treatment_id,
                                        name:
                                            "Trattamento non trovato [tid=" +
                                            app.treatment_id +
                                            "]",
                                    };
                                }
                                app.treatment = { data: trt };
                                angular.forEach(
                                    vm.storesList,
                                    function (store) {
                                        if (app.store_id == store.id) {
                                            app.store = { data: store };
                                        }
                                    }
                                );
                            }
                        );
                    }

                    vm.singleCategory = env.company === 'Biosmed' ? 'Elenco' : false;
                    if (vm.singleCategory) {
                        var datasingle = {
                            'id': 0,
                            'name': vm.singleCategory,
                            'order': 1,
                            'description': '',
                            'treatments': {
                                'data': []
                            }
                        };
                        angular.forEach(data, function (tc) {
                            angular.forEach(tc.treatments.data, function (t) {
                                t.treatment_category_id = 0;
                                datasingle['treatments']['data'].push(t);
                            });
                        });
                        data = [];
                        data.push(datasingle);
                    }

                    vm.tenantMsg =
                        "Caricamento trattamenti " + vm.tenant + " ... fatto!";

                    vm.treatmentsListOrigin = vm.filterByOperatorCapability(
                        data,
                        null,
                        false
                    );
                    vm.treatmentsList = vm.filterByOperatorCapability(
                        vm.treatmentsListOrigin,
                        vm.operator && vm.operator.role ? vm.operator.role.capabilities : null,
                        true
                    );
                    console.log('vm.treatmentsList b', vm.treatmentsListOrigin, vm.treatmentsList, vm.operator);

                    //vm.treatmentsListPlain = tmpPlain;
                    // vm.allTreatmentsList = data;
                    if (vm.landing) {
                        if (!vm.landing.treatment_id) {
                            vm.gendersList = $filter("setGendersFilter")(
                                vm.treatmentsList,
                                vm.gendersList
                            );
                            vm.gendersList = $filter(
                                "setActiveRadioButtonFilter"
                            )(vm.gender, vm.gendersList);
                        }
                    }
                    vm.treatment = $filter('getTreatmentFilter')(vm.treatmentsList,vm.treatmentId);
                    if (vm.treatment) {
                        vm.active_treatment_category_id = vm.treatment.treatment_category_id;
                        vm.initOperatorAssistByUserAssist();
                    }
                    vm.priceOverride = vm.getTreatmentPrice();
                    if (vm.active_treatment_category_id!=vm.treatment.treatment_category_id) {
                        vm.active_treatment_category_id = vm.treatment.treatment_category_id;
                    }
                    vm.buildCapabilities();
                    vm.loadingTreatments = false;
                    vm.treatmentsLoaded = true;
                    vm.buildCustomerAppointments();
                    if (vm.landing) {
                        if (!vm.user) {
                            vm.monthAvailability.load();
                        } else {
                            $log.info("landing ma cè user");
                        }
                    }
                },
                function (response) {
                    $log.error(response);
                    vm.tenantMsg = response.data.message;
                    vm.loading = false;
                }
            );
        };


        vm.prepaymentSelected = function () {
            vm.f_deposit = false;
            vm.f_preauth = false;
            vm.customer_subscription_id = "";
            console.log("prepaymentSelected");
            vm.treatmentsList = vm.filterByOperatorCapability(
                vm.treatmentsListOrigin,
                vm.operator && vm.operator.role ? vm.operator.role.capabilities : null,
                true
            );
        };

        vm.depositSelected = function () {
            vm.f_prepayment = false;
            vm.f_preauth = false;
            vm.customer_subscription_id = "";
            console.log("depositSelected");
            vm.treatmentsList = vm.filterByOperatorCapability(
                vm.treatmentsListOrigin,
                vm.operator && vm.operator.role ? vm.operator.role.capabilities : null,
                true
            );
        };

        vm.preauthSelected = function () {
            vm.f_deposit = false;
            vm.f_prepayment = false;
            vm.customer_subscription_id = "";
            console.log("preauthSelected");
            vm.treatmentsList = vm.filterByOperatorCapability(
                vm.treatmentsListOrigin,
                vm.operator && vm.operator.role ? vm.operator.role.capabilities : null,
                true
            );
        };


        $scope.$watch(
            "booking.treatmentId",
            function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    vm.monthAvailability.reset();
                    vm.treatment = $filter("getTreatmentFilter")(
                        vm.treatmentsList,
                        vm.treatmentId
                    );
                    vm.deposit = 0;
                    vm.deposit_price = 0;
                    vm.preauth = 0;
                    vm.preauth_price = 0;
                    vm.prepayment = 0;
                    vm.prepayment_price = 0;
                    if (vm.treatment) {
                        if (vm.treatment.f_prepayment) {
                            vm.prepayment = vm.treatment.prepayment_price;
                            vm.prepayment_price = vm.treatment.prepayment_price;
                            vm.prepayment_residuo = 0;
                        }
                        if (vm.treatment.f_deposit) {
                            vm.deposit = vm.treatment.deposit_amount;
                            vm.deposit_price = vm.treatment.deposit_price;
                            vm.deposit_residuo = vm.deposit_price-vm.deposit;
                        }
                        if (vm.treatment.f_preauth) {
                            vm.preauth = vm.treatment.preauth_amount;
                            vm.preauth_price = vm.treatment.preauth_price;
                        }
                    }
                    vm.priceOverride = vm.getTreatmentPrice();
                    vm.initOperatorAssistByUserAssist();
                    vm.buildCapabilities();
                    vm.isOver = false;
                }
            },
            true
        );

        $scope.$watch(
            "booking.active_treatment_category_id",
            function (newValue, oldValue, o) {
                //$log.info(newValue);
                //$log.info(oldValue);
                //$log.info(o);
            },
            true
        );

        // $scope.$watch(
        //     "booking.typeApp",
        //     function (newValue, oldValue) {
        //         var selectedOld = $filter("filter")(
        //             vm.typeAppList,
        //             { value: oldValue },
        //             true
        //         );
        //         var selected = $filter("filter")(
        //             vm.typeAppList,
        //             { value: newValue },
        //             true
        //         );
        //         if (selected && selected.length == 1) {
        //             selected[0].active = 1;
        //         }
        //         if (
        //             oldValue != newValue &&
        //             selectedOld &&
        //             selectedOld.length == 1
        //         ) {
        //             selectedOld[0].active = 0;
        //         }
        //         vm.priceOverride = vm.getTreatmentPrice();
        //     },
        //     true
        // );

        vm.getTreatmentPrice = function () {
            if (!vm.treatment) {
                return;
            }
            if (vm.customer_subscription_id) {
                return vm.customerSubscriptionIdChange();
            }
            if (vm.subscription_new_id) {
                return vm.subscriptionNewIdChange();
            }
            if (vm.typeApp == "TRAT_PROMO_WEB") {
                if (vm.treatment.promo_price) {
                    return vm.treatment.promo_price;
                } else {
                    return vm.treatment.start_price;
                }
            }
            return vm.treatment.start_price;
        };

        vm.buildCapabilities = function () {
            var t = vm.treatment;
            if (!t) return;
            /**
             * devo aggiornare le capabilities
             */
            angular.forEach(vm.rolesList, function (role) {
                role.c_capability = { comm: 1, man: 1, man_speed: null, rel: 1 };

                if (t.capability_id != null) {
                    angular.forEach(role.capabilities, function (cap) {
                        if (cap.capability_id == t.capability_id) {
                            role.c_capability = cap;
                        }
                    });
                }
                /**
                 * aggiorno dati reddh
                 */
                role.c_capability.reddh = 0;
                role.c_capability.check_m_pond = 0;
                role.c_capability.max_daily_app = null;
                if (role.kpis && role.kpis.length > 0) {
                    angular.forEach(role.kpis, function (kpi) {
                        if (
                            kpi.f_first_time == vm.user_times < 1 &&
                            kpi.treatment_category_id ==
                                t.treatment_category_id &&
                            kpi.store_id == vm.storeId
                        ) {
                            role.c_capability.reddh = parseInt(kpi.reddh);
                            role.c_capability.check_m_pond = parseInt(
                                kpi.check_m_pond
                            );
                            role.c_capability.max_daily_app =
                                "" + kpi.max_daily_app == "null"
                                    ? null
                                    : parseInt(kpi.max_daily_app);
                        }
                    });
                }
            });
        };
        /*
         * vm.sortByReddh = function (role) { var val = 0; if
         * (role.c_capability && role.c_capability.reddh) { val =
         * parseInt(role.c_capability.reddh); }
         * $log.info(role.user.firstname + " "+val); return val; }
         */
        // ---------- stores -------------------------------------//

        vm.titleStoreArticle = "della";
        vm.titleStore = "clinica";
        vm.titleCustomer = "paziente";
        vm.storesTitle = "Scegli il <span>" + vm.titleStore + "</span>";
        if (vm.landing) {
            if (vm.landing.stores.data.length === 1) {
                vm.storesTitle =
                    "Dettagli " +
                    vm.titleStoreArticle +
                    " <span>" +
                    vm.titleStore +
                    "</span>";
            }
        }

        vm.storesList = [];
        vm.rolesList = [];
        vm.rolesListBackup = [];
        vm.loadStores = function () {
            vm.loadingTreatments = true;
            var opts = { with: "roles" };
            /*
             * if (appointmentId != null) { opts.searchFields = 'id:=';
             * opts.search = storeId; }
             */
            vm.tenantMsg = "Caricamento centri " + vm.tenant + " ...";
            StoreService.all(opts, vm.currentAPI).then(function (data) {
                vm.tenantMsg = vm.tenantMsg =
                    "Caricamento centri " + vm.tenant + " ... fatto!";
                vm.storesList = data;
                if (vm.landing) {
                    if (vm.landing.stores.data.length) {
                        vm.storesList = vm.landing.stores.data;
                    }
                }

                // city stores
                vm.citiesList = $filter("getCitiesFilter")(vm.storesList);
                vm.city = vm.citiesList[0];

                // se non è stato passato nessuno store da url, setto il
                // primo della lista
                if (!vm.storeId) {
                    vm.store = $filter("filter")(
                        vm.storesList,
                        { active: 1, booking_online: 1 },
                        true
                    )[0];
                    if (vm.store) {
                        vm.storeId = vm.store.id;
                    }
                } else {
                    vm.store = $filter("getStoreFilter")(
                        vm.storeId,
                        vm.storesList
                    );
                }
                if (vm.user != null && vm.user.store_id) {
                    vm.user.store = $filter("getStoreFilter")(
                        vm.user.store_id,
                        vm.storesList
                    );
                }
                if (
                    vm.store &&
                    vm.store.id &&
                    vm.store.roles &&
                    vm.store.roles.data
                ) {
                    vm.storeId = vm.store.id;
                    vm.rolesList = $filter('filter')(vm.store.roles.data, function(item){
                        return item.active && item.user && item.user.active && (item.role === 'operator' || item.role === 'storemngr' || item.role === 'manager');
                    });
                    angular.copy(vm.rolesList, vm.rolesListBackup);
                    vm.refreshRolesList();
                }
                vm.loadTreatments();
                vm.buildCapabilities();
                vm.initOperatorForCustomer();
                // vm.search(true);
                vm.tenantDataLoaded = true;
                vm.loading = false;
            });
        };

        /**
         * Inizilizzo operator
         */
        vm.initOperatorForCustomer = function () {
            vm.operatorSelectionDisabled = false;
            if (vm.env.config && vm.env.config.select_operator_first) {
                if (
                    vm.rolesList &&
                    vm.customer &&
                    vm.customer.operator_user_id
                ) {
                    //$log.info(vm.rolesList);
                    var operators = $filter("filter")(
                        vm.rolesList,
                        {
                            user_id: vm.customer.operator_user_id,
                            store_id: vm.storeId,
                        },
                        true
                    );
                    if (operators && operators.length > 0) {
                        //$log.info("operator_user_id");
                        //$log.info(operators[0]);
                        vm.operator.id = operators[0].user_id;
                        vm.operator.role = operators[0];
                        vm.treatmentsList = vm.filterByOperatorCapability(
                            vm.treatmentsListOrigin,
                            vm.operator.role.capabilities,
                            true
                        );
                        console.log('vm.treatmentsList c', vm.treatmentsListOrigin, vm.treatmentsList);

                        // if (vm.user_times >= 1 &&
                        //     vm.user &&
                        //     vm.user.type == "operator"
                        // ) {
                        //     vm.operatorSelectionDisabled = true; //disabilito selezione operatore se presente operatore assegnato al cliente
                        // }
                    }
                }
            }
        };

        /**
         * Confirm tenant usa checkcustomer che va definita sopra
         */
        vm.checkCustomer = function () {
            vm.existLeadComm = false;
            if (vm.customer.phone == null || vm.customer.phone.trim() == "")
                return;
            vm.customerChecking = true;
            vm.customerLoaded = false;
            vm.old_user_times = vm.user_times;
            vm.old_flow_type = vm.getFlowType();
            if (vm.customer_subscription_id) {
                vm.customer_subscription_id = null;
                vm.customerSubscriptionIdChange();
            }
            /**
             * Devo eseguire solo se il cell è valido
             */
            // $log.info("checkCustomer: " + vm.customer.phone);
            if (vm.customer.id != null) {
                // tengo solo il telefono
                var phone = vm.customer.phone;
                vm.customer = vm.newCustomer(phone);
            }
            vm.tenantMsg = "Caricamento dati " + vm.titleCustomer + " ...";
            var pars = {
                search: "phone:" + vm.customer.phone,
                searchFields: "phone:=",
                check_f_oper: 1,
                lead_id: vm.leadId
            };
            if (vm.birthdate) {
                pars.search +=
                    ";birthdate:" + vm.birthdate.format("YYYY-MM-DD");
                pars.searchFields += ";birthdate:=";
            }
            if (vm.isUser || vm.birthdate) {
                pars.with =
                    "leads;leads.user;appointments;customer_subscriptions";
            }
            CustomerService.all(pars, vm.currentAPI).then(
                function (data) {
                    vm.customerChecking = false;
                    vm.tenantMsg =
                        "Caricamento dati " + vm.titleCustomer + " ... fatto!";
                    if (data.length >= 1) {
                        vm.customer = data[0];
                        if (vm.customer.f_guarantee) {
                            vm.customer.guarantee_at_frmt = moment(
                                vm.customer.guarantee_at
                            ).format("DD/MM/YY");
                        }
                        vm.lead = null;
                        console.log('searchByPhone1', vm.leadId);
                        if (vm.leadId && vm.customer.leads && vm.customer.leads.data) {
                            console.log('searchByPhone2', vm.customer.leads.data);
                            for (var i in vm.customer.leads.data) {
                                if (''+vm.customer.leads.data[i].id === ''+vm.leadId) {
                                    vm.lead = vm.customer.leads.data[i];
                                    break;
                                }
                            }
                        }
                        console.log('searchByPhone3', vm.lead);
                        vm.buildCustomerAppointments();
                        if (
                            vm.isUser &&
                            vm.user &&
                            vm.user.store_id &&
                            !vm.appointmentId &&
                            !vm.haveAppointmensPaid(120) &&
                            !vm.haveSubscriptionActive()
                        ) {
                            //lo spostamento è escluso
                            vm.checkLeadExist();
                            //verifica esistenza lead commerciale recente non chiuso
                        }
                        vm.customerLoaded = true;
                        if (vm.tenant) {
                            var options = {
                                with: "subscription;quotation",
                                search:
                                    "customer_id:" +
                                    vm.customer.id +
                                    ";app_remaining:1",
                                searchFields: "customer_id:=;app_remaining:>=",
                                active: "A",
                                s: 1000,
                                exclude_old: true,
                            };
                            var customer_subscriptions_active = [];
                            CustomerSubscriptionService.all(
                                options,
                                vm.currentAPI
                            ).then(function (response) {
                                angular.forEach(
                                    response.data.data,
                                    function (elem) {
                                        if (
                                            elem.customer_id ==
                                                vm.customer.id &&
                                            elem.app_remaining >= 1
                                        ) {
                                            customer_subscriptions_active.push(
                                                elem
                                            );
                                        }
                                    }
                                );

                                vm.customer.customer_subscriptions_active =
                                    customer_subscriptions_active;
                            });
                        }
                        vm.customer.birthdate = vm.customer.birthdate
                            ? new Date(vm.customer.birthdate)
                            : null;
                        vm.isClientList = $filter("setActiveRadioButtonFilter")(
                            true,
                            vm.isClientList
                        );

                        //BMS-1046: SET CUSTOMER GENDER
                        vm.gender = (vm.customer.gender) ? vm.customer.gender : null;
                        vm.gendersList = $filter("setActiveRadioButtonFilter")(
                            vm.gender,
                            vm.gendersList
                        );
                    } else {
                        vm.isClientList = $filter("setActiveRadioButtonFilter")(
                            false,
                            vm.isClientList
                        );
                    }
                    vm.customerLoaded = true;
                    vm.user_times = vm.customer.user_times;
                    vm.user_times_descr = vm.user_times < 1 ? "Primo ingresso" : "Smaltimento";

                    if (!vm.appointmentId) {
                        vm.f_oper = vm.customer.f_oper ? 1 : 0;
                        vm.f_oper_descr = vm.getFlowTypeDescription();
                        console.log('searchByPhone4', vm.lead);
                        vm.refreshRolesList();
                    }

                    if (vm.customer.last_store_id) {
                        angular.forEach(vm.storesList, function (store) {
                            if (vm.customer.last_store_id == store.id) {
                                vm.store = store;
                            }
                        });
                    }
                    if (vm.store) {
                        vm.storeSelected();
                    } else {
                        vm.initOperatorForCustomer();
                    }

                    if (vm.tenant) {
                        vm.buildCapabilities();
                        if (vm.old_flow_type !== vm.getFlowType()) {
                            // devo resettare le disponibilità caricate
                            // e i trattamenti perchè user_times è cambiato
                            vm.loadTreatments();
                            vm.monthAvailability.reset();
                        }
                    }
                },
                function (data) {
                    var msg = vm.getErrorMsg(data);
                    if (!vm.isUser) {
                        $http
                            .post(
                                (vm.env.currentAPI
                                    ? vm.env.currentAPI
                                    : vm.env.API) + "/handleerror",
                                { params: data }
                            )
                            .then(
                                function () {},
                                function () {}
                            );
                    }
                    alert(
                        "C'è stato un problema nel caricamento dei dati del " +
                            vm.titleCustomer +
                            "." +
                            (msg != null ? " " + msg : "")
                    );
                    vm.customerChecking = false;
                }
            );
        };

        if (!vm.env.apis || vm.tenant) {
            vm.confirmTenant();
        }

        vm.storeSelected = function () {
            vm.storeId = vm.store.id;

            vm.rolesList = $filter('filter')(vm.store.roles.data, function(item){
                return item.active && item.user && item.user.active && (item.role === 'operator' || item.role === 'storemngr' || item.role === 'manager');
            });
            angular.copy(vm.rolesList, vm.rolesListBackup);
            vm.refreshRolesList();

            vm.operator = { id: null };
            vm.initOperatorForCustomer();
            vm.assist = { id: null };
            vm.commercial = { id: null };
            if (vm.env.stores) {
                vm.loadTreatments();
            }
            vm.monthAvailability.reset();
            vm.buildCapabilities();
        };

        vm.filterByOperatorCapability = function (data, capabilities, unique) {
            var res = [];
            var excludePromo =
                (vm.appointmentId == null && vm.cusActId == null) ||
                (vm.appointment != null &&
                    !vm.appointment.treatment.data.name.endsWith(" Promo"));
            var excludeGP =
                vm.appointmentId != null &&
                vm.appointment != null &&
                !vm.appointment.treatment.data.name.endsWith(" GP");
            var filterCategory =
                vm.storeId &&
                vm.env.stores &&
                vm.env.stores[vm.storeId] &&
                vm.env.stores[vm.storeId].categories;
            var firstTreatmentId = null;
            var existTreatmentId = false;
            var treatmentFlowTypes = vm.getTreatmentTypesFromFlow();
            console.log('treatmentFlowTypes', treatmentFlowTypes);
            angular.forEach(data, function (tc) {
                var tmp = [];
                var aggiunti = [];
                var tcToAdd = {
                    treatments: { data: [] },
                    name: tc.name,
                    id: tc.id,
                    order: tc.order,
                };
                if (
                    !filterCategory ||
                    (vm.env.stores &&
                        vm.env.stores[vm.storeId].categories.includes(tc.id))
                ) {
                    tc.treatments.data = $filter("orderBy")(
                        tc.treatments.data,
                        ["order", "name"]
                    );
                    angular.forEach(tc.treatments.data, function (t) {
                        var cap = null;
                        if (capabilities && t.capability_id) {
                            var caps = $filter("filter")(
                                capabilities,
                                {
                                    capability_id: t.capability_id,
                                    store_id: vm.checkCapabilitiesByStore ? vm.storeId : null
                                },
                                true
                            );
                            if (caps.length > 0) {
                                cap = caps[0];
                            }
                        }
                        if ((!vm.f_preauth || t.f_preauth) && (!vm.f_deposit || t.f_deposit) && (!vm.f_prepayment || t.f_prepayment)) {
                            if (((capabilities === null || vm.checkCapabilitiesDefaultValue) && (!cap || cap[vm.capabilitiesField])) ||
                                (capabilities !== null && cap && cap[vm.capabilitiesField] && (vm.capabilitiesField !== 'man_speed' || cap[vm.capabilitiesField] === t.speed))
                            ) {
                                if ((vm.treatmentIdParam && vm.treatmentIdParam == t.id) ||
                                    (vm.tag && vm.tag == t.tag) ||
                                    (vm.birthdate && t.f_birthday) ||
                                    (!vm.birthdate && t.active && t.f_book && (t.f_oper === null || treatmentFlowTypes.indexOf(t.f_oper) >= 0))
                                ) {
                                    if ((vm.treatmentIdParam && vm.treatmentIdParam == t.id) ||
                                        (vm.tag && vm.tag == t.tag) ||
                                        (!vm.isUser && !t.private) ||
                                        (vm.isUser && t.promo && !excludePromo) ||
                                        (vm.isUser && t.name.endsWith(" GP") && !excludeGP) ||
                                        (vm.isUser && !t.promo && !t.name.endsWith(" GP"))
                                    ) {
                                        if (!firstTreatmentId &&
                                            (!filterCategory || !vm.env.stores[vm.storeId].firstTreatmentId || vm.env.stores[vm.storeId].firstTreatmentId)
                                        ) {
                                            if ((vm.gender == t.gender || t.gender == "U") &&
                                                ((vm.user && vm.user.id) || !t.private)
                                            ) {
                                                //trattamento selezionato inizialmente
                                                firstTreatmentId = t.id;
                                            }
                                        }
                                        if (vm.treatmentIdParam && t.id == vm.treatmentIdParam) {
                                            existTreatmentId = true;
                                            vm.treatmentId = t.id;
                                        } else if (!vm.treatmentIdParam && vm.tag && t.tag == vm.tag) {
                                            existTreatmentId = true;
                                            vm.treatmentId = t.id;
                                            vm.search_treatment = t.name;
                                        }
                                        /**
                                         * Controllo che non esista già lo stesso nome (aggiungo solo il primo)
                                         */
                                        if (aggiunti.indexOf(t.name) == -1 || !unique) {
                                            tmp.push(t);
                                            aggiunti.push(t.name);
                                        } else {
                                            //$log.info("Trattamento multiplo: scartato: "+ t.name + ' ' + t.id);
                                        }
                                        //$log.info("Trattamento incluso: "+t.name + " [tag="+t.tag+"] " + " [tid="+t.id+"] / "+t.treatment_category_id);
                                    } else {
                                        //$log.info("Trattamento escluso per private gp promo: "+t.name + " [tag="+t.tag+"] " + " [tid="+t.id+"] / "+t.treatment_category_id);
                                    }
                                } else {
                                    //$log.info("Trattamento escluso per book type: "+t.name + " t.f_book=" + t.f_book + " t.active=" + t.active +  " t.f_oper=" + t.f_oper + " treatmentFlowType=" + treatmentFlowType + " [tag="+t.tag+"] " +  " [tid="+t.id+"] / "+t.treatment_category_id);
                                }
                            } else {
                                //$log.info("Trattamento non abilitato: "+t.name + " - "+t.capability_id);
                            }
                        } else {
                            //$log.info("Trattamento escluso per preauth o deposit: "+t.name + " [tag="+t.tag+"] " +  " [tid="+t.id+"] / "+t.treatment_category_id);
                        }
                    });
                }
                if (tmp.length > 0) {
                    tcToAdd.treatments.data = tmp;
                    res.push(tcToAdd);
                }
            });
            if (!existTreatmentId) {
                vm.treatmentId = firstTreatmentId;
            }

            vm.treatment = $filter("getTreatmentFilter")(data, vm.treatmentId);
            if (vm.treatment) {
                setTimeout(function () {
                    console.log("filterTreatments imposto categoria selezionata: "+vm.treatment.treatment_category_id);
                    vm.active_treatment_category_id = vm.treatment.treatment_category_id;
                    /**
                     * La modifica non viene propagata all'interfaccia, devo forzare aggiornamento
                     */
                    $scope.$apply();
                    vm.initOperatorAssistByUserAssist();
                }, 100);
            }
            return res;
        };
        vm.operatorSelected = function () {
            vm.operator.role = $filter("filter")(
                vm.rolesList,
                { store_id: vm.store.id, user_id: vm.operator.id },
                true
            )[0];
            if (!vm.isOver) {
                vm.monthAvailability.reset();
            }
            /**
             * devo filtrare i trattamenti in base alle abilitazioni utente
             */
            if (vm.operator.id) {
                vm.treatmentsList = vm.filterByOperatorCapability(
                    vm.treatmentsListOrigin,
                    vm.operator.role.capabilities,
                    true
                );
            } else {
                vm.treatmentsList = vm.filterByOperatorCapability(
                    vm.treatmentsListOrigin,
                    null,
                    true
                );
            }
            console.log('vm.treatmentsList a', vm.treatmentsListOrigin, vm.treatmentsList);
        };

        vm.assistSelected = function () {
            vm.assist.role = $filter("filter")(
                vm.rolesList,
                { store_id: vm.store.id, user_id: vm.assist.id },
                true
            )[0];
            if (!vm.isOver) {
                vm.monthAvailability.reset();
            }
        };

        vm.commercialSelected = function () {
            vm.commercial.role = $filter("filter")(
                vm.rolesList,
                { store_id: vm.store.id, user_id: vm.commercial.id },
                true
            )[0];
            if (!vm.isOver) {
                vm.monthAvailability.reset();
            }
        };

        vm.operatorFilter = function (role) {
            if (!role.c_capability[vm.capabilitiesField]) return;
            vm.operator.id = role.user_id;
            vm.operatorSelected();
            vm.monthAvailability.load();
        };

        // map
        var w = Math.max(
            $document[0].documentElement.clientWidth,
            $window.innerWidth || 0
        );
        var isDraggable = w > 480 ? true : false;
        vm.map = {
            options: {
                draggable: isDraggable,
                scrollwheel: false,
                disableDefaultUI: true,
            },
            zoom: 14,
        };
        // end map

        vm.openLightboxModal = function (index) {
            Lightbox.openModal(vm.store.gallery, index);
        };
        // end city stores

        // ---------- dateTime -------------------------------------//

        vm.dateTimeTitle = "Scegli la <span>data</span> e l’<span>ora</span>";

        // date
        // controllo se siamo oltre all'orario di chiusura
        vm.today = moment();
        vm.nowTime = moment(vm.today.format("HH:mm"), "HH:mm");
        vm.closingTime = moment("20:00", "HH:mm");
        if (vm.nowTime >= vm.closingTime) {
            vm.dateStart = moment().add(1, "days");
        } else {
            vm.dateStart = moment();
        }
        vm.inlineOptions = {
            showWeeks: false,
            startingDay: 1,
            // minDate: moment(),
            customClass: function (data) {
                if (data.mode != "day") {
                    return "";
                } else {
                    var std_date = moment(data.date).format("YYYY-MM-DD");
                    // var d = moment(data.date).format("DD");
                    var ym = moment(data.date).format("YYYY-MM");
                    var res = "";
                    if (!vm.monthAvailability.loaded[ym]) {
                        res = "";
                    } else {
                        if (vm.availabilitiesCount[std_date] != null) {
                            var disp = null;
                            if (vm.dayMoment == null || vm.dayMoment == "") {
                                disp = vm.availabilitiesCount[std_date].disp;
                            } else {
                                disp =
                                    vm.availabilitiesCount[std_date][
                                        "disp_" +
                                            vm.monthAvailability.dayMomToLabel(
                                                vm.dayMoment
                                            )
                                    ];
                            }
                            if (disp == 0) {
                                res = "";
                            } else {
                                var dispInd = 1 + Math.round(disp / 100);
                                if (dispInd > 10) {
                                    dispInd = 10;
                                }
                                res = "availab-" + dispInd;
                                var gp =
                                    vm.availabilitiesCount[std_date][
                                        "count_gp"
                                    ];
                                if (gp > 0 && vm.isUser) {
                                    res +=
                                        " count-gp-" + (1 + Math.round(gp / 3));
                                }
                            }
                            // console.log(std_date + " availab: " + disp +
                            // " class: " + res);
                        }
                    }
                    return res;
                }
            },
            dateDisabled: function (data) {
                //$log.info('scope',vm.scope);
                //$log.info('cf',vm.customerForm);
                //$log.info('date',data);
                /**
                 * problema non torna a chiederlo quando cambia validità del form
                 */
                if (vm.customerForm && vm.customerForm.$invalid) {
                    //return true;
                }
                //$log.info('null customerForm');
                var date = data.date,
                    mode = data.mode;
                if (mode != "day") return false;
                var std_date = moment(data.date).format("YYYY-MM-DD");
                var d = moment(data.date).format("DD");
                var ym = moment(data.date).format("YYYY-MM");
                var curr_ym = moment().format("YYYY-MM");
                var toLoad = d == "15";
                if (toLoad) {
                    var load_date = null;
                    if (ym == curr_ym) {
                        load_date = moment().format("YYYY-MM-DD");
                    } else {
                        load_date = ym + "-01";
                    }
                    vm.monthAvailability.toLoadDate = load_date;
                    vm.monthAvailability.setToLoadYm(ym);
                }
                var res = true;
                if (
                    vm.monthAvailability.loaded[ym] &&
                    vm.monthAvailability.existsFull(std_date, vm.dayMoment)
                ) {
                    res = false;
                }

                /**
                 * By passo calcoli vari
                 */
                var oggi = moment().format("YYYY-MM-DD");
                if (std_date >= oggi) {
                    return false;
                } else {
                    return true;
                }

                return res;
            },
        };

        // day moments
        vm.dayMoment = "";
        vm.dayMomentList = [
            {
                value: "",
                label: "",
                description: "Tutti",
                icon: "",
                active: true,
                disabled: false,
                start: "08:00:00",
                end: "21:00:00",
                type: "euro",
            },
            {
                value: "0-720",
                minute_start: 0,
                minute_end: 720,
                label: "",
                description: "Mattina",
                icon: "",
                active: false,
                disabled: false,
                start: "08:00:00",
                end: "12:00:00",
                type: "euro",
            },
            {
                value: "720-870",
                minute_start: 720,
                minute_end: 870,
                label: "",
                description: "Pausa Pranzo",
                icon: "",
                active: false,
                disabled: false,
                start: "12:00:00",
                end: "14:30:00",
                type: "euro",
            },
            {
                value: "870-1020",
                minute_start: 870,
                minute_end: 1020,
                label: "",
                description: "Pomeriggio",
                icon: "",
                active: false,
                disabled: false,
                start: "14:30:00",
                end: "17:00:00",
                type: "euro",
            },
            {
                value: "1020-1440",
                minute_start: 1020,
                minute_end: 1440,
                label: "",
                description: "Sera",
                icon: "",
                active: false,
                disabled: false,
                start: "17:00:00",
                end: "21:00:00",
                type: "euro",
            },
        ];

        vm.reserved = undefined;
        vm.reservedOptionsList = [
            {
                value: undefined,
                label: "",
                description: "Tutti",
                icon: "",
                active: true,
                disabled: false,
                start: "",
                end: "",
                type: "",
            },
            {
                value: -1,
                label: "",
                description: "Riservati",
                icon: "",
                active: false,
                disabled: false,
                start: "",
                end: "",
                type: "",
            },
            {
                value: 0,
                label: "",
                description: "Non riservati",
                icon: "",
                active: false,
                disabled: false,
                start: "",
                end: "",
                type: "",
            },
        ];

        vm.reservedSelected = function () {
            vm.setAvailabilitiesToShowList();
        };
        // end day moment

        // NO MOMENTI GIORNATA

        vm.setAvailabilitiesToShowList = function () {
            /**
             * devo tener conto anche del fatto se è prima volta: faccio
             * vedere solo il commerciale migliore?
             */
            var tmpList = $filter("distributeAvailabilitiesInMomentsFilter")(
                vm.availabilitiesList,
                vm.dayMoment,
                vm.dayMomentList,
                vm.customer
            );
            if (vm.reserved == undefined) {
                vm.availabilitiesToShowList = tmpList;
            } else {
                vm.availabilitiesToShowList = $filter("filter")(
                    tmpList,
                    { reserved: vm.reserved },
                    true
                );
            }
            //$log.info(vm.availabilitiesToShowList);
            vm.availability = null;
            if (vm.availabilitiesToShowList.length > 0) {
                var curDate = moment(vm.date).format("YYYY-MM-DD");
                $log.info("curDate is: " + curDate);
                for (var i = 0; i < vm.availabilitiesToShowList.length; i++) {
                    var el = vm.availabilitiesToShowList[i];
                    if (el.date == curDate) {
                        // $log.info("OK: "+el.date);
                        vm.availability = el;
                        // $log.info(el);
                        break;
                    }
                }
                // default devo mettere il primo orario disponibile della data
                // selezionata
            }
        };

        // all'avvio e al cambio del momento del giorno, ricalcolo le
        // disponibilità da mostrare
        // NO MOMENTI GIORNATA
        /*
         * $scope.$watch('booking.dayMoment', function() {
         * vm.setAvailabilitiesToShowList(); },true);
         */

        vm.gp = 0;
        vm.date4Labels = null;
        vm.dateSelected = function () {
            vm.search();
        };

        vm.momentSelected = function () {
            /**
             * devo far aggiornare il calendario con la disponibilità per
             * questo daymoment
             */
            /*
             * if (vm.date!=null &&
             * vm.monthAvailability.exists(moment(vm.date).format("YYYY-MM"),
             * vm.dayMoment)) { vm.date =
             * moment(vm.monthAvailability.getFirst(moment(vm.date).format("YYYY-MM"),
             * vm.dayMoment)); } else {
             */
            vm.date = moment(vm.date); // imposto la data corrente per il
            // ricalcolo delle disponibilità
            vm.dateStr = moment(vm.date).format("YYYY-MM-DD");
            /**
             * Aggiorno la lista con i soli momenti disponibili nel
             * dayMoment selezionato
             */
            // }
            vm.setAvailabilitiesToShowList();
        };

        vm.loading = false;
        vm.searchLoading = false;
        vm.availabilitiesList = [];
        vm.availabilitiesCount = [];
        vm.appointmentsToShowList = [];
        vm.getOptionsForAvailability = function () {
            var date_start = vm.dateStart.format("YYYY-MM-DD") + " 08:00:00";
            if (vm.date != null) {
                date_start = moment(vm.date).format("YYYY-MM-DD") + " 08:00:00";
            }
            var options = {
                date_start: date_start,
                treatment_id: vm.treatmentId,
                store_id: vm.storeId,
                user_times: vm.user_times,
                flow_type_capability: vm.getFlowTypeCapability(),
            };

            // caso della centralinista alla quale servono tutte le
            // disponibilità
            // Modificato per tutte le operatrici
            if (vm.operatorId != null) {
                options.all = true;
            }
            if (vm.operator.id != null && vm.operator.id != "") {
                options.user_id = vm.operator.id;
            }
            if (vm.assist.id != null && vm.assist.id != "") {
                options.assist_user_id = vm.assist.id;
            }
            /*
             * if (vm.dayMoment!=null && vm.dayMoment!='') { options.minutes =
             * vm.dayMoment; }
             */
            options.c_role = vm.userRole;
            if (!vm.kpiCheck) {
                options.kpi_check = false;
            }
            return options;
        };
        vm.monthAvailability = {
            loading: false,
            loaded: [],
            isLoaded: false,
            data: null,
            toLoadDate: null,
            toLoadYm: null,
            isCurrentYmLoaded: false,
            setToLoadYm: function (ym) {
                this.toLoadYm = ym;
                var res =
                    this.toLoadYm != null &&
                    this.loaded[this.toLoadYm] != null &&
                    this.loaded[this.toLoadYm].val;
                this.isCurrentYmLoaded = res;
                if (
                    !this.isCurrentYmLoaded &&
                    !vm.user &&
                    vm.landing &&
                    vm.treatment
                ) {
                    this.load();
                }
                /*
                 * if (vm.monthAvailability.loaded[ym]!=null) { if
                 * (vm.monthAvailability.loaded[ym].found &&
                 * !vm.searchLoading) { vm.date =
                 * moment(vm.monthAvailability.loaded[ym].firstDay);
                 * vm.search(); } else if
                 * (!vm.monthAvailability.loaded[ym].found) { vm.date =
                 * null; vm.availability = null; vm.availabilitiesList =
                 * []; vm.availabilitiesToShowList = []; } }
                 */
                // console.log("isCurrentYmLoaded " +ym +" ->
                // "+this.isCurrentYmLoaded);
            },
            load: function () {
                var data = this.toLoadDate;
                this.data = data;
                this.loading = true;
                vm.loading = true;
                var options = vm.getOptionsForAvailability();
                var firstDay = data + " 08:00:00";
                options.date_start = firstDay;
                var lastDay =
                    moment(firstDay)
                        .add(1, "months")
                        .date(0)
                        .format("YYYY-MM-DD") + " 23:59:59";
                options.date_to = lastDay;
                // console.log(options);
                MyAvailabilityService.availabilitiesCount(
                    options,
                    vm.currentAPI
                ).then(
                    function (response) {
                        var found = false;
                        var firstDay = "";
                        if (response.data != null && response.data.length > 0) {
                            for (var i = 0; i < response.data.length; i++) {
                                if (!found) {
                                    found = true;
                                    firstDay =
                                        response.data[i].date + " 08:00:00";
                                }
                                vm.availabilitiesCount[response.data[i].date] =
                                    response.data[i];
                            }
                        }
                        vm.monthAvailability.loading = false;
                        vm.monthAvailability.loaded[data.substring(0, 7)] = {
                            val: true,
                            found: found,
                            firstDay: firstDay,
                        };
                        vm.monthAvailability.isCurrentYmLoaded = true;
                        vm.monthAvailability.isLoaded = true;
                        vm.loading = vm.searchLoading;
                        if (found) {
                            vm.date = moment(firstDay);
                            vm.dateStr = vm.date.format("YY-MM-DD");
                            vm.search();
                        } else {
                            /*
                             * vm.date = null; vm.availability = null;
                             * vm.availabilitiesList = [];
                             * vm.availabilitiesToShowList = [];
                             */
                        }
                        if (!vm.isUser) {
                            ga("set", "page", "/appointments-available-count");
                            ga("send", "pageview");
                            //$http.post(vm.env.API+"/handleerror",{params: response})
                        }
                    },
                    function (response) {
                        var msg = vm.getErrorMsg(response);
                        vm.monthAvailability.loading = false;
                        vm.loading = vm.searchLoading;
                        if (!vm.isUser) {
                            ga(
                                "set",
                                "page",
                                "/appointments-available-count/error"
                            );
                            ga("send", "pageview");
                            $http
                                .post(
                                    (vm.env.currentAPI
                                        ? vm.env.currentAPI
                                        : vm.env.API) + "/handleerror",
                                    { params: response }
                                )
                                .then(
                                    function () {},
                                    function () {}
                                );
                        }
                        alert(
                            "C'è stato un problema nel caricamento della disponibilità." +
                                (msg != null ? " " + msg : "")
                        );
                    }
                );
            },
            reset: function () {
                vm.date = null;
                vm.dateStr = null;
                vm.availabilitiesCount = [];
                vm.monthAvailability.loaded = [];
                vm.monthAvailability.isLoaded = false;
                vm.availability = null;
                vm.availabilitiesList = [];
                vm.availabilitiesToShowList = [];
                vm.appointmentsToShowList = [];
                vm.event2Show = {};
                vm.isOver = false;
                vm.monthAvailability.isCurrentYmLoaded = false;
                vm.typeApp = 'TRAT_PREZZO_PIENO';
                // faccio rieseguire il load del calendario
                /*
                 * if (vm.date!=null) { vm.date = moment(vm.date); }
                 * else { //vm.date = moment();//imposto la data
                 * corrente }
                 */
            },
            getFirst: function (date_ym, dayMoment) {
                var day = moment(date_ym + "-01");
                while (day.format("YYYY-MM") == date_ym) {
                    var k = day.format("YYYY-MM-DD");
                    if (
                        vm.availabilitiesCount[k] != null &&
                        vm.availabilitiesCount[k][
                            "disp_" + this.dayMomToLabel(dayMoment)
                        ] > 0
                    ) {
                        return k;
                    }
                    day = day.add(1, "days");
                }
                return null;
            },
            exists: function (date_ym, dayMoment) {
                return this.getFirst(date_ym, dayMoment) != null;
            },
            getCounts: function (k) {
                return vm.availabilitiesCount[k];
            },
            existsFull: function (k, dayMoment) {
                var el = this.getCounts(k);
                if (dayMoment == null || dayMoment == "") {
                    return el != null && el.disp > 0;
                } else {
                    return (
                        el != null &&
                        el["disp_" + this.dayMomToLabel(dayMoment)] > 0
                    );
                }
            },
            dayMomToLabel: function (dm) {
                var DM_MAP = [];
                DM_MAP["0-720"] = "morning";
                DM_MAP["720-870"] = "lanch";
                DM_MAP["870-1020"] = "afternoon";
                DM_MAP["1020-1440"] = "dinner";
                return DM_MAP[dm];
            },
        };
        /**
         * Cambio data clic su calendario e carico disponibilità del giorno
         */
        vm.search = function () {
            vm.event2Show = {};
            vm.availabilitiesList = [];
            vm.appointmentsToShowList = [];
            vm.availabilitiesToShowList = [];
            vm.availability = null;
            if (vm.monthAvailability.loading) {
                // alert("Il caricamento disponibilità non è terminato
                // correttamente, attendere o riprovare.");
                return;
            }
            if (vm.date == null) {
                // alert("Il caricamento disponibilità non è terminato
                // correttamente, o la data non è stata impostata, attendere o
                // riprovare.");
                return;
            }
            vm.loading = true;
            vm.searchLoading = true;
            var options = vm.getOptionsForAvailability();
            vm.date_frmt = moment(vm.date).format("dddd, D MMMM");
            var ym = moment(vm.date).format("YYYY-MM-DD");
            var el = vm.monthAvailability.getCounts(ym);
            if (el != null) {
                vm.gp = el.count_gp;
            } else {
                vm.gp = 0;
            }
            if (vm.isUser) {
                vm.loadAppointments();
                vm.loadEvent2Show();
            }
            MyAvailabilityService.availabilities(options, vm.currentAPI).then(
                function (response) {
                    vm.date1 = null;
                    vm.date2 = null;
                    vm.date3 = null;

                    var date1, date2, date3;
                    date1 = moment(vm.date);
                    date2 = moment(vm.date).add(1, "days");
                    date3 = moment(vm.date).add(2, "days");

                    var frmt = "dddd, D MMMM";
                    if (response.data && response.data.data) {
                        vm.date1 = response.data.meta[0];
                        vm.date2 = response.data.meta[1];
                        vm.date3 = response.data.meta[2];

                        angular.forEach(response.data.data, function (el) {
                            el.customer_id = null;
                            if (el.date_start == null && el.hours != null) {
                                el.store_id = options.store_id;
                                if (!el.treatment_id) {
                                    el.treatment_id = vm.treatment.id;
                                }
                                el.price = vm.treatment.start_price;
                                el.date_start = el.date + " " + el.hours;
                                var duration = el.min_duration
                                    ? el.min_duration
                                    : vm.treatment.duration;
                                el.date_end = moment(el.date_start)
                                    .add(duration, "minutes")
                                    .format("YYYY-MM-DD HH:mm:ss");
                                // delete el.date;
                                el.minute;
                                delete el.hours;
                            }

                            el.role = { data: { c_capability: { comm: 1 } } };
                            el.user = { data: {} };

                            angular.forEach(vm.rolesList, function (r) {
                                if (r.user_id == el.user_id) {
                                    el.role = { data: r };
                                    el.user = { data: r.user };
                                }
                                if (r.user_id == el.assist_user_id) {
                                    el.assistRole = { data: r };
                                    el.assistUser = { data: r.user };
                                }
                                if (r.user_id == el.commercial_user_id) {
                                    el.commercialRole = { data: r };
                                    el.commercialUser = { data: r.user };
                                }
                            });
                            // $log.info(el);
                            vm.availabilitiesList.push(el);
                        });
                        //$log.info('vm.availabilitiesList 2241', vm.availabilitiesList);
                        if (vm.availabilitiesList.length > 0) {
                            vm.setAvailabilitiesToShowList();
                        }
                        vm.loading = vm.monthAvailability.loading;
                        vm.searchLoading = false;
                        // per far visualizzare la data formattata
                        // NO MOMENTI GIORNATA
                        /*
                         * vm.dayMomentsList_before =
                         * $filter('setDayMomentsFilter')(vm.availabilitiesList,vm.defaultDayMoments);
                         * vm.dayMoment =
                         * $filter('setFirstMomentFilter')(vm.dayMomentsList_before);
                         * vm.dayMomentsList =
                         * $filter('setActiveRadioButtonFilter')(vm.dayMoment,vm.dayMomentsList_before);
                         * //setto ad active il primo momento
                         */
                    }
                    vm.date1_frmt = moment(vm.date1).format(frmt);
                    vm.date2_frmt = moment(vm.date2).format(frmt);
                    vm.date3_frmt = moment(vm.date3).format(frmt);

                    if (!vm.isUser) {
                        ga("set", "page", "/appointments-available");
                        ga("send", "pageview");
                    }
                },
                function (data) {
                    var msg = vm.getErrorMsg(data);
                    alert(
                        "C'è stato un problema nel caricamento della disponibilità per il giorno selezionato." +
                            (msg != null ? " " + msg : "")
                    );
                    vm.loading = vm.monthAvailability.loading;
                    vm.searchLoading = false;
                    if (!vm.isUser) {
                        ga("set", "page", "/appointments-available/error");
                        ga("send", "pageview");
                        $http
                            .post(
                                (vm.env.currentAPI
                                    ? vm.env.currentAPI
                                    : vm.env.API) + "/handleerror",
                                { params: data }
                            )
                            .then(
                                function () {},
                                function () {}
                            );
                    }
                }
            );
        };

        /**
         * Carico gli appuntamenti già presi per la data selezionata
         */

        vm.appointmentsToShowList = [];
        vm.loadAppointments = function () {
            vm.appointmentsToShowList = [];
            var options = {
                with: "role;treatment",
                search:
                    "recalled:3" +
                    ";date_start:" +
                    moment(vm.date).format("YYYY-MM-DD") +
                    ";date_end:" +
                    moment(vm.date).add(1, "days").format("YYYY-MM-DD") +
                    ";store_id:" +
                    vm.storeId,
                searchFields: "date_start:>;date_end:<;store_id:=;recalled:<",
                orderBy: "date_start",
                sortedBy: "asc",
                s: 100, // per bypassare la paginazione
            };
            AppointmentService.all(options, vm.currentAPI).then(
                function (data) {
                    vm.appointmentsToShowList = data;
                    // console.log(vm.appointmentsToShowList);
                },
                function (data) {
                    $http
                        .post(
                            (vm.env.currentAPI
                                ? vm.env.currentAPI
                                : vm.env.API) + "/handleerror",
                            { params: data }
                        )
                        .then(
                            function () {},
                            function () {}
                        );
                }
            );
            // .finally( vm.reRenderEvents )
        };

        vm.loadEvent2Show = function () {
            vm.event2Show = {};
            var path = "booking";
            var date = moment(vm.date).format("YYYY-MM-DD");
            $http
                .get(
                    vm.currentAPI +
                        "/events/2show/" +
                        vm.storeId +
                        "/" +
                        date +
                        "/" +
                        path
                )
                .then(function (response) {
                    if (response.data.data) {
                        vm.event2Show = response.data.data;
                    }
                });
        };

        vm.insertPf = function () {
            //alert('/pf?cph='+vm.customer.phone);
            window.location =
                "/pf?cph=" + vm.customer.phone + "&token=" + vm.token;
        };

        vm.getErrorMsg = function (response) {
            if (!vm.isUser) return null;
            var msg = null;
            if (response.data != null && response.data.message != null) {
                msg =
                    response.data != null && response.data.message != null
                        ? "\n\nERRORE: " + response.data.message
                        : "";
                msg +=
                    response.config != null && response.config.url != null
                        ? "\nURL: " + response.config.url
                        : "";
                if (vm.user && (vm.user.id == 20 || vm.user.type == "admin")) {
                    if (response.data != null && response.data.debug != null) {
                        msg += "\n\nCLASS: " + response.data.debug.class;
                        msg += "\nTRACE:";
                        for (
                            var i = 0;
                            i < response.data.debug.trace.length && i < 5;
                            i++
                        ) {
                            msg += "\n" + response.data.debug.trace[i];
                        }
                    }
                }
            }
            return msg;
        };

        // ---------- customerdata -------------------------------------//

        vm.customerChecking = false;
        vm.customerLoaded = false;
        vm.user_times = null;
        vm.user_times_descr = '';

        vm.f_oper = null;
        vm.f_oper_descr = '';
        vm.refreshRolesList();

        // alert(vm.user_times);
        // alert(vm.isCallCenter);

        vm.initOperatorAssistByUserAssist = function() {
        };

        vm.haveAppointmensPaid = function (days) {
            if (
                !vm.customer ||
                !vm.customer.appointments ||
                !vm.customer.appointments.data
            ) {
                return false;
            }
            for (var i = 0; i < vm.customer.appointments.data.length; i++) {
                var app = vm.customer.appointments.data[i];
                if (app.paid) {
                    //console.log('adesso');
                    //console.log(moment().format('YYYY-MM-DD HH:mm'));
                    //console.log('date_start');
                    //console.log(app.date_start);
                    if (app.date_start < moment().format("YYYY-MM-DD HH:mm")) {
                        //console.log('start + 120 < now')
                        //console.log(moment(app.date_start).add(days,'days').isAfter(moment()));
                        return moment(app.date_start)
                            .add(days, "days")
                            .isAfter(moment());
                    }
                }
            }
            return false;
        };
        vm.haveSubscriptionActive = function () {
            if (
                !vm.customer ||
                !vm.customer.customer_subscriptions ||
                !vm.customer.customer_subscriptions.data
            ) {
                return false;
            }
            for (
                var i = 0;
                i < vm.customer.customer_subscriptions.data.length;
                i++
            ) {
                var s = vm.customer.customer_subscriptions.data[i];
                if (!s.f_over && s.app_remaining > 0) {
                    //console.log('trovato abbonamento attivo');
                    return true;
                }
            }
            return false;
        };

        vm.existLeadComm = false;
        vm.checkLeadExist = function () {
            if (
                vm.customer &&
                vm.customer.leads &&
                vm.customer.leads.data &&
                vm.customer.leads.data.length > 0
            ) {
                angular.forEach(vm.customer.leads.data, function (l) {
                    if (
                        !l.f_dup_mkt &&
                        !l.f_oper &&
                        l.user_id != vm.user.id &&
                        ![
                            "rullo",
                            "conferma",
                            "non presentato",
                            "non fidelizzato",
                            "confermaop",
                            "confermacomm",
                            "disdetto",
                        ].includes(l.category) &&
                        ![
                            "ha preso appuntamento",
                            "ha già preso appuntamento",
                        ].includes(l.call_state) &&
                        moment(
                            l.created_at.date ? l.created_at.date : l.created_at
                        )
                            .add(3, "months")
                            .format("YYYY-MM-DD") >=
                            moment().format("YYYY-MM-DD")
                    ) {
                        vm.existLeadComm = l;
                    }
                });
            }
        };

        vm.buildCustomerAppointments = function () {
            if (
                vm.treatmentsLoaded &&
                vm.customer &&
                vm.customer.appointments &&
                vm.customer.appointments.data
            ) {
                angular.forEach(vm.customer.appointments.data, function (app) {
                    app.treatment = {
                        data: $filter("getTreatmentFilter")(
                            vm.treatmentsListAll,
                            app.treatment_id,
                            true
                        ),
                    };
                    angular.forEach(vm.storesList, function (store) {
                        if (app.store_id == store.id) {
                            app.store = { data: store };
                        }
                    });
                    app.date_start_frmt = moment(app.date_start).format(
                        "DD/MM/YYYY HH:mm"
                    );
                    var createdAt = moment(
                        app.created_at && app.created_at.date
                            ? app.created_at.date
                            : app.created_at
                    );
                    //console.log(app.created_at);
                    //console.log(createdAt);
                    //console.log(vm.nearestBirthdate().subtract(15,'day'));
                    //console.log("->"+(vm.nearestBirthdate().subtract(15,'day')<createdAt));
                    if (
                        vm.birthdate &&
                        app.treatment.data.f_birthday &&
                        app.recalled < 3 &&
                        vm
                            .nearestBirthdate()
                            .subtract(15, "days")
                            .isBefore(createdAt)
                    ) {
                        $state.go("booking-promo-already");
                    } else if (vm.birthdate && app.treatment.data.f_birthday) {
                        //console.log('non considero questo app:');
                        //console.log(app);
                    }
                });
            }
        };

        // Caso in cui il cliente prenota compleanno o landing personalizzata
        if (vm.customerId && !vm.isUser && (vm.birthdate || vm.landing)) {
            vm.customer.phone = vm.customerId;
            vm.checkCustomer();
        }

        /*
         * $scope.$watch( 'booking.treatment.start_price', function( value ) {
         * if( angular.isDefined( value ) ) { if( vm.landing ) {
         * vm.priceOverride = vm.landing.price; vm.treatment.start_price =
         * vm.landing.price; } else { if(vm.priceFromSubscription ===
         * false){ vm.priceOverride = value; } } } } );
         */

        /*
         * $scope.$watch( 'booking.search_treatment', function( value ) {
         * //vm.treatmentId = null; //vm.treatment = null; $log.info ("watch
         * search_treatment vm.search_treatment : " + vm.search_treatment); } );
         */

        vm.customerSubscriptionIdChange = function () {
            var value = vm.customer_subscription_id;
            $log.info(
                "customerSubscriptionIdChange: " + vm.customer_subscription_id
            );
            if (value) {
                vm.subscription_new_id = null;
                vm.priceOverride = 0;
                vm.priceFromSubscription = true;
            } else {
                vm.priceFromSubscription = false;
                vm.priceOverride = vm.getTreatmentPrice();
            }
            vm.checkTypeApp();
            return vm.priceOverride;
        };

        vm.subscriptionNewIdChange = function () {
            var value = vm.subscription_new_id;
            if (value) {
                vm.customer_subscription_id = null;
                vm.priceOverride = 0;
                vm.priceFromSubscription = false;
                angular.forEach(vm.subscriptionsList, function (elem) {
                    if (elem.id == value) {
                        vm.priceOverride = elem.price;
                        vm.priceFromSubscription = true;
                    }
                });
            } else {
                vm.priceFromSubscription = false;
                vm.priceOverride = vm.getTreatmentPrice();
            }
            return vm.priceOverride;
        };

        vm.appHaveOverlap = function (app) {
            var res = false;
            var start, end, valid;

            if (!vm.isOver) {
                valid = vm.availability;
                if (valid) {
                    end = vm.availability.date_end;
                    start = vm.availability.date_start;
                }
            } else {
                valid = vm.overDateStart;
                // $log.info(vm.overDateStart);
                if (valid) {
                    start =
                        moment(vm.date).format("YYYY-MM-DD") +
                        " " +
                        moment(vm.overDateStart).format("HH:mm");
                    end = moment(start)
                        .add(vm.treatment.duration, "minutes")
                        .format("YYYY-MM-DD HH:mm");
                }
            }
            // $log.info("Check overlap: start->" + start + " end->"+end);
            res = valid && app.date_start < end && app.date_end > start;
            /*
             * if (res) { $log.info("Found overlap"); $log.info(app); }
             */
            return res;
        };
        /*
         * $scope.$watch('booking.date', function(newValue, oldValue) {
         * //var vm = $scope.booking; //console.log($scope);
         * //console.log($scope.booking); //$log.info("I've changed -> new: " +
         * moment(newValue).format("YYYY-MM-DD HH:mm") + " old:" +
         * moment(oldValue).format("YYYY-MM-DD HH:mm")); });
         */

        /*
         * $scope.$watch('booking.availability', function(newValue,
         * oldValue) { //console.log($scope); //console.log($scope.booking);
         * $log.info(newValue); $log.info(oldValue); });
         */

        /*
         * $scope.$watch('booking.isClient', function() { if(vm.isClient) {
         * //vm.customerDataTitle = 'Lascia i tuoi dati per usufruire di
         * <span>sconti e promozioni</span>'; if(isUser || vm.user){
         * vm.customerDataTitle = 'Dati di <span>'+vm.customer.firstname+'</span>'; }
         * }else{ vm.customerDataTitle = 'Lascia i tuoi <span>dati</span>';
         * if(isUser || vm.user){ vm.customerDataTitle = 'Inserisci i dati
         * del <span>cliente</span>'; } } },true);
         */

        // ---------- SEND DATA -------------------------------------//

        vm.initAvailabilityOver = function () {
            var availab = {
                store_id: vm.storeId,
                treatment_id: vm.treatmentId,
                price: vm.treatment.start_price,
                user_id: vm.operator.id,
                assist_user_id: vm.assist.id,
                commercial_user_id: vm.commercial.id,
            };
            var date_start =
                moment(vm.date).format("YYYY-MM-DD") +
                " " +
                moment(vm.overDateStart).format("HH:mm");
            var date_end = moment(date_start)
                .add(vm.treatment.duration, "minutes")
                .format("YYYY-MM-DD HH:mm");
            availab.date_start = date_start;
            availab.date_end = date_end;
            availab.f_over = 1;
            return availab;
        };

        vm.isSaving = false;
        vm.isOver = false;
        vm.sendData = function () {
            $log.info("save");
            vm.isSaving = true;
            vm.customer_updated = {};
            if (vm.isOver) {
                vm.availability = vm.initAvailabilityOver();
            }
            vm.availability.by_operator = 0;
            vm.availability.c_role = "guest";
            if (vm.isUser) {
                vm.availability.confirmed = 1;
                vm.availability.by_operator = vm.operatorId;
                vm.availability.cus_act_id = vm.cusActId;
                vm.availability.c_role = vm.userRole;
                vm.availability.type_app = vm.typeApp;
            }
            vm.availability.cus_phone = vm.customer.phone;
            if (vm.gender) {
                vm.customer.gender = vm.gender;
            }
            vm.availability.note = vm.note;
            vm.availability.paid = 0;

            if (vm.source) {
                vm.availability.source = vm.source;
            }
            if (vm.couponCode) {
                vm.availability.coupon_code = vm.couponCode;
            }
            if (vm.appCustomerId) {
                vm.availability.app_customer_id = vm.appCustomerId;
            }
            if (vm.f_prepayment) {
                /**
                 * non faccio override perchè se non viene pagato il prezzo resta intero
                 */
                //vm.priceOverride = vm.deposit;
                //vm.availability.price = vm.deposit;
                vm.availability.f_prepayment = 1;
                vm.availability.prepayment = vm.prepayment;
            }
            if (vm.f_preauth) {
                vm.availability.f_preauth = 1;
                //vm.availability.preauth_amount = vm.preauth;
                vm.availability.preauth = vm.preauth;
            }
            if (vm.f_deposit) {
                vm.availability.f_deposit = 1;
                vm.availability.deposit = vm.deposit;
            }
            Object.keys(vm.utms).forEach(function (key) {
                if (vm.utmsValues[key]) {
                    vm.availability[vm.utms[key]] = vm.utmsValues[key];
                }
            });

            if (vm.wkFlow) {
                vm.availability.wkflow = vm.wkFlow;
                vm.availability.wkStateTo = vm.wkStateTo;
                vm.availability.wkStateFrom = vm.wkStateFrom;
                vm.availability.wkEntityId = vm.wkEntityId;
            }

            /**
             * Utente nuovo
             */
            if (vm.customer.id == null) {
                CustomerService.save(vm.customer, vm.currentAPI).then(
                    function (data) {
                        data.birthdate = data.birthdate
                            ? new Date(data.birthdate)
                            : null;
                        vm.customer = data;
                        vm.availability.new_customer = 1;
                        vm.availability.customer = vm.customer;
                        vm.availability.customer_id = vm.customer.id;
                        if (vm.treatmentPrice) {
                            vm.availability.price = vm.treatmentPrice;
                        }
                        if (
                            (vm.priceOverride && vm.isCallCenter) ||
                            (vm.priceOverride &&
                                vm.priceFromSubscription === true)
                        ) {
                            vm.availability.price = vm.priceOverride;
                        }
                        vm.availability.f_oper = vm.forceFOper ? true : vm.f_oper;
                        vm.availability.flow_type = vm.getFlowType();
                        vm.availability.flow_type_capability = vm.getFlowTypeCapability();
                        AppointmentService.save(
                            vm.availability,
                            vm.currentAPI
                        ).then(
                            function () {
                                // per la pagina conferma prenotazione
                                vm.isSaving = false;
                                if (vm.isUser) {
                                    if (vm.appointmentId != null) {
                                        ngDialog.open({
                                            template:
                                                '<div class="message-dialog">Spostamento effettuato.</div>',
                                            plain: true,
                                        });
                                        vm.appointmentId = null;
                                        vm.leadId = null;
                                        vm.cantChangeCustomer = false;
                                        vm.customer = null;
                                        if (!vm.env.apis) {
                                            vm.removeLocalStorage();
                                            window.history.go(-1); // torna
                                            // all'amministrazione
                                        } else {
                                            window.close();
                                        }
                                    } else {
                                        ngDialog.open({
                                            template:
                                                '<div class="message-dialog">Prenotazione effettuata.</div>',
                                            plain: true,
                                        });
                                    }
                                    vm.monthAvailability.reset();
                                } else {
                                    $rootScope.appointment = vm.availability;
                                    /**
                                     * Traccia la presa app su analytics
                                     */
                                    ga(
                                        "set",
                                        "page",
                                        "/online-booking-completed"
                                    );
                                    ga("send", "pageview");
                                    $state.go("booking-completed");
                                }
                            },
                            function errorCallback(data) {
                                vm.isSaving = false;
                                console.log(data);
                                var message =
                                    "Errore durante la prenotazione.<br/>Riprovare o contattare direttamente il centro.";
                                if (
                                    data.data.message ==
                                    "appointment no longer available"
                                ) {
                                    message =
                                        "<h4><strong>Non è stato possibile prenotare l'appuntamento</strong> dalle ore " +
                                        moment(
                                            vm.availability.date_start
                                        ).format("LT") +
                                        " alle ore " +
                                        moment(vm.availability.date_end).format(
                                            "LT"
                                        ) +
                                        " in quanto appena prenotato da un altro operatore</h4><br/><strong>Riprovare con un altro orario o centro</strong>.<br> Grazie.";
                                } else if (vm.isUser && data.data.message) {
                                    message += "<br/>" + data.data.message;
                                }
                                ngDialog.open({
                                    template:
                                        '<div class="message-dialog">' +
                                        message +
                                        "</div>",
                                    plain: true,
                                });
                            }
                        );
                    },
                    function (data) {
                        if (!vm.isUser) {
                            $http
                                .post(
                                    (vm.env.currentAPI
                                        ? vm.env.currentAPI
                                        : vm.env.API) + "/handleerror",
                                    { params: data }
                                )
                                .then(
                                    function () {},
                                    function () {}
                                );
                        }
                        vm.isSaving = false;
                        var message =
                            "Errore durante la prenotazione.<br/>Riprovare o contattare direttamente il centro.<br/>";
                        message +=
                            "<strong>Non è stato possibile inserire il nuovo utente!</strong></br>";
                        if (vm.isUser && data.data.message) {
                            message += "<br/>" + data.data.message;
                        }
                        ngDialog.open({
                            template:
                                '<div class="message-dialog">' +
                                message +
                                "</div>",
                            plain: true,
                        });
                    }
                );
            } else {
                /*
                 * Duplicato l'utente per non ricevere errori JS dalle date
                 * di Angular
                 */
                // if(vm.appointmentId==null) {

                if (
                    vm.customer_subscription_id !== undefined &&
                    vm.customer_subscription_id !== null &&
                    vm.customer_subscription_id !== ""
                ) {
                    vm.availability.type = "abb";
                    vm.availability.customer_subscription_id = parseInt(
                        vm.customer_subscription_id
                    );
                }

                if (
                    vm.subscription_new_id !== undefined &&
                    vm.subscription_new_id !== ""
                ) {
                    vm.availability.type = "abb";
                    vm.availability.subscription_new_id = parseInt(
                        vm.subscription_new_id
                    );
                }

                angular.copy(vm.customer, vm.customer_updated);

                vm.customer_updated.birthdate = vm.customer.birthdate
                    ? moment(vm.customer.birthdate).format("YYYY-MM-DD")
                    : null;
                //evita out of memory
                delete vm.customer_updated.appointments;
                vm.availability.customer = vm.customer_updated;
                /*
                 * Duplicato l'utente per non ricevere errori JS dalle
                 * date di Angular
                 */
                /*
                 * prima era semplicemente vm.customer.birthdate =
                 * vm.customer.birthdate ? moment( vm.customer.birthdate
                 * ).format( 'YYYY-MM-DDT' ) : null;
                 */
                vm.customer.birthdate = vm.customer.birthdate
                    ? new Date(
                          moment(vm.customer.birthdate).format("YYYY-MM-DD")
                      )
                    : null;
                vm.availability.customer_id = vm.customer.id;

                if (vm.treatmentPrice) {
                    vm.availability.price = vm.treatmentPrice;
                }
                vm.availability.f_oper = vm.forceFOper ? true : vm.f_oper;
                vm.availability.flow_type = vm.getFlowType();
                vm.availability.flow_type_capability = vm.getFlowTypeCapability();

                if (
                    (vm.priceOverride >= 0 && vm.isCallCenter) ||
                    (vm.priceOverride >= 0 && vm.priceFromSubscription === true)
                ) {
                    vm.availability.price = vm.priceOverride;
                }
                // aggiorno i dati cliente (solo se sono autenticato)
                if (vm.isUser) {
                    vm.customer_updated.put();
                }
                // } else {
                vm.availability.moveFromAppId = vm.appointmentId;
                if (vm.leadId != null) {
                    vm.availability.lead_id = vm.leadId;
                }
                // }
                AppointmentService.save(vm.availability, vm.currentAPI).then(
                    function () {
                        // per la pagina conferma prenotazione
                        vm.isSaving = false;
                        if (vm.isUser) {
                            if (vm.appointmentId != null) {
                                ngDialog.open({
                                    template:
                                        '<div class="message-dialog">Spostamento effettuato.</div>',
                                    plain: true,
                                });
                                vm.monthAvailability.reset();
                                vm.appointmentId = null;
                                vm.leadId = null;
                                vm.cantChangeCustomer = false;
                                vm.customer = null;
                                if (!vm.env.apis) {
                                    vm.removeLocalStorage();
                                    window.history.go(-1); // torna
                                    // all'amministrazione
                                } else {
                                    window.close();
                                }
                            } else {
                                ngDialog.open({
                                    template:
                                        '<div class="message-dialog">Prenotazione effettuata.</div>',
                                    plain: true,
                                });
                                vm.monthAvailability.reset();
                            }
                        } else {
                            $rootScope.appointment = vm.availability;
                            /**
                             * Traccia la presa app su analytics
                             */
                            ga("set", "page", "/online-booking-completed");
                            ga("send", "pageview");
                            $state.go("booking-completed");
                        }
                    },
                    function errorCallback(data) {
                        if (!vm.isUser) {
                            $http
                                .post(
                                    (vm.env.currentAPI
                                        ? vm.env.currentAPI
                                        : vm.env.API) + "/handleerror",
                                    { params: data }
                                )
                                .then(
                                    function () {},
                                    function () {}
                                );
                        }
                        vm.isSaving = false;
                        var message =
                            "Errore durante la prenotazione.<br/>Riprovare o contattare direttamente il centro.";
                        if (
                            data.data.message ==
                            "appointment no longer available"
                        ) {
                            message =
                                "<h4><strong>Non è stato possibile prenotare l'appuntamento</strong> dalle ore " +
                                moment(vm.availability.date_start).format(
                                    "LT"
                                ) +
                                " alle ore " +
                                moment(vm.availability.date_end).format("LT") +
                                " in quanto appena prenotato da un altro operatore</h4><br/><strong>Riprovare con un altro orario o centro</strong>.<br> Grazie.";
                        } else if (vm.isUser && data.data.message) {
                            message += "<br/>" + data.data.message + ".";
                        }
                        ngDialog.open({
                            template: "<p>" + message + "</p>",
                            plain: true,
                        });
                    }
                );
            }
        };

        // Check for User logged-in
        vm.redirectLogout = function () {
            $state.go("booking-notauthorized");
        };
        vm.removeLocalStorage = function () {
            localStorage.removeItem("Biolaser_token");
            localStorage.removeItem("user");
        };
        if (!token && !vm.env.apis && !vm.env.anonymous_access === false) {
            vm.removeLocalStorage();
        } else if (
            (vm.env.apis || vm.env.anonymous_access === false) &&
            !token
        ) {
            token = localStorage.getItem("Biolaser_token");
        }
        vm.doLogin = function () {
            var data = {
                email: vm.loginEmail,
                password: vm.loginPassword,
                version: vm.version,
            };
            vm.loading = true;
            $auth.login(data).then(
                function (response) {
                    vm.token = response.data.token;
                    // alert (vm.token);
                    vm.initOperatorByToken(vm.token);
                    vm.loading = false;
                },
                function (error) {
                    // $log.info( error );
                    var msg = "";
                    var wrongVersion = false;
                    if (
                        error != null &&
                        error.data != null &&
                        error.data.error != null
                    ) {
                        msg = "\n" + error.data.error;
                        wrongVersion = error.data.wrongVersion;
                    }
                    alert("Autenticazione fallita." + msg);
                    vm.loading = false;
                    if (wrongVersion) {
                        $window.location.reload();
                    }
                    return;
                }
            );
        };
        vm.initOperatorByToken = function (token) {
            vm.loading = true;
            localStorage.setItem("Biolaser_token", token);
            UserService.logIn(token, userRole).then(function (response) {
                if (response.data.user) {
                    localStorage.setItem(
                        "user",
                        angular.toJson(response.data.user)
                    );
                    /* Operatore connesso */
                    var user = angular.fromJson(localStorage.getItem("user"));
                    if (user) {
                        // vm.operator = user;
                        vm.user = user;
                        angular.forEach(vm.user.roles, function (r) {
                            if (
                                r.active &&
                                userRole == r.role &&
                                r.store_id == userSid
                            ) {
                                vm.user.type = userRole;
                                vm.user.color = r.color;
                                vm.user.store_id = userSid;
                                vm.user.config = r.config;

                                //VITRUVIAN MAN ENABLED
                                vm.vitruvianManEnabled = vm.config.get("vitruvian-man.enabled", false);
                            }
                        });
                        vm.reserved = undefined;
                        if (userRole == "operator" || userRole == "storemngr" || userRole == "manager") {
                            vm.isStoreUser = true;
                            vm.reservedOptionsList[1].value = 2; // posso
                            // filtrare
                            // sui
                            // riservati
                            // centro
                        } else {
                            vm.isStoreUser = false;
                            vm.reservedOptionsList[1].value = 1; // posso
                            // filtrare
                            // sui
                            // riservati
                            // commerciale
                        }
                        vm.setUserAlias(user, user);
                        vm.operatorId = user.id;
                        vm.user_type = user.type;
                        vm.isCallCenter =
                            vm.user_type === "callcenter" ||
                            vm.user_type === "admin"
                                ? true
                                : false;

                        vm.showOperators = vm.config.get("booking.operators.show", true);
                        if (vm.user_type === 'admin') {
                            vm.showOperators = true;
                        }
                        vm.checkCapabilitiesByStore = vm.config.get("availability.checkcapabilities.bystore", false);
                        vm.checkCapabilitiesDefaultValue = vm.config.get("availability.checkcapabilities.defaultvalue", true);
                        vm.appointmentTypeCheck = vm.config.get("appointments.type.check", false);

                        vm.enableCapabilitiesSpeed = vm.config.get('capabilities.speed.enabled', false);
                        vm.capabilitiesField = vm.enableCapabilitiesSpeed ? 'man_speed' : 'man';

                        vm.canSeeDuration = vm.user.type === 'admin' || vm.user.type === 'callcenter';
                        vm.canForceFOper = vm.user.type === 'admin' || (vm.user.type === 'callcenter' && vm.user.ext_f_appointments);

                        vm.refreshRolesList();

                        /*if (!vm.env.apis) {
                                        vm.loadStores();
                                    }*/
                        /**
                         * Inizializzo promo
                         */
                        // if (
                        //     vm.user_type === "callcenter" &&
                        //     vm.user.tag_area != "INBOUND"
                        // ) {
                        //     vm.typeApp = "promo";
                        // }
                        /**
                         * Inizializzo cliente se presente
                         */
                        if (vm.customerId && vm.isUser) {
                            vm.customer.phone = vm.customerId;
                            vm.checkCustomer();
                        }
                    } else {
                        vm.doLogout();
                    }
                }
                vm.loading = false;
                vm.initialized = true;
            }, vm.doLogout);
        };

        vm.config.get = function(key, defaultValue) {
            var result = null;
            var resultOnRole = null;
            angular.forEach(vm.user.config, function(el) {

                if (el.key==key && (el.role==null || el.role==vm.user.type)) {

                    var tmpResult = null;
                    try {
                        switch (el.type) {
                            case "int":
                                tmpResult = parseInt(el.value);
                                break;
                            case "boolean":
                                switch(el.value.toLowerCase().trim()) {
                                    case "true": ;
                                    case "yes": ;
                                    case "1": {
                                        tmpResult = true;
                                        break;
                                    }
                                    case "false": ;
                                    case "no": ;
                                    case "0": {
                                        tmpResult = false;
                                        break;
                                    }
                                    default:
                                        tmpResult = false;
                                }
                                break;
                            case "object":
                                tmpResult = angular.fromJson(el.value);
                                break;
                            case "string":
                                tmpResult = el.value;
                                break;
                            default:
                                break;
                        }
                        if (el.role==null) {
                            result = tmpResult;
                        } else {
                            resultOnRole = tmpResult;
                        }
                    } catch (error) {
                        $log.error("Errore carivamento config: ");
                        $log.info(el);
                        $log.error(error);
                    }
                }

            });
            var res = null;
            if (resultOnRole != null) {
                res = resultOnRole;
            } else if (result == null) {
                res = defaultValue;
            } else {
                res = result;
            }
            $log.info("config.get "+key+ " is " +res);
            return res;
        };

        vm.doLogout = function () {
            TokenService.delete()
                .finally($auth.logout)
                .finally(function () {
                    vm.removeLocalStorage();
                    vm.loading = false;
                    vm.initialized = true;
                    if (vm.isUser) {
                        vm.user = null;
                        if (
                            !vm.env.apis &&
                            !vm.env.anonymous_access === false
                        ) {
                            return vm.redirectLogout();
                        }
                    }
                });
        };
        vm.state = $state;
        if (
            vm.env.apis ||
            vm.env.anonymous_access === false ||
            $state.current.name === "booking-operator"
        ) {
            if (token) {
                vm.initOperatorByToken(token);
            } else {
                vm.initialized = true;
            }
        } else {
            // vm.loadStores();
        }
    }

    function BookingNotAuthorizedController($rootScope, env, $log) {
        var vm = this;
        vm.env = env;
        //console.log(env);
        $log.info("BookingNotAuthorizedController");
        ga("set", "page", "/notauthorized");
        ga("send", "pageview");
    }

    function BookingCompletedController($rootScope, env, $log) {
        var vm = this;
        vm.appointment = $rootScope.appointment;
        vm.env = env;
        $log.info("BookingCompletedController");
        $log.info(env);
    }

    function BookingPaymentErrorController($log, env){
        var vm = this;
        vm.env = env;
        $log.info('BookingPaymentErrorController');
        //ga('set', 'page', '/completed');
        //ga('send', 'pageview');
    }

    function BookingPaymentSuccessController($log, env, type){
        var vm = this;
        vm.env = env;
        $log.info('BookingPaymentSuccessController', type);
        vm.type = type;
        //ga('set', 'page', '/completed');
        //ga('send', 'pageview');
    }

    function BookingPaymentCancelController($log, env, type){
        var vm = this;
        vm.env = env;
        $log.info('BookingPaymentCancelController', type);
        vm.type = type;
        //ga('set', 'page', '/completed');
        //ga('send', 'pageview');
    }
})();

(function() {
  'use strict';

  angular
    .module('biolaser')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('biolaser')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    /*$stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });*/

    $urlRouterProvider.otherwise('/');
  }

})();

angular.module('biolaser')
.constant('env', {"tenant":"Bologna","domain":"biosmed.it","company":"Biosmed","info_email":"info@biosmed.it","info_number":"xxx xxxxxxx","privacy_url":"//www.iubenda.com/privacy-policy/xxxxxxxx","anonymous_access":false,"captcha":{"key":"6Ld5G9UZAAAAANC4qQl2cmdbpObSrhwuMnLnSpEA"},"API":"https://api-test.biosmed.it/api","booking":"https://booking-test.biosmed.it","admin":"https://admin-test.biosmed.it","show":{"price":false,"filter_promo":true,"filter_reserved":true},"enabled":{"deposit":true},"stripe":{"public_key":"pk_test_51Q0PeL2ejfIki74Y9nnP9V0oGqNXQhByBtFvNKb6S8EYFXXYjm5jfTaDyJ9Q19HxJhGL3yc3X3mPiuZFFPb6NVct00yNTmDr2p"}});

(function() {
    'use strict';

    angular
        .module('biolaser')
        .config(config)
    ;

    /** @ngInject */
    function config(
        env,
        $logProvider,
        $locationProvider,
        $authProvider,
        $provide,
        $httpProvider,
        uiGmapGoogleMapApiProvider,
        RestangularProvider
    ) {
        // Enable log
        $logProvider.debugEnabled( false );
        $locationProvider.html5Mode( true );
        /* Google Maps */
        if (!env.googleMap || env.googleMap.key) {
	        uiGmapGoogleMapApiProvider.configure({
	            key : env.googleMap?env.googleMap.key:'AIzaSyCtcc0wbPJDAGw1vdVnh7IgIaZcOLEPUZg'
	        });
        }
        /* Auth Settings */
        $authProvider.tokenPrefix = 'Biolaser';
        $authProvider.loginUrl = env.API+'/auth/token';
        /* Factory Interceptor */
        $provide.factory( 'redirectWhenLoggedOut', function( $q, $injector ) {
            return {
                responseError: function( rejection ) {
                    var rejectionReasons = [
                            'token_not_provided',
                            'token_expired',
                            'token_absent',
                            'token_invalid',
                        ]
                        , env =  $injector.get('env')
                        , $log =  $injector.get('$log')
                    ;
                	angular.forEach( rejectionReasons, function( value ) {
                        if( rejection.data ) {
                            if( rejection.data.error === value ) {
                            	/* Rimozione token in ogni caso o solo in quelli specificati nelle rejectionReasons? */
                                localStorage.removeItem( 'user' );
                                localStorage.removeItem( 'Biolaser_token' );
                                window.location.replace( env.booking + '/notauthorized?reason='+rejection.data.error );
                                //window.location.replace( env.admin + '/dashboard?logout=1' );
                            };
                        };
                    });
                    // if( rejection.data.status_code === 404 ) { alert("Elemento non trovato!"); };
                    return $q.reject( rejection );
                },
            };
        });
        $httpProvider.interceptors.push( 'redirectWhenLoggedOut' );
        // RestAngular
        RestangularProvider.setBaseUrl( env.API );
        RestangularProvider.setResponseExtractor( function( response ) {
            return response.data;
        });
        RestangularProvider.setDefaultHeaders( { 'Authorization': 'Bearer ' + localStorage.getItem( 'Biolaser_token' ) } );
    };
})();

angular.module("biolaser").run(["$templateCache", function($templateCache) {$templateCache.put("app/booking/booking.html","<div ng-if=\"booking.config.data.disabled && !booking.loadingNewBooking\" class=\"container page-booking\" ng-class=\"{isuser: booking.isUser, isclient: booking.isClient, isloading: booking.loading, islandingtreatment: booking.landing.treatment_id, islandingstore: booking.landing.store_id }\"><header class=\"main-header full-width\"><div class=\"message\" ng-if=\"!booking.config.data.message\">Prenotazione momentaneamente disabilitata.</div><div class=\"message\" ng-if=\"booking.config.data.message\" ng-bind-html=\"booking.config.data.message\"></div><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant!=\'Bios\'\" class=\"logo\"></div><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div><div class=\"banner\" ng-if=\"!booking.isUser && !booking.env.apis\"></div></header></div><div ng-if=\"!booking.config.data.disabled && !booking.loadingNewBooking\" class=\"container page-booking\" ng-class=\"{isuser: booking.isUser, isclient: booking.isClient, isloading: booking.loading, islandingtreatment: booking.landing.treatment_id, islandingstore: booking.landing.store_id }\"><header class=\"main-header full-width\"><div class=\"message\" ng-if=\"booking.config.data.message\" ng-bind-html=\"booking.config.data.message\"></div><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant!=\'Bios\'\" class=\"logo\"></div><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div><div class=\"banner\" ng-if=\"!booking.env.hideBanner && !booking.isUser && !booking.env.apis\"></div></header><section><h4 style=\"text-align: center; margin-left: 130px; margin-top: -50px;\'\" ng-if=\"booking.user!=null\">v{{booking.version}} | <b>{{ booking.env.apis?\'Italia\':booking.env.company }}</b> | <span ng-if=\"booking.user.type==\'operator\' || booking.user.type==\'storemngr\' || booking.user.type==\'manager\'\" class=\"operator-circle\" style=\"background-color: {{ booking.user.color }};\"></span> <span>{{booking.user.firstname}} {{booking.user.lastname}}</span> <span ng-if=\"booking.user.type!=\'operator\' && booking.user.type!=\'storemngr\' && booking.user.type!=\'manager\'\">[{{booking.user.type}}]</span> <span ng-if=\"booking.user.type==\'operator\' || booking.user.type==\'storemngr\' || booking.user.type==\'manager\'\">[{{booking.user.store.alias}}<span ng-if=\"booking.user.type==\'storemngr\' || booking.user.type==\'manager\'\">*</span>]</span> <span ng-if=\"booking.leadId!=null\">| App. da lead</span> <span ng-if=\"booking.cusActId!=null\">| App. da rullo</span></h4><h1 ng-if=\"!booking.landing.treatment_id && booking.appointmentId==null && (booking.tenantDataLoaded || booking.tenantFixed) && (booking.env.anonymous_access || booking.user)\" class=\"title title-main\">Prenota un appuntamento <span ng-if=\"booking.treatment\">{{booking.treatment.name}}</span><span ng-show=\"booking.env.apis\">| Area: {{ booking.tenant}}</span></h1><h6 ng-if=\"(booking.source | lowercase) == \'app\'\" class=\"title title-app-coupon\">Eventuali sconti verranno applicati al momento del pagamento.</h6><h1 class=\"title title-main\" style=\"font-size: 2.1rem;\" ng-if=\"booking.leadId && booking.campagna && (booking.tenantDataLoaded || booking.tenantFixed) && (booking.env.anonymous_access || booking.user)\">per la campagna <i>{{booking.campagna}}</i></h1><h1 ng-if=\"!booking.landing.treatment_id && booking.appointmentId==null && !booking.tenantDataLoaded && booking.isUser && booking.user && booking.env.apis && !booking.tenantFixed\" class=\"title title-main\">Effettuare la scelta dell\'area per la prenotazione</h1><h1 ng-if=\"!booking.landing.treatment_id && booking.appointmentId!=null && booking.isUser && booking.user\" class=\"title title-main\">Sposta appuntamento di {{booking.customer.firstname}} ({{booking.customer.phone}}) per {{booking.treatmentOrig.name}} del giorno {{booking.appointmentDate}} <span ng-show=\"booking.env.apis\">| Area: {{ booking.tenant}}</span></h1><h1 ng-if=\"booking.landing.treatment_id && !booking.user && booking.customer.id\" class=\"title title-main\">Benvenut{{booking.customer.gender==\'F\'?\'a\':(booking.customer.gender==\'M\'?\'o\':\'a/o\')}} {{booking.customer.firstname}}</h1><h1 ng-if=\"booking.landing.treatment_id\" class=\"title title-main\"><span ng-if=\"booking.appointment.id\">Sposta</span>{{booking.landing.title}}</h1><h4 style=\"text-align: center;\" ng-if=\"booking.landing.treatment_id && booking.appointment.id\">La prenotazione precedente era fissata per il {{booking.appointmentDate}}</h4><md-progress-circular style=\"text-align: center; margin: 50px;\" md-mode=\"indeterminate\" ng-if=\"booking.loadingTreatments\"></md-progress-circular></section><form name=\"booking.customerForm\" role=\"form\" autocomplete=\"off\" novalidate=\"\"><section class=\"row box box-tenant-data centered\" ng-if=\"!booking.user && booking.initialized && (booking.env.apis || booking.env.anonymous_access===false)\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Inserisci le credenziali di accesso</h3></div><div class=\"col-md-12 box-body centered\"><div class=\"user-select\" ng-if=\"true\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': booking.customerForm.email.$touched && booking.customerForm.email.$invalid }\"><label for=\"email\" class=\"label-input\">Email:</label> <input ng-disabled=\"booking.loading || booking.user\" id=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" ng-model=\"booking.loginEmail\" required=\"\"><div class=\"help-block\" ng-messages=\"booking.customerForm.email.$error\" ng-show=\"booking.customerForm.email.$touched\"><div ng-message=\"required\">Campo Obbligatorio</div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': booking.customerForm.password.$touched && booking.customerForm.password.$invalid }\"><label for=\"password\" class=\"label-input\">Password:</label> <input ng-disabled=\"booking.loading || booking.user\" id=\"password\" name=\"password\" type=\"password\" class=\"form-control\" placeholder=\"Password\" ng-model=\"booking.loginPassword\" required=\"\"><div class=\"help-block\" ng-messages=\"booking.customerForm.password.$error\" ng-show=\"booking.customerForm.password.$touched\"><div ng-message=\"required\">Campo Obbligatorio</div></div></div></div><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.doLogin()\" ng-disabled=\"booking.loading || booking.user || booking.customerForm.$invalid\"><img src=\"assets/images/loading.svg\"> <span>Entra</span></button></div></section><section class=\"row box box-tenant-data centered\" ng-if=\"booking.isUser && booking.user && booking.env.apis && !booking.tenantFixed\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Scelta area</h3></div><div class=\"col-md-12 box-body centered\"><div class=\"row\"><radio-buttons ng-show=\"booking.isUser\" options=\"booking.tenantsList\" ng-model=\"booking.tenant\" ng-click=\"booking.changeTenant()\"></radio-buttons></div><div><h2>Area scelta: <b>{{booking.tenant}}</b></h2></div><br><span>{{booking.tenantMsg}}</span><br><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.confirmTenant()\" ng-disabled=\"booking.loading || !booking.tenant || booking.tenantDataLoaded\"><img src=\"assets/images/loading.svg\"> <span>Conferma</span></button></div></section><div class=\"switch-boxes\" ng-class=\"{ reverse: booking.isUser || !booking.isUser }\"><div class=\"switch-item1\" ng-if=\"booking.tenantDataLoaded && (!booking.env.tenant==\'Italia\' || booking.user || !booking.isUser)\"><section class=\"row box box-stores\" ng-if=\"!booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.storesTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"form-group row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-1 col-md-10\"><span ng-if=\"booking.storeIdParam && ((booking.source | lowercase) == \'app\')\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-location_city\"></i></div><input type=\"text\" class=\"form-control\" ng-value=\"(booking.store.name+\' - \'+booking.store.city+\' - \'+booking.store.address)\" ng-disabled=\"true\"></div></span> <span ng-if=\"booking.storesList.length>1 && ((!booking.storeIdParam) || (booking.source | lowercase) != \'app\')\"><label for=\"storesList\" class=\"label-input\">Scegli una clinica</label><select ng-disabled=\"booking.loading || booking.monthAvailability.loading\" class=\"form-control select-store\" id=\"storesList\" ng-model=\"booking.store\" ng-options=\"(store.name+\' - \'+store.city+\' - \'+store.address) group by store.city for store in booking.storesList | filter : {active: 1}: true\" ng-change=\"booking.storeSelected()\"></select></span><div class=\"cta-wrap call-wrap centered\" ng-if=\"booking.storeId && !booking.store.booking_online\"><h3>In questo centro puoi solamente <strong>prenotare telefonicamente</strong></h3><a class=\"or-call centered\" ng-if=\"!booking.isUser\" href=\"tel:{{booking.store.phone}}\"><div class=\"call-icon\"><i class=\"icon-phone\"></i></div><div class=\"call-info\"><div class=\"call-number\">{{booking.store.phone}}</div></div><div class=\"clearfix\"></div></a></div><div class=\"user-select\" ng-if=\"booking.config.data.selectoper_enabled && booking.store.booking_online && booking.showOperators\"><label for=\"usersList\" class=\"label-input\">Scegli un operatore</label><md-select ng-disabled=\"booking.operatorSelectionDisabled || booking.loading || booking.monthAvailability.loading\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"usersList\" name=\"usersList\" aria-label=\"Selezione operatore\" ng-model=\"booking.operator.id\" ng-change=\"booking.operatorSelected()\" ng-required=\"false && booking.isUser && booking.user && booking.user.type == \'operator\' && booking.env.config && booking.env.config.select_operator_first && (!booking.customer || booking.customer.user_times>=1)\"><md-option value=\"\"></md-option><md-option ng-value=\"op.user_id\" ng-repeat=\"op in booking.rolesList | orderBy: \'user.firstname\': true track by op.id\"><span ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ op.color }};\"></span> {{ op.user.firstname }} <span ng-if=\"booking.isUser\">{{ op.user.lastname }}</span> <span ng-if=\"!booking.isUser\">{{ op.user.lastname!=null && op.user.lastname.substring(0,1) + \'.\' }}</span></md-option></md-select><div class=\"help-block\" ng-messages=\"booking.customerForm.usersList.$error\" \"=\"\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"user-select\" style=\"text-align: left;\" ng-if=\"booking.isUser && booking.treatment.f_prepayment && booking.treatment.prepayment_price\"><div layout=\"row\"><div><div layout=\"row\" class=\"md-block\"><md-checkbox ng-model=\"booking.f_prepayment\" ng-disabled=\"booking.loading || booking.appointmentId\" ng-change=\"booking.prepaymentSelected()\">Richiedi pagamento anticipato</md-checkbox></div></div></div><div layout=\"row\" ng-if=\"booking.f_prepayment\"><div flex=\"30\"><label for=\"prepayment\" class=\"label-input\">Importo pag. anticipato (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"prepayment\" name=\"prepayment\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Importo pag. anticipato\" ng-model=\"booking.prepayment\"></div><div flex=\"5\"><i ng-if=\"booking.appointment && booking.appointment.f_prepayment && booking.appointment.deposit && booking.appointment.deposit.data && booking.appointment.deposit.data.paid\" class=\"icon-done\"></i> <i ng-if=\"booking.appointment && booking.appointment.f_prepayment && booking.appointment.deposit && booking.appointment.deposit.data && !booking.appointment.deposit.data.paid\" class=\"icon-error\"></i></div><div flex=\"30\"><label for=\"prepayment_price\" class=\"label-input\">Prezzo con pag. anticipato (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"prepayment_price\" name=\"prepayment_price\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Prezzo con pag. anticipato\" ng-model=\"booking.prepayment_price\"></div><div flex=\"5\"></div><div flex=\"30\"><label for=\"prepayment_residuo\" class=\"label-input\">Residuo (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"prepayment_residuo\" name=\"prepayment_residuo\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Residuo\" ng-model=\"booking.prepayment_residuo\"></div></div></div><div class=\"user-select\" style=\"text-align: left;\" ng-if=\"booking.isUser && booking.treatment.f_deposit && booking.treatment.deposit_price && booking.treatment.deposit_amount\"><div layout=\"row\"><div><div layout=\"row\" class=\"md-block\"><md-checkbox ng-disabled=\"booking.loading || booking.appointmentId\" ng-model=\"booking.f_deposit\" ng-change=\"booking.depositSelected()\">Richiedi pagamento acconto</md-checkbox></div></div></div><div layout=\"row\" style=\"text-align: left;\" ng-if=\"booking.f_deposit\"><div flex=\"30\"><label for=\"deposit\" class=\"label-input\">Importo acconto (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"deposit\" name=\"deposit\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Importo acconto\" ng-model=\"booking.deposit\"></div><div flex=\"5\"><i ng-if=\"booking.appointment && booking.appointment.f_deposit && booking.appointment.deposit && booking.appointment.deposit.data && booking.appointment.deposit.data.paid\" class=\"icon-done\"></i> <i ng-if=\"booking.appointment && booking.appointment.f_deposit && booking.appointment.deposit && booking.appointment.deposit.data && !booking.appointment.deposit.data.paid\" class=\"icon-error\"></i></div><div flex=\"30\"><label for=\"deposit_price\" class=\"label-input\">Prezzo con pag. acconto (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"deposit_price\" name=\"deposit_price\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Prezzo con pagamento acconto\" ng-model=\"booking.deposit_price\"></div><div flex=\"5\"></div><div flex=\"30\"><label for=\"deposit_residuo\" class=\"label-input\">Residuo (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"deposit_residuo\" name=\"deposit_residuo\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Residuo\" ng-model=\"booking.deposit_residuo\"></div></div></div><div class=\"user-select\" style=\"text-align: left;\" ng-if=\"booking.isUser && booking.treatment.f_preauth && booking.treatment.preauth_price && booking.treatment.preauth_amount\"><div layout=\"row\"><div><div layout=\"row\" class=\"md-block\"><md-checkbox ng-disabled=\"booking.loading || booking.appointmentId\" ng-model=\"booking.f_preauth\" ng-change=\"booking.preauthSelected()\">Richiedi pagamento pre-autorizzato</md-checkbox></div></div></div><div layout=\"row\" style=\"text-align: left;\" ng-if=\"booking.f_preauth\"><div flex=\"45\"><label for=\"preauth\" class=\"label-input\">Importo pre-autorizzato (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"preauth\" name=\"deposit\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Importo pre-autorizzato\" ng-model=\"booking.preauth\"></div><div flex=\"10\" style=\"margin-top: 30px; padding: 5px;\"><i ng-if=\"booking.appointment && booking.appointment.deposit && booking.appointment.deposit.data && booking.appointment.deposit.data.preauth_paid\" class=\"icon-done\"></i> <i ng-if=\"booking.appointment && booking.appointment.deposit && booking.appointment.deposit.data && !booking.appointment.deposit.data.preauth_paid\" class=\"icon-error\"></i></div><div flex=\"45\" ng-if=\"booking.f_preauth\"><label for=\"preauth_price\" class=\"label-input\">Prezzo con pag. pre-autorizzato (&euro;)</label> <input ng-disabled=\"true\" type=\"number\" id=\"preauth_price\" name=\"preauth_price\" step=\"0.01\" min=\"0\" class=\"form-control\" placeholder=\"Prezzo con pagamento pre-autorizzato\" ng-model=\"booking.preauth_price\"></div></div></div></div></div><div ng-if=\"!booking.env.hideStoreImages && !booking.isUser\"><div class=\"selected-line\"><span>{{booking.store.name}}</span> - {{booking.store.city}} - {{booking.store.address}}<br><a class=\"btn btn-default btn-sm navigate\" target=\"_blank\" href=\"https://maps.google.com?daddr={{booking.store.coordinates.latitude}},{{booking.store.coordinates.longitude}}\"><i class=\"icon-near_me\"></i>Indicazioni</a></div><ui-gmap-google-map ng-if=\"!booking.env.googleMap || booking.env.googleMap.key\" class=\"disable-map\" center=\"booking.store.coordinates\" zoom=\"booking.map.zoom\" options=\"booking.map.options\"><ui-gmap-markers models=\"booking.storesList\" coords=\"\'coordinates\'\" icon=\"\'icon\'\"></ui-gmap-markers></ui-gmap-google-map><div class=\"gallery row\"><div class=\"pic col-xs-6 col-sm-3\" ng-repeat=\"image in booking.store.gallery\"><a ng-click=\"booking.openLightboxModal($index)\"><img ng-src=\"{{image.thumbUrl}}\"></a></div></div></div></div><div class=\"step_number\"><strong>{{ booking.storesStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section><section class=\"row box box-treatments\" ng-show=\"!(booking.landing && booking.customerId) && !booking.birthdate && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.treatmentsTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><radio-buttons ng-if=\"false\" ng-show=\"booking.isUser\" options=\"booking.typeAppList\" ng-model=\"booking.typeApp\"></radio-buttons><div class=\"row\" ng-if=\"booking.treatmentIdParam && ((booking.source | lowercase) == \'app\')\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-1 col-md-10\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-check\"></i></div><input type=\"text\" name=\"treatment_selected\" class=\"form-control\" placeholder=\"Trattmento selezionato\" ng-model=\"booking.treatment.name\" ng-disabled=\"true\"></div></div></div><div class=\"row\" ng-if=\"(!booking.treatmentIdParam) || ((booking.source | lowercase) != \'app\')\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-1 col-md-10\"><uib-tabset active=\"booking.active_treatment_category_id\" justified=\"true\" class=\"custom-tabs\"><uib-tab ng-repeat=\"tab in booking.treatmentsList\" index=\"tab.id\" ng-hide=\"booking.landing.treatment_id\" ng-if=\"tab | showTabFilter:booking.gender:booking.landing.treatment_id\"><uib-tab-heading><div ng-if=\"tab.id > 0\"><div class=\"mini-txt\">trattamenti</div>{{tab.name}}</div><div ng-if=\"tab.id == 0\"><div class=\"mini-txt\">{{tab.name}}</div>Trattamenti</div></uib-tab-heading><div class=\"input-group\" style=\"margin-top: 20px;\"><div class=\"input-group-addon\"><i class=\"icon-search\"></i></div><input type=\"text\" name=\"search_treatment\" class=\"form-control\" placeholder=\"\" ng-model=\"booking.search_treatment\" ng-disabled=\"false\"></div><div class=\"custom-select\"><div ng-repeat=\"treatment in tab.treatments.data | filter: {\'active\':1} : true | searchTreatment:tab.id:booking.treatment:booking.search_treatment | getGenderTreatmentsFilter:booking.gender:booking.landing.treatment_id | orderBy: [\'order\',\'name\']\" class=\"row custom-select-element {{booking.treatmentId==treatment.id?\'active\':\'\'}}\" ng-disabled=\"booking.appointment && booking.appointment.deposit && booking.appointment.deposit.data\" ng-model=\"booking.treatmentId\" uib-btn-radio=\"treatment.id\"><table><tr><td class=\"treatment-name\"><div class=\"treatment-title\">{{treatment.name}}</div><div class=\"treatment-time opacity-70\" ng-if=\"booking.canSeeDuration\"><i class=\"icon-alarm\"></i> {{treatment.duration}} min</div></td><td class=\"treatment-details\" ng-if=\"(booking.env.show_price==undefined || booking.env.show_price) && !booking.customer_subscription_id\"><div class=\"treatment-price\" ng-if=\"booking.landing.price\" ng-bind-html=\"booking.treatmentPrice | labelRadioButtonFilter: \'euro\'\"></div><div class=\"treatment-price\" ng-if=\"!booking.landing.price\" ng-bind-html=\"treatment.start_price | labelRadioButtonFilter: \'euro\'\"></div></td><td class=\"treatment-details\" style=\"padding-left:1rem;\" ng-if=\"(booking.env.show_price==undefined || booking.env.show_price) && !booking.customer_subscription_id && !booking.landing.price\"><div class=\"treatment-price treatment-price-promo\" ng-if=\"treatment.promo_price\" ng-bind-html=\"treatment.promo_price | labelRadioButtonFilter: \'euro\'\"></div></td></tr></table></div></div><div class=\"row treatment-list-separator\"><div class=\"col-xs-12\"><hr></div></div><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-check\"></i></div><input type=\"text\" name=\"treatment_selected\" class=\"form-control\" placeholder=\"Trattmento selezionato\" ng-model=\"booking.treatment.name\" ng-disabled=\"true\"></div><div class=\"tab-footer row\" ng-if=\"false && !booking.isUser\"><div class=\"tab-footer-image col-xs-12 col-sm-4\"><img ng-src=\"{{booking.treatment.image}}\"></div><div class=\"tab-footer-description col-xs-12 col-sm-8\" ng-bind-html=\"booking.treatment.description\"></div></div></uib-tab></uib-tabset></div></div><md-input-container style=\"margin-bottom:0;\" class=\"md-block\" ng-if=\"booking.treatment && booking.treatment.promo_price && !booking.customer_subscription_id\"><md-checkbox ng-model=\"booking.isPromo\" ng-change=\"booking.checkTypeApp()\">Usa prezzo <strong class=\"text-primary\">Promo</strong></md-checkbox></md-input-container><md-input-container style=\"margin-bottom:0;\" class=\"md-block\" ng-if=\"booking.canForceFOper && !booking.f_oper\"><md-checkbox ng-model=\"booking.forceFOper\" ng-change=\"booking.operatorSelected()\">Forza trattamento operativo</md-checkbox></md-input-container></div><div class=\"step_number\"><strong>{{ booking.treatmentsStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section><div class=\"centered\" ng-if=\"!(booking.landing && !booking.user) && booking.store.booking_online && !booking.existLeadComm\"><div class=\"alert alert-primary\" ng-if=\"booking.customer.customer_subscriptions_active.length > 0 && !booking.landing.treatment_id && !booking.birthdate && booking.customer_subscription_id === null\">È presente un abbonamento attivo: prima di cercare disponibilità, scegli quale usare.</div><button id=\"btn-load_ava\" class=\"btn btn-success btn-mega\" ng-click=\"booking.monthAvailability.load()\" ng-disabled=\"booking.customerForm.$invalid || booking.storeId == null || (booking.isUser && booking.customer == null) || (booking.isUser && booking.customer.phone == null) || booking.monthAvailability.loading || booking.monthAvailability.isCurrentYmLoaded || booking.loadingTreatments || (booking.customer.customer_subscriptions_active.length > 0 && !booking.landing.treatment_id && !booking.birthdate && booking.customer_subscription_id === null)\"><img src=\"assets/images/loading.svg\"><span>Cerca disponibilità</span></button></div><section class=\"row box box-datetime\" ng-if=\"booking.store.booking_online && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.dateTimeTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><table ng-if=\"booking.isUser && booking.debug\" class=\"capabilities col-md-offset-2 col-md-8\"><thead><tr><td></td><td></td><td>Man.</td><td style=\"text-align: right;\">Redd/H.</td><td style=\"text-align: right;\">Scontr. M.P.</td><td style=\"text-align: right;\">Max App.</td></tr></thead><tbody><tr ng-repeat=\"role in booking.rolesList | orderBy : \'c_capability.check_m_pond\' : true\" ng-click=\"booking.operatorFilter(role)\" class=\"{{ role.user_id == booking.operator.id ? \'selected\': (role.c_capability.man==0?\'disabled\':\'\') }}\"><td><div class=\"operator-circle\" style=\"background-color: {{ role.color }};\"></div></td><td><span data-tooltip=\"uid={{ role.user_id }}\">{{ role.user.firstname }} {{ role.user.lastname }}</span></td><td><ng-rate-it ng-model=\"role.c_capability.man\" read-only=\"true\" min=\"0\" max=\"3\"></ng-rate-it></td><td style=\"text-align:right;\"><span>{{ role.c_capability.reddh }}</span></td><td style=\"text-align:right;\"><span>{{ role.c_capability.check_m_pond }}</span></td><td style=\"text-align:right;\"><span>{{ role.c_capability.max_daily_app }}</span></td></tr></tbody></table><div class=\"row\"><div class=\"{{ booking.isUser ? \'col-xs-offset-0 col-xs-12 col-md-offset-3 col-md-6\': \'col-xs-offset-0 col-xs-12 col-md-offset-3 col-md-6\' }}\"><div class=\"calendar-box\"><span ng-if=\"booking.isUser && booking.gp!=null && booking.gp!=0\" class=\"opacity-70\">Groupon prenotati il {{ booking.date4Labels.format(\'DD/MM/YYYY\') }}:</span> <strong ng-if=\"booking.isUser && booking.gp!=null && booking.gp!=0\">{{ booking.gp }}</strong><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\"><img src=\"assets/images/loading.svg\"></div></div></div><uib-datepicker ng-model=\"booking.date\" ng-change=\"booking.dateSelected()\" datepicker-options=\"booking.inlineOptions\" class=\"custom-datepicker well well-sm\"></uib-datepicker></div><div ng-if=\"booking.config.data.overbooking_enabled && booking.isOver\"><h4>{{ booking.date_frmt }}</h4></div><div><h3>{{booking.event2Show.title}}</h3><p><b>{{booking.event2Show.note}}</b></p></div><div layout=\"row\" layout-align=\"center\" ng-if=\"booking.config.data.overbooking_enabled && booking.isUser && booking.treatmentId && (booking.user_type == \'callcenter\' && !booking.treatment.over_enabled) && booking.store && booking.date && booking.customer\"><md-input-container layout=\"row\" class=\"md-block\"><md-checkbox ng-disabled=\"\'true\'\"><b>Overbooking non abilitato</b> per <b>{{ booking.treatment.name }}</b></md-checkbox></md-input-container></div><div class=\"user-select\" ng-if=\"booking.config.data.overbooking_enabled && booking.store.booking_online && booking.isOver\"><label for=\"usersList2\" class=\"label-input\">Scegli una operatrice</label><md-select ng-disabled=\"booking.loading || booking.monthAvailability.loading\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"usersList2\" aria-label=\"Selezione operatrice\" ng-model=\"booking.operator.id\" ng-change=\"booking.operatorSelected()\"><md-option value=\"\"></md-option><md-option ng-value=\"op.user_id\" ng-repeat=\"op in booking.rolesList | orderBy: \'user.firstname\': true track by op.id\"><span ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ op.color }};\"></span> {{ op.user.firstname }} <span ng-if=\"booking.isUser\">{{ op.user.lastname }}</span> <span ng-if=\"!booking.isUser\">{{ op.user.lastname!=null && op.user.lastname.substring(0,1) + \'.\' }}</span></md-option></md-select><div class=\"help-block\" ng-messages=\"booking.customerForm.usersList2.$error\" \"=\"\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div layout=\"row\" layout-align=\"center\" ng-if=\"booking.config.data.overbooking_enabled && booking.isUser && booking.treatmentId && (booking.user_type === \'admin\' || (booking.treatment && booking.treatment.over_enabled)) && booking.store && booking.date && booking.customer\"><md-input-container layout=\"row\" class=\"md-block\" flex=\"40\"><md-checkbox ng-model=\"booking.isOver\">Overbooking</md-checkbox></md-input-container><md-input-container layout=\"row\" class=\"md-block\" flex=\"40\" ng-if=\"booking.isOver\" style=\"font-size: 1.2em; text-align: center; margin-top: 30px;\"><input mdc-datetime-picker=\"\" disable-parent-scroll=\"true\" today-btn=\"false\" short-time=\"true\" date=\"false\" type=\"text\" id=\"startTime\" time=\"true\" placeholder=\"Ora inizio\" format=\"HH:mm\" ng-model=\"booking.overDateStart\" ng-disabled=\"!booking.operator.id\"></md-input-container></div></div></div><div class=\"row\"><div ng-if=\"!booking.isOver\" ng-class=\"{\'col-xs-10\': true, \'col-md-4\': true}\"><div><h4>{{booking.date1_frmt}}</h4></div><div class=\"custom-select custom-select-boxed\"><div ng-repeat=\"availability in booking.availabilitiesToShowList | filter : {\'date\': booking.date1}: true | orderBy: availability.date_start\" ng-model=\"booking.availability\" uib-btn-radio=\"availability\" class=\"custom-select-element {{ (booking.isUser && availability.speed?\'speed-\'+availability.speed:\'\') }}\"><div ng-if=\"booking.isUser && booking.showOperators\" class=\"operator-circle\" style=\"background-color: {{ availability.role.data.color }};\"></div><span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">dalle</span> <strong>{{availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">alle</span> <strong ng-if=\"booking.canSeeDuration\">{{availability.date_end | splitTimeFilter | limitTo:5}}</strong><span ng-if=\"availability.reserved && availability.reserved<5\">*</span> <span ng-if=\"availability.reserved == 5\"><i class=\"icon-school\"></i></span> <span ng-if=\"availability.reserved && availability.reserved==8\"><i class=\"icon-group\"></i> {{availability.meet_available}} posti</span> <span ng-if=\"availability.user_id\">M: {{availability.user.data.lastname}}</span> <span ng-if=\"availability.user_id_replace\">({{availability.replaceUser.data.lastname}})</span> <span ng-if=\"availability.assist_user_id\">A: {{availability.assistUser.data.lastname}}</span></div><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco le disponibilit&agrave;</div></div></div><div class=\"no-availability\" ng-show=\"!booking.availabilitiesToShowList.length\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessuna disponibilit&agrave;</div></div></div><div ng-if=\"!booking.isOver\" ng-class=\"{\'col-xs-10\': true, \'col-md-4\': true}\"><div><h4>{{booking.date2_frmt}}</h4></div><div class=\"custom-select custom-select-boxed\"><div ng-repeat=\"availability in booking.availabilitiesToShowList | filter : {\'date\': booking.date2} : true | orderBy: availability.date_start\" ng-model=\"booking.availability\" uib-btn-radio=\"availability\" class=\"custom-select-element {{ (booking.isUser && availability.speed?\'speed-\'+availability.speed:\'\') }}\"><div ng-if=\"booking.isUser && booking.showOperators\" class=\"operator-circle\" style=\"background-color: {{ availability.role.data.color }};\"></div><span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">dalle</span> <strong>{{availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">alle</span> <strong ng-if=\"booking.canSeeDuration\">{{availability.date_end | splitTimeFilter | limitTo:5}}</strong><span ng-if=\"availability.reserved && availability.reserved<5\">*</span> <span ng-if=\"availability.reserved == 5\"><i class=\"icon-school\"></i></span> <span ng-if=\"availability.reserved && availability.reserved==8\"><i class=\"icon-school\"></i> {{availability.meet_available}} posti</span> <span ng-if=\"availability.user_id\">M: {{availability.user.data.lastname}}</span> <span ng-if=\"availability.user_id_replace\">({{availability.replaceUser.data.lastname}})</span> <span ng-if=\"availability.assist_user_id\">A: {{availability.assistUser.data.lastname}}</span></div><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco le disponibilit&agrave;</div></div></div><div class=\"no-availability\" ng-show=\"!booking.availabilitiesToShowList.length\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessuna disponibilit&agrave;</div></div></div><div ng-if=\"!booking.isOver\" ng-class=\"{\'col-xs-10\': true, \'col-md-4\': true}\"><div><h4>{{booking.date3_frmt}}</h4></div><div class=\"custom-select custom-select-boxed\"><div ng-repeat=\"availability in booking.availabilitiesToShowList | filter : {\'date\': booking.date3} : true | orderBy: availability.date_start\" ng-model=\"booking.availability\" uib-btn-radio=\"availability\" class=\"custom-select-element {{ (booking.isUser && availability.speed?\'speed-\'+availability.speed:\'\') }}\"><div ng-if=\"booking.isUser && booking.showOperators\" class=\"operator-circle\" style=\"background-color: {{ availability.role.data.color }};\"></div><span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">dalle</span> <strong>{{availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">alle</span> <strong ng-if=\"booking.canSeeDuration\">{{availability.date_end | splitTimeFilter | limitTo:5}}</strong><span ng-if=\"availability.reserved && availability.reserved<5\">*</span> <span ng-if=\"availability.reserved == 5\"><i class=\"icon-school\"></i></span> <span ng-if=\"availability.reserved && availability.reserved==8\"><i class=\"icon-school\"></i> {{availability.meet_available}} posti</span> <span ng-if=\"availability.user_id\">M: {{availability.user.data.lastname}}</span> <span ng-if=\"availability.user_id_replace\">({{availability.replaceUser.data.lastname}})</span> <span ng-if=\"availability.assist_user_id\">A: {{availability.assistUser.data.lastname}}</span></div><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco le disponibilit&agrave;</div></div></div><div class=\"no-availability\" ng-show=\"!booking.availabilitiesToShowList.length\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessuna disponibilit&agrave;</div></div></div></div><div class=\"col-xs-10 col-md-6 col-md-offset-3\" ng-if=\"booking.isOver && booking.isUser\"><div class=\"custom-select custom-select-boxed app_pren\"><table width=\"100%\"><tr class=\"app_pren_tr_h\"><td colspan=\"{{booking.canSeeDuration ? 5 : 3}}\">Appuntamenti prenotati</td></tr><tr ng-repeat=\"app in booking.appointmentsToShowList\" style=\"text-align: left; width: 100%;\" ng-class-even=\"\'app_pren_even\'\"><td width=\"8%\" style=\"text-align: center;\"><div ng-if=\"booking.isUser\" class=\"operator-circle\" style=\"background-color: {{ app.role.data.color }};\"></div></td><td width=\"20%\"><span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">dalle</span> <strong>{{app.date_start | splitTimeFilter | limitTo:5 }}</strong></td><td width=\"10%\" ng-if=\"booking.canSeeDuration\"><i ng-if=\"booking.appHaveOverlap(app)\" class=\"icon-error_outline blink\"></i></td><td width=\"20%\" ng-if=\"booking.canSeeDuration\"><span class=\"opacity-70\">alle</span> <strong>{{app.date_end | splitTimeFilter | limitTo:5}}</strong></td><td width=\"42%\"><i ng-if=\"app.user_times<=1\" style=\"color: green;\" class=\"icon-input\"></i> <i ng-if=\"app.f_over>0\" style=\"color: red;\" class=\"icon-grid_off\"></i> <strong>{{app.treatment.data.name}}</strong></td></tr></table><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco appuntamenti</div></div></div><div class=\"no-availability\" ng-show=\"booking.appointmentsToShowList.length==0\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessun appuntamento</div></div></div><div class=\"row radio-buttons-box\" ng-if=\"!booking.isOver\"><div class=\"col-md-12\"><radio-buttons options=\"booking.dayMomentList\" ng-model=\"booking.dayMoment\" ng-click=\"booking.momentSelected()\"></radio-buttons></div></div><div class=\"row fadein fadeout\" ng-show=\"!booking.isUser && booking.availability && !(booking.landing && booking.customerId)\"><div class=\"col-md-12\"><h3 class=\"title resume-sentence\"><span class=\"opacity-70\">Il trattamento</span> <strong>{{booking.treatment.name }}</strong> <span class=\"opacity-70\">sar&agrave; eseguito</span> <strong ng-if=\"booking.birthdate\">in Omaggio</strong> <span ng-if=\"!booking.birthdate\" class=\"opacity-70\">al costo di</span> <strong ng-if=\"!booking.birthdate\" ng-bind-html=\"booking.treatmentPrice?booking.treatmentPrice:booking.treatment.start_price | labelRadioButtonFilter: \'euro\'\"></strong><br class=\"hidden-xs\"><strong>{{ booking.date4Labels.format() | date:\'EEEE d MMMM\' }}</strong> <span class=\"opacity-70\" ng-if=\"!booking.canSeeDuration\">alle</span> <span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">dalle</span> <strong>{{booking.availability.date_start | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">alle</span> <strong ng-if=\"booking.canSeeDuration\">{{booking.availability.date_end | splitTimeFilter | limitTo:5}}</strong> <span class=\"opacity-70\">da:</span></h3><div class=\"user-wrap centered\"><div class=\"user-name title\">{{booking.availability.user.data.firstname}}</div><div class=\"user-description row\"><div class=\"col-xs-offset-1 col-xs-10 col-md-offset-3 col-md-6\">{{booking.availability.user.data.description}}</div></div></div></div></div></div><div ng-if=\"!(booking.landing && !booking.user && booking.customerId)\" class=\"step_number\"><strong>{{ booking.dateTimeStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section></div><div class=\"switch-item2\" ng-if=\"booking.store.booking_online || booking.customer\"><section class=\"row box box-client\" ng-if=\"!(booking.customerId && booking.landing) && !booking.birthdate && !booking.isUser && booking.env.anonymous_access\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-bind-html=\"booking.isClientTitle\"></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><radio-buttons options=\"booking.isClientList\" ng-model=\"booking.isClient\"></radio-buttons></div><div class=\"step_number\"><strong>{{ booking.isClientStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section><section class=\"row box box-customer-data\" ng-if=\"!(booking.landing && booking.customerId) && booking.appointmentId==null && booking.env.anonymous_access || booking.user\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-show=\"booking.isUser && booking.customerId\">Dati di <span>{{booking.customer.firstname}}</span></h3><h3 class=\"title\" ng-show=\"!booking.isUser\">Lascia i tuoi <span>dati</span></h3><h3 class=\"title\" ng-show=\"booking.isUser && !booking.customerId\">Inserisci i dati del <span>cliente</span></h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><div class=\"form-group required\"><div ng-if=\"!booking.isUser && (!booking.env.captcha || booking.env.captcha.key)\" vc-recaptcha=\"\" key=\"!booking.env.captcha?\'6LfLty4UAAAAAGRLmlN7G7csoOGGLe75Q0ewkY9D\':booking.env.captcha.key\" ng-model=\"booking.captcha\" theme=\"light\" size=\"normal\" type=\"\'image\'\" lang=\"it\"></div></div></div></div><div class=\"row\"><h1 ng-if=\"booking.isUser && booking.existLeadComm && booking.existLeadComm.user_id\" class=\"col-xs-12 has-error title title-main col-md-12\">Lead Commerciale gestito da {{booking.existLeadComm.user.data.lastname }} {{booking.existLeadComm.user.data.firstname }} N° Tel. {{booking.existLeadComm.user.data.phone }}</h1><h1 ng-if=\"booking.isUser && booking.existLeadComm && !booking.existLeadComm.user_id\" class=\"col-xs-12 has-error title title-main col-md-12\">Lead Commerciale gestito da NUMERO VERDE {{ booking.env.info_number }}</h1><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><div ng-if=\"booking.isUser && booking.customer && booking.customer.f_guarantee\" class=\"form-group row\"><h3 class=\"title\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"currentColor\" class=\"bi bi-shield-check\" viewbox=\"0 0 16 16\"><path d=\"M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z\"></path><path d=\"M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z\"></path></svg>&nbsp;Garanzia attiva: {{booking.customer.guarantee_at_frmt }}</h3></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': booking.customerForm.phone.$invalid && booking.customerForm.phone.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone\" name=\"phone\" class=\"form-control\" placeholder=\"Cellulare\" ng-model=\"booking.customer.phone\" ng-disabled=\"booking.cantChangeCustomer || (!booking.isUser && booking.captcha==null && (!booking.env.captcha || booking.env.captcha.key))\" ng-pattern=\"/^[0-9]{9}[0-9]?[0-9]?[0-9]?$/\" ng-blur=\"booking.checkCustomer()\" required=\"\"></div><div ng-show=\"booking.customerChecking\"><i class=\"icon-cached\"></i>Caricamento in corso ...</div><div class=\"help-block\" ng-messages=\"booking.customerForm.phone.$error\" ng-show=\"booking.customerForm.phone.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono(9 o 10 cifre) senza spazi ne altri caratteri.</div></div><span class=\"small-txt\">il cellulare &egrave; necessario per confermare l\'appuntamento</span></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.firstname.$touched && booking.customerForm.firstname.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"booking.customer.firstname\" ng-maxlength=\"30\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded || (!booking.isUser && booking.customer.id!=null) || (!booking.isUser && booking.captcha==null && (!booking.env.captcha || booking.env.captcha.key))\" required=\"\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.firstname.$error\" ng-show=\"booking.customerForm.firstname.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"row\"><h6 ng-if=\"(booking.source | lowercase) == \'app\'\" class=\"title title-app-coupon title-app-coupon-last\">Eventuali sconti verranno applicati al momento del pagamento.</h6></div><div ng-if=\"booking.isUser\" class=\"form-group\" ng-class=\"{ \'has-error\': booking.customerForm.lastname.$touched && booking.customerForm.lastname.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"booking.customer.lastname\" ng-maxlength=\"30\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.lastname.$error\" ng-show=\"booking.customerForm.lastname.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"booking.isUser\" class=\"form-group\" ng-class=\"{ \'has-error\': booking.customerForm.email.$touched && booking.customerForm.email.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-markunread\"></i></div><input type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email\" ng-model=\"booking.customer.email\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.email.$error\" ng-show=\"booking.customerForm.email.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"booking.isUser\" class=\"form-group\" ng-class=\"{ \'has-error\': booking.customerForm.birthdate.$touched && booking.customerForm.birthdate.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-today\"></i></div><input type=\"date\" name=\"birthdate\" class=\"form-control\" placeholder=\"Data di nascita\" ng-model=\"booking.customer.birthdate\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\" ng-required=\"booking.isCallCenter && !booking.appointmentId\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.birthdate.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><radio-buttons ng-show=\"booking.isUser\" options=\"booking.gendersList\" ng-model=\"booking.gender\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\" ng-required=\"booking.isCallCenter && !booking.appointmentId\"></radio-buttons><div class=\"has-error\" ng-if=\"booking.isCallCenter && !booking.appointmentId && !booking.gender\">Questo campo è obbligatorio</div><div ng-if=\"booking.isUser\" style=\"margin-top:1rem;\" class=\"form-group\" ng-class=\"{ \'has-error\': booking.customerForm.referral_code.$touched && booking.customerForm.referral_code.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><input type=\"text\" name=\"referral_code\" class=\"form-control\" placeholder=\"Codice acquisizione\" ng-disabled=\"true\" ng-model=\"booking.user.user_alias\"></div></div><div ng-if=\"booking.isUser && booking.sourcesList!=null && booking.customer.id == null\" class=\"form-group\"><p>Campagna</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-autorenew\"></i></div><select ng-model=\"booking.customer.campaign\" class=\"form-control\" ng-disabled=\"booking.customerChecking\"><option value=\"\"></option><option ng-value=\"val\" ng-repeat=\"val in booking.sourcesList\">{{ val }}</option></select></div></div><div ng-if=\"booking.isUser\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><input type=\"text\" name=\"user_times\" class=\"form-control\" ng-disabled=\"true\" ng-model=\"booking.f_oper_descr\"></div></div><div ng-if=\"false || (booking.isUser && booking.customer.id == null)\" class=\"form-group\" ng-class=\"{ \'has-error\': booking.customerForm.src_phone.$touched && booking.customerForm.src_phone.$invalid }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" name=\"src_phone\" class=\"form-control\" placeholder=\"Telefono Phone Friends\" ng-disabled=\"booking.customerChecking\" ng-model=\"booking.customer.src_phone\"></div></div><div ng-if=\"booking.customer.customer_subscriptions_active.length > 0 && !booking.landing.treatment_id && !booking.birthdate\" class=\"form-group form-group-highlight\"><p>Sfrutta un abbonamento attivo <strong style=\"color:#a94442;\">*</strong></p><md-radio-group id=\"customer_subscription_id\" name=\"customer_subscription_id\" ng-model=\"booking.customer_subscription_id\" ng-change=\"booking.customerSubscriptionIdChange()\" ng-disabled=\"booking.customerChecking || booking.f_prepayment || booking.f_deposit || booking.f_preauth\" class=\"form-control\" style=\"height:auto;\"><md-radio-button ng-repeat=\"subscription in booking.customer.customer_subscriptions_active track by subscription.id\" value=\"{{subscription.id}}\"><span ng-if=\"subscription.subscription_id != 1000\"><span ng-bind-html=\"subscription.subscription_id | subscriptionIdtoName:booking.subscriptionsList:subscription.app_remaining\"></span><br><small>[id: {{subscription.id}}]</small></span> <span ng-if=\"subscription.subscription_id == 1000 && subscription.quotation && subscription.quotation.data && subscription.quotation.data.id\"><strong>Pdc n.{{subscription.quotation.data.id}} del {{subscription.quotation.data.date | date:\'dd/MM/yyyy\'}} {{subscription.quotation.data.type}} {{subscription.quotation.data.note ? \'(\' + subscription.quotation.data.note + \')\' : \'\'}}</strong> (rimaste {{subscription.app_remaining}})</span></md-radio-button><md-radio-button value=\"\">Non sfruttare un abbonamento</md-radio-button></md-radio-group></div><div ng-if=\"false && booking.tenantDataLoaded && booking.isUser && !booking.landing.treatment_id\" class=\"form-group\"><p>Crea un nuovo abbonamento</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-autorenew\"></i></div><select ng-model=\"booking.subscription_new_id\" ng-change=\"booking.subscriptionNewIdChange()\" class=\"form-control\" ng-disabled=\"booking.customerChecking\"><option value=\"\"></option><option ng-value=\"subscriptionNew.id\" ng-repeat=\"subscriptionNew in booking.subscriptionsList | filter: {active: 1}: true | orderBy: \'name\'\" ng-if=\"booking.user.type == \'admin\' || (!booking.vitruvianManEnabled || subscriptionNew.treatment_category_id != 1 )\">{{ subscriptionNew.name }}</option></select></div></div></div></div><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.insertPf()\" ng-if=\"booking.isUser && booking.tenantDataLoaded && booking.customer && booking.customer.phone && !booking.existLeadComm\"><img src=\"assets/images/loading.svg\"> <span ng-if=\"true\">Inserisci Phone Friend</span></button><div ng-if=\"booking.isUser\" class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Note Paziente</h3></div><div ng-if=\"booking.isUser\" class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"input-group-addon\"><i class=\"icon-event_note\"></i></div><textarea id=\"note\" name=\"note\" class=\"form-control\" placeholder=\"Note\" rows=\"3\" ng-disabled=\"booking.customerChecking || !booking.tenantDataLoaded\" ng-model=\"booking.customer.note\"></textarea></div></div></div><div ng-if=\"booking.isUser && booking.tenantDataLoaded && !booking.existLeadComm\" class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Appuntamenti Precedenti</h3></div><div ng-if=\"booking.isUser && booking.tenantDataLoaded && !booking.existLeadComm\" class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"custom-select custom-select-boxed app_prec\"><table width=\"100%\"><tr class=\"app_prec_tr_h\"><td>Trattamento</td><td>Centro</td><td>Data ora</td><td>Spost./Disd.</td><td>Presentato</td><td>&euro;</td></tr><tr ng-repeat=\"app in booking.customer.appointments.data | orderBy : app.date_start : true\" style=\"text-align: left; width: 100%;\" ng-class-even=\"\'app_pren_even\'\"><td width=\"30%\"><strong>{{app.treatment.data.name}}</strong></td><td width=\"25%\"><strong>{{app.store.data.alias}}</strong></td><td width=\"20%\"><strong>{{app.date_start_frmt}}</strong></td><td width=\"10%\"><strong>{{app.recalled==3?\'DISD\':(app.recalled==4?\'SPOST\':\'\')}}</strong></td><td width=\"10%\"><strong>{{app.paid?\'SI\':\'NO\'}}</strong></td><td width=\"10%\"><strong><span ng-if=\"app.paid\">{{app.price}}&euro;</span></strong></td></tr></table><div class=\"loading\"><div class=\"loading-in\"><div class=\"loading-content\">Cerco appuntamenti precendenti</div></div></div><div class=\"no-availability\" ng-show=\"booking.customer.appointments.data.length==0\"><i class=\"icon-sentiment_dissatisfied\"></i>Nessun appuntamento</div></div></div></div></div></div><div class=\"step_number\"><strong>{{ booking.customerDataStep }}</strong> di <span ng-if=\"booking.store.booking_online\">{{ booking.totalStep }}</span><span ng-if=\"!booking.store.booking_online\">3</span></div></div></section></div></div><section class=\"row box box-customer-data\" ng-if=\"booking.isUser && booking.tenantDataLoaded && (!booking.env.tenant==\'Italia\' || booking.user) && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Note Appuntamento</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"input-group-addon\"><i class=\"icon-event_note\"></i></div><textarea id=\"note\" name=\"note\" class=\"form-control\" placeholder=\"Note\" rows=\"3\" ng-model=\"booking.note\"></textarea></div></div></div></section><section class=\"row box box-customer-data\" ng-show=\"booking.isUser && (booking.availability || booking.isOver) && (!booking.env.tenant==\'Italia\' || booking.user) && !booking.existLeadComm\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\">Riepilogo prenotazione di {{booking.customer.firstname}} (telefono: {{booking.customer.phone}})</h3></div><div class=\"col-md-12 box-body\"><h3 class=\"title resume-sentence\"><span class=\"opacity-70\">Il trattamento</span> <strong>{{booking.treatment.name }}</strong> <span class=\"opacity-70\">sar&agrave; eseguito</span><span ng-show=\"booking.priceOverride>0\">al costo di</span> <strong ng-show=\"booking.priceOverride>0\" ng-bind-html=\"booking.treatmentPrice?booking.treatmentPrice:booking.priceOverride | labelRadioButtonFilter: \'euro\'\"></strong> <strong ng-show=\"booking.priceOverride==0\">Omaggio</strong><br class=\"hidden-xs\"><span class=\"opacity-70\">il giorno</span> <strong ng-show=\"!booking.isOver\">{{ booking.availability.date_start | dateTimeStringToLabel }}</strong> <strong ng-show=\"booking.isOver\">{{ booking.date | dateTimeStringToLabel }}</strong> <span class=\"opacity-70\" ng-if=\"!booking.canSeeDuration\">alle</span> <span class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">dalle</span> <strong ng-show=\"!booking.isOver\">{{booking.availability.date_start | splitTimeFilter | limitTo:5}}</strong> <strong ng-show=\"booking.isOver\">{{booking.overDateStart | date: \'HH:mm\'}}</strong> <span ng-show=\"!booking.isOver\" class=\"opacity-70\" ng-if=\"booking.canSeeDuration\">alle</span> <strong ng-show=\"!booking.isOver\" ng-if=\"booking.canSeeDuration\">{{booking.availability.date_end | splitTimeFilter | limitTo:5}}</strong> <span ng-show=\"booking.isOver\" class=\"opacity-70\">(in overbooking)</span><br class=\"hidden-xs\"><span class=\"opacity-70\">da</span> <strong ng-show=\"!booking.isOver\">{{booking.availability.user.data.firstname}}</strong> <strong ng-show=\"booking.isOver\">{{booking.operator.role.user.firstname}}</strong> <span class=\"opacity-70\">nel centro di</span> <strong>{{booking.store.alias}}</strong></h3></div></section><div class=\"cta-wrap centered\" ng-if=\"booking.store.booking_online && !booking.existLeadComm\"><div class=\"alert alert-primary\" ng-if=\"booking.customer.customer_subscriptions_active.length > 0 && !booking.landing.treatment_id && !booking.birthdate && booking.customer_subscription_id === null\">È presente un abbonamento attivo: prima di proseguire, scegli quale usare.</div><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.sendData()\" ng-if=\"booking.env.anonymous_access || booking.user\" ng-disabled=\"booking.existLeadComm || booking.isSaving || booking.customerForm.$invalid || (!booking.isOver && !booking.availability || booking.isOver && (!booking.customer || !booking.operator.id || !booking.date || !booking.overDateStart)) || (booking.customer.customer_subscriptions_active.length > 0 && !booking.landing.treatment_id && !booking.birthdate && booking.customer_subscription_id === null)\"><img src=\"assets/images/loading.svg\"> <span ng-if=\"booking.appointmentId==null\">Prenota ora</span> <span ng-if=\"booking.appointmentId!=null\">Sposta</span></button><br><a class=\"or-call centered\" ng-if=\"!booking.isUser\" href=\"tel:{{booking.store.phone}}\"><div class=\"call-icon\"><i class=\"icon-phone\"></i></div><div class=\"call-info\"><span class=\"small-txt\">oppure contattaci telefonicamente</span><div class=\"call-number\">{{ booking.store.phone }}</div></div><div class=\"clearfix\"></div></a></div><div class=\"footer full-width\" ng-if=\"!booking.isUser\">&copy; {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a ng-if=\"booking.env.info_number\" href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br><a href=\"{{booking.env.privacy_url}}\" class=\"iubenda-nostyle no-brand iubenda-embed\" title=\"Privacy Policy\">Privacy Policy</a></div><footer class=\"main-header full-width\"><button class=\"btn btn-primary btn-back\" ng-if=\"booking.isUser && booking.state.current.name === \'booking-operator\'\" ng-click=\"booking.back()\"><i class=\"icon-arrow_back\"></i> Indietro</button><div ng-if=\"booking.env.tenant!=\'Bios\'\" class=\"logo\"></div><div ng-if=\"booking.env.tenant==\'Bios\'\" class=\"logo-bios\"></div></footer></form></div>");
$templateCache.put("app/booking/completed.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-done\"></i><h1 class=\"title title-main\">Grazie {{ completed.appointment.customer.firstname }} per l\'appuntamento!</h1><div><h4><strong>Verrai contattato</strong> al numero di telefono che hai indicato da una nostra operatrice<br>per confermare i dati dell\'appuntamento.</h4></div><div ng-if=\"false\"><p>Più Condividi e più ti ricarichi!<br>Per ogni amico che porti a {{completed.env.company}}, una sorpresa ti aspetta!</p><p><button class=\"sharer button btn btn-social\" data-sharer=\"twitter\" data-title=\"{{completed.env.company}} - Medicina Estetica AntiAge, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Medicina Estetica AntiAge, Viso, Antiage, Corpo, Modeling\" data-url=\"https://booking.{{completed.env.domain}}\">Twitter</button> <button class=\"sharer button btn btn-social\" data-sharer=\"facebook\" data-title=\"{{completed.env.company}} - Medicina Estetica AntiAge, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Medicina Estetica, Epilazione, Viso, Antiage, Corpo, Modeling\" data-url=\"https://booking.{{completed.env.domain}}\">Facebook</button> <button class=\"sharer button btn btn-social\" data-sharer=\"googleplus\" data-title=\"{{completed.env.company}} - Medicina Estetica, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Medicina Estetica, Epilazione, Viso, Antiage, Corpo, Modeling\" data-url=\"https://booking.{{completed.env.domain}}\">Google+</button> <button class=\"sharer button btn btn-social\" data-sharer=\"telegram\" data-title=\"{{completed.env.company}} - Medicina Estetica, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Medicina Estetica, Viso, Antiage, Corpo, Modeling\" data-url=\"http://booking.{{completed.env.domain}}\">Telegram</button> <button class=\"sharer button btn btn-social\" data-sharer=\"whatsapp\" data-title=\"{{completed.env.company}} - Medicina Estetica, Viso, Corpo\" data-hashtags=\"{{completed.env.company}}, Medicina Estetica, Viso, Antiage, Corpo, Modeling\" data-url=\"http://booking.{{completed.env.domain}}\">Whatsapp</button></p></div></section><div class=\"footer full-width\">© {{completed.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{completed.env.info_email}}\">{{completed.env.info_email}}</a><br><a href=\"tel:{{completed.env.info_number}}\">{{completed.env.info_number}}</a><br></div></div>");
$templateCache.put("app/booking/notauthorized.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-error\"></i><h1 class=\"title title-main\">Autenticazione fallita.</h1><div><h4>Le credenziali inserite non sono valide.</h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/booking/payment-cancel.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-error\"></i><h1 ng-if=\"booking.type==\'preauth\" class=\"title title-main\">Pre-autorizzazione al non andata a buon fine.</h1><h1 ng-if=\"booking.type==\'prepayment\'\" class=\"title title-main\">Pagamento non andato a buon fine.</h1><h1 ng-if=\"booking.type==\'deposit\'\" class=\"title title-main\">Pagamento acconto non andato a buon fine.</h1><div><h4></h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/booking/payment-error.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-error\"></i><h1 class=\"title title-main\">Collegamento a Stripe fallito.</h1><div><h4>I dati trasmessi non sono validi.</h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/booking/payment-success.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-done\"></i><h1 ng-if=\"booking.type==\'prepayment\'\" class=\"title title-main\">Pagamento avvenuto con successo.</h1><h1 ng-if=\"booking.type==\'deposit\'\" class=\"title title-main\">Pagamento acconto avvenuto con successo.</h1><h1 ng-if=\"booking.type==\'preauth\'\" class=\"title title-main\">Pre-autorizzazione pagamento avvenuta con successo.</h1><div><h4 ng-if=\"booking.type==\'preauth\'\"><strong>Il pagamento è stato pre-autorizzato</strong><br>Riceverai un messaggio di conferma con i dettagli del pagamento.</h4><h4 ng-if=\"booking.type==\'prepayment\'\"><strong>Il pagamento è stato effettuato con successo</strong><br>Riceverai un messaggio di conferma con i dettagli del pagamento.</h4><h4 ng-if=\"booking.type==\'deposit\'\"><strong>Il pagamento dell\'acconto è stato effettuato con successo</strong><br>Riceverai un messaggio di conferma con i dettagli del pagamento.</h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/main/messages.html","<p class=\"has-error\" ng-message=\"required\">Questo campo è obbligatorio</p><p class=\"has-error\" ng-message=\"minlength\">Questo campo è troppo corto</p><p class=\"has-error\" ng-message=\"maxlength\">Questo campo è troppo lungo</p><p class=\"has-error\" ng-message=\"email\">Questa email non è valida</p><p class=\"has-error\" ng-message=\"pattern\">Questa email non è valida</p>");
$templateCache.put("app/payment/payment-success.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><section><i class=\"icon-done\"></i><h1 ng-if=\"booking.type==\'prepayment\'\" class=\"title title-main\">Pagamento avvenuto con successo.</h1><h1 ng-if=\"booking.type==\'deposit\'\" class=\"title title-main\">Pagamento acconto avvenuto con successo.</h1><h1 ng-if=\"booking.type==\'preauth\'\" class=\"title title-main\">Pre-autorizzazione pagamento avvenuta con successo.</h1><div><h4 ng-if=\"booking.type==\'preauth\'\"><strong>Il pagamento è stato pre-autorizzato</strong><br>Riceverai un messaggio di conferma con i dettagli del pagamento.</h4><h4 ng-if=\"booking.type==\'prepayment\'\"><strong>Il pagamento è stato effettuato con successo</strong><br>Riceverai un messaggio di conferma con i dettagli del pagamento.</h4><h4 ng-if=\"booking.type==\'deposit\'\"><strong>Il pagamento dell\'acconto è stato effettuato con successo</strong><br>Riceverai un messaggio di conferma con i dettagli del pagamento.</h4></div></section><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/payment/payment.html","<div class=\"container page-booking page-completed\" ng-class=\"{ isuser: booking.isUser, isclient: booking.isClient }\"><header class=\"main-header full-width\"><div class=\"logo\"></div></header><form name=\"booking.customerForm\" role=\"form\" autocomplete=\"off\" novalidate=\"\"><section class=\"row box box-tenant-data centered\"><div class=\"col-md-12 box-header title-container\"><h3 class=\"title\" ng-if=\"!booking.type && booking.loading\">Caricamento dati pagamento in corso ...</h3><h3 class=\"title\" ng-if=\"!booking.type && !booking.loading\">Dati pagamento non trovati</h3><h3 class=\"title\" ng-if=\"booking.type == \'prepayment\'\">Pagamento anticipato</h3><h3 class=\"title\" ng-if=\"booking.type == \'deposit\'\">Pagamento acconto</h3><h3 class=\"title\" ng-if=\"booking.type == \'preauth\'\">Pre-autorizzazione al Pagamento</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-3 col-md-6\"><div ng-if=\"booking.error\" id=\"card-errors\" role=\"alert\"><i class=\"icon-error\"></i><h2>{{booking.error}}</h2></div><md-progress-circular style=\"text-align: center; margin: 50px;\" md-mode=\"indeterminate\" ng-if=\"booking.loading\"></md-progress-circular><img src=\"assets/images/loading.svg\" ng-if=\"false\" class=\"loading-img\"></div><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-3 col-md-6\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.firstname.$touched && booking.customerForm.firstname.$invalid) }\"><p>Nome:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname\" class=\"form-control\" placeholder=\"Nome\" ng-model=\"booking.customer.firstname\" ng-maxlength=\"30\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" required=\"\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.firstname.$error\" ng-show=\"booking.customerForm.firstname.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.lastname.$touched && booking.customerForm.lastname.$invalid) }\"><p>Cognome:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname\" class=\"form-control\" placeholder=\"Cognome\" ng-model=\"booking.customer.lastname\" ng-maxlength=\"30\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" required=\"\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.lastname.$error\" ng-show=\"booking.customerForm.lastname.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group required\" style=\"text-align: center;\"><p>Sesso:</p><div class=\"input-group\" style=\"text-align: center;\"><md-radio-group id=\"gender\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" name=\"gender\" ng-model=\"booking.customer.gender\" ng-required=\"true\" required=\"\"><md-radio-button value=\"F\">Femmina</md-radio-button><md-radio-button value=\"M\" class=\"md-primary\">Maschio</md-radio-button></md-radio-group></div><div class=\"help-block\" ng-messages=\"booking.customerForm.gender.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': booking.customerForm.birthdate.$touched && booking.customerForm.birthdate.$invalid }\"><p>Data di nascita:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-today\"></i></div><input type=\"date\" name=\"birthdate\" class=\"form-control\" placeholder=\"Data di nascita\" ng-model=\"booking.customer.birthdate\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" ng-required=\"true\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.birthdate.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': booking.customerForm.birthprovince.$touched && booking.customerForm.birthprovince.$invalid }\"><p>Provincia di nascita:</p><div class=\"input-group required\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><md-select ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"birthprovince\" ng-required=\"true\" aria-label=\"Selezione Provincia di nascita\" ng-model=\"booking.customer.birthprovince\" ng-change=\"booking.birthProvinceChange()\"><md-option ng-repeat=\"province in booking.birthProvinces\" value=\"{{province.value}}\">{{province.label}}</md-option></md-select></div><div class=\"help-block\" ng-messages=\"booking.customerForm.birthprovince.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': booking.customerForm.birthcity.$touched && booking.customerForm.birthcity.$invalid }\"><p>Città di nascita:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><md-select ng-disabled=\"booking.loading || !booking.appointment || booking.processing || !booking.customer.birthprovince || booking.birthCitiesByProvince.length === 0\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"birthcity\" name=\"birthcity\" ng-required=\"true\" aria-label=\"Selezione Città di nascita\" ng-model=\"booking.customer.birthcity\"><md-option ng-repeat=\"city in booking.birthCitiesByProvince\" value=\"{{city}}\">{{city}}</md-option></md-select></div><div class=\"help-block\" ng-messages=\"booking.customerForm.birthcity.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"cta-wrap centered\" style=\"margin-bottom: 10px;\"><button id=\"btn-booking\" ng-class=\"{issaving: booking.computingCf }\" class=\"btn btn-success btn-mega\" ng-click=\"booking.computeCf()\" style=\"padding: 10px; font-size: 2rem;\" ng-disabled=\"!booking.customer.firstname || !booking.customer.lastname || !booking.customer.birthcity || !booking.customer.gender || !booking.customer.birthdate || booking.computingCf || booking.alreadyPaid || booking.processing || booking.loading || !booking.appointment\"><img src=\"assets/images/loading.svg\"> <span>Calcola Cod. Fisc.</span></button><div style=\"margin-top: 20px;\" ng-if=\"booking.cferror\"><h2 class=\"text-center\">{{booking.cferror}}</h2></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.cf.$touched && booking.customerForm.cf.$invalid) }\"><p>Codice fiscale:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"cf\" class=\"form-control\" placeholder=\"Codice fiscale\" ng-model=\"booking.customer.cf\" ng-maxlength=\"30\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" required=\"\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.cf.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.province.$touched && booking.customerForm.province.$invalid) }\"><p>Provincia di residenza:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><md-select ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"province\" ng-required=\"true\" aria-label=\"Selezione Provincia di residenza\" ng-model=\"booking.customer.province\" ng-change=\"booking.provinceChange()\"><md-option ng-repeat=\"province in booking.provinces\" value=\"{{province.value}}\">{{province.label}}</md-option></md-select></div><div class=\"help-block\" ng-messages=\"booking.customerForm.province.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.city.$touched && booking.customerForm.city.$invalid) }\"><p>Città di residenza:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><md-select ng-disabled=\"booking.loading || !booking.appointment || booking.processing || !booking.customer.province || booking.citiesByProvince.length === 0\" style=\"width: 100%; text-align: left; margin: 0px;\" class=\"form-control select-store md-no-underline\" id=\"city\" name=\"city\" ng-required=\"true\" aria-label=\"Selezione Città di residenza\" ng-model=\"booking.customer.city\"><md-option ng-repeat=\"city in booking.citiesByProvince\" value=\"{{city}}\">{{city}}</md-option></md-select></div><div class=\"help-block\" ng-messages=\"booking.customerForm.city.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.zip_code.$touched && booking.customerForm.zip_code.$invalid) }\"><p>Cap di residenza:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><input type=\"text\" name=\"zip_code\" class=\"form-control\" ng-required=\"true\" placeholder=\"Cap di residenza\" ng-model=\"booking.customer.zip_code\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.zip_code.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': (booking.customerForm.address.$touched && booking.customerForm.address.$invalid) }\"><p>Indirizzo di residenza:</p><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-code\"></i></div><input type=\"text\" name=\"address\" class=\"form-control\" ng-required=\"true\" placeholder=\"Indirizzo di residenza\" ng-model=\"booking.customer.address\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\"></div><div class=\"help-block\" ng-messages=\"booking.customerForm.address.$error\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"booking.appointment\" class=\"col-md-12 box-header title-container\"><p></p><h3 class=\"title\" ng-if=\"booking.type == \'prepayment\'\">Pagamento Anticipato</h3><h3 class=\"title\" ng-if=\"booking.type == \'deposit\'\">Pagamento Acconto</h3><h3 class=\"title\" ng-if=\"booking.type == \'preauth\'\">Pre-autorizzazione al pagamento</h3><p></p></div><table ng-if=\"booking.appointment\" style=\"padding: 20px; width: 100%; font-size: 2rem;\"><tr><td style=\"padding: 20px 0px; text-align: left;\" ng-if=\"booking.appointment.treatment\">{{booking.appointment.treatment.alias?booking.appointment.treatment.alias:booking.appointment.treatment.name}}<br>{{booking.appointment.date_start_frmt}}</td><td style=\"padding: 20px 0px; text-align: right;\">{{booking.deposit.price}} &euro;</td></tr></table><div class=\"form-group\"><p ng-if=\"booking.appointment\">Inserire i dati per <span ng-if=\"booking.type == \'prepayment\'\">il pagamento anticipato</span> <span ng-if=\"booking.type == \'deposit\'\">il pagamento acconto</span> <span ng-if=\"booking.type == \'preauth\'\">la pre-autorizzazione al pagamento</span></p><label for=\"card-holder-name\">Nome del titolare della carta</label> <input type=\"text\" id=\"card-holder-name\" class=\"form-control\" placeholder=\"Cognome Nome\" ng-model=\"booking.cardholder\" ng-disabled=\"booking.loading || !booking.appointment || booking.processing\" required=\"\"><div style=\"padding: 20px 0px; font-size: 2rem;\" id=\"card-element\"></div></div><div style=\"margin: 20px;\" id=\"payment-request-button\"></div><div class=\"cta-wrap centered\"><button id=\"btn-booking\" ng-class=\"{issaving: booking.isSaving }\" class=\"btn btn-success btn-mega\" style=\"padding: 16px; font-size: 3.5rem;\" ng-click=\"booking.processPayment()\" ng-disabled=\"booking.customerForm.$invalid || booking.alreadyPaid || booking.processing || booking.loading || !booking.appointment\"><img src=\"assets/images/loading.svg\"> <span ng-if=\"booking.type == \'prepayment\'\">Paga</span> <span ng-if=\"booking.type == \'deposit\'\">Paga anticipo</span> <span ng-if=\"booking.type == \'preauth\'\">Autorizza</span></button><div style=\"margin-top: 20px;\" ng-if=\"booking.alreadyPaid\"><h2 class=\"text-center\">Transazione già effettuata!</h2></div></div></div></div></div></div></section></form><div class=\"footer full-width\">© {{booking.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{booking.env.info_email}}\">{{booking.env.info_email}}</a><br><a href=\"tel:{{booking.env.info_number}}\">{{booking.env.info_number}}</a><br></div></div>");
$templateCache.put("app/phonefriends/completed.html","<div class=\"container page-booking page-completed\"><header class=\"main-header full-width\"><div class=\"logo\"></div><div class=\"banner\"></div></header><section><i class=\"icon-done\"></i><h1 class=\"title title-main\">Grazie per le segnalazioni!</h1><div><h4><div ng-if=\"customer.last_store_id != null\">Mostra questo messaggio nel negozio {{ customer.lastStore.data.name}}<br>per ricevere immeditamente un trattamento <strong>gratuito</strong> a tua scelta.</div><div ng-if=\"customer.last_store_id == null\">Mostra questo messaggio nel centro {{phonefriend.env.company}} pi&ugrave; vicino<br>per ricevere immeditamente un trattamento <strong>gratuito</strong> a tua scelta.</div></h4></div></section><div class=\"footer full-width\">© {{phonefriends.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{phonefriends.env.info_email}}\">{{phonefriends.env.info_email}}</a><br><a href=\"tel:{{phonefriends.env.info_number}}\">{{phonefriends.env.info_number}}</a><br><a href=\"{{phonefriends.env.privacy_url}}\" class=\"iubenda-nostyle no-brand iubenda-embed\" title=\"Privacy Policy\">Privacy Policy</a></div></div>");
$templateCache.put("app/phonefriends/phonefriends.html","<div class=\"container page-booking\"><header class=\"main-header full-width\"><div ng-if=\"phonefriends.env.tenant != \'Bios\'\" class=\"logo\"></div><div ng-if=\"phonefriends.env.tenant == \'Bios\'\" class=\"logo-bios\"></div><div ng-if=\"!phonefriends.isUser\" class=\"banner\"></div></header><section ng-if=\"!phonefriends.isUser\"><h1 class=\"title title-main\">Invita 5 amici per ricevere subito<br>un trattamento <strong>GRATIS</strong></h1></section><section ng-if=\"phonefriends.user\"><h4 style=\"text-align: center;\">v{{phonefriends.version}} | <span ng-if=\"phonefriends.user.type==\'operator\' || phonefriends.user.type==\'storemngr\'\" class=\"operator-circle\" style=\"background-color: {{ phonefriends.user.color }};\"></span> <span>{{phonefriends.user.firstname}} {{phonefriends.user.lastname}}</span> <span ng-if=\"phonefriends.user.type!=\'operator\' && phonefriends.user.type!=\'storemngr\'\">[{{phonefriends.user.type}}]</span> <span ng-if=\"phonefriends.user.type==\'operator\' || phonefriends.user.type==\'storemngr\'\">[{{phonefriends.user.store.alias}} <span ng-if=\"phonefriends.user.type==\'storemngr\'\">*</span>]</span></h4><h1 class=\"title title-main\">Inserimento PhoneFriends</h1></section><section class=\"row box box-customer-data\"><div class=\"col-md-12 box-header title-container\"><h3 ng-if=\"!phonefriends.isUser\" class=\"title\">Il tuo numero di <span>cellulare</span></h3><h3 ng-if=\"phonefriends.user\" class=\"title\"><span>Cellulare</span> del cliente segnalante</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><form name=\"custumerForm\" role=\"form\" id=\"custumerForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': customerForm.phone.$invalid && customerForm.phone.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone\" name=\"phone\" class=\"form-control\" placeholder=\"Il tuo cellulare\" ng-model=\"phonefriends.customer.phone\" ng-disabled=\"phonefriends.customerChecking || phonefriends.customerLoaded==true\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" required=\"\"></div><div ng-show=\"phonefriends.customerChecking\"><i class=\"icon-cached\"></i> ricerca in corso ...</div><div class=\"non-cliente\" ng-show=\"phonefriends.customerLoaded==false\"><strong>Non sei ancora cliente {{phonefriends.env.company}}? Rivolgiti al centro {{phonefriends.env.company}} pi&ugrave; vicino.</strong></div><div class=\"help-block\" ng-messages=\"customerForm.phone.$error\" ng-show=\"customerForm.phone.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div><span class=\"small-txt\">il cellulare è necessario per invitare i tuoi amici</span></div><div ng-hide=\"phonefriends.customerLoaded\" class=\"cta-wrap centered\"><button id=\"btn-pf-start\" ng-class=\"{ issaving: phonefriends.customerChecking }\" class=\"btn btn-success btn-mega\" ng-click=\"phonefriends.checkCustomer()\" ng-disabled=\"phonefriends.customerChecking || customerForm.phone.$invalid\"><img src=\"assets/images/loading.svg\"> <span>Inizia</span></button></div></div></div></form></div></div></section><section class=\"row box box-customer-data\" ng-show=\"phonefriends.customerLoaded\"><div class=\"col-md-12 box-header title-container\"><h3 ng-if=\"!phonefriends.isUser\" class=\"title\">Invita 5 <span>amici</span></h3><h3 ng-if=\"phonefriends.user\" class=\"title\"><span>Amici</span> segnalati</h3></div><div class=\"col-md-12 box-body\"><div class=\"centered\"><div class=\"row\"><div class=\"col-xs-offset-0 col-xs-12 col-md-offset-4 col-md-4\"><wizard on-finish=\"finished()\" indicators-position=\"top\" name=\"addProspects\"><wz-step wz-title=\"Amica 1\"><form name=\"friend1Form\" role=\"form\" id=\"friend1Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend1Form.firstname1.$touched && friend1Form.firstname1.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname1\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend1Form.firstname1.$error\" ng-show=\"friend1Form.firstname1.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname1\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend1Form.phone1.$invalid && friend1Form.phone1.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone1\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend1Form.phone1.$error\" ng-show=\"friend1Form.phone1.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step1\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend1Form.phone1.$invalid || friend1Form.firstname1.$invalid\" ng-click=\"saveProspect(1)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button> <button id=\"btn-pf-step1p\" wz-next=\"\" class=\"btn btn-success btn-mega\" style=\"margin-top: 10px;\" ng-disabled=\"saving || friend1Form.phone1.$invalid || friend1Form.firstname1.$invalid\" ng-click=\"saveProspect(1,true)\"><img src=\"assets/images/loading.svg\"> Prenota</button></div></form></wz-step><wz-step wz-title=\"Amica 2\"><form name=\"friend2Form\" role=\"form\" id=\"friend2Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend2Form.firstname2.$touched && friend2Form.firstname2.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname2\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend2Form.firstname2.$error\" ng-show=\"friend2Form.firstname2.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname2\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend2Form.phone2.$invalid && friend2Form.phone2.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone2\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend2Form.phone2.$error\" ng-show=\"friend2Form.phone2.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step2\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend2Form.phone2.$invalid || friend2Form.firstname2.$invalid\" ng-click=\"saveProspect(2)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button></div><div class=\"cta-wrap centered\"></div></form></wz-step><wz-step wz-title=\"Amica 3\"><form name=\"friend3Form\" role=\"form\" id=\"friend3Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend3Form.firstname3.$touched && friend3Form.firstname3.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname3\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend3Form.firstname3.$error\" ng-show=\"friend3Form.firstname3.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname3\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend3Form.phone3.$invalid && friend3Form.phone3.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone3\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend3Form.phone3.$error\" ng-show=\"friend3Form.phone3.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step3\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend3Form.phone3.$invalid || friend3Form.firstname3.$invalid\" ng-click=\"saveProspect(3)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button></div></form></wz-step><wz-step wz-title=\"Amica 4\"><form name=\"friend4Form\" role=\"form\" id=\"friend4Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend4Form.firstname4.$touched && friend4Form.firstname4.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname4\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend4Form.firstname4.$error\" ng-show=\"friend4Form.firstname4.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname4\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend4Form.phone4.$invalid && friend4Form.phone4.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone4\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend4Form.phone4.$error\" ng-show=\"friend4Form.phone4.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step4\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend4Form.phone4.$invalid || friend4Form.firstname4.$invalid\" ng-click=\"saveProspect(4)\"><img src=\"assets/images/loading.svg\"> <span>Avanti</span></button></div></form></wz-step><wz-step wz-title=\"Amica 5\"><form name=\"friend5Form\" role=\"form\" id=\"friend5Form\" autocomplete=\"off\" novalidate=\"\"><div class=\"form-group required\" ng-class=\"{ \'has-error\': (friend5Form.firstname5.$touched && friend5Form.firstname5.$invalid) }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"firstname5\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Nome\" ng-model=\"phonefriends.prospect.firstname\" ng-minlength=\"3\" ng-maxlength=\"30\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend5Form.firstname5.$error\" ng-show=\"friend5Form.firstname5.$touched\"><div ng-messages-include=\"app/main/messages.html\"></div></div></div><div ng-if=\"phonefriends.user\" class=\"form-group\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-person\"></i></div><input type=\"text\" name=\"lastname5\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cognome\" ng-model=\"phonefriends.prospect.lastname\" ng-minlength=\"2\" ng-maxlength=\"30\"></div></div><div class=\"form-group required\" ng-class=\"{ \'has-error\': friend5Form.phone5.$invalid && friend5Form.phone5.$touched }\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"icon-phone_android\"></i></div><input type=\"text\" id=\"phone1\" name=\"phone5\" class=\"form-control\" ng-disabled=\"saving\" placeholder=\"Cellulare\" ng-model=\"phonefriends.prospect.phone\" ng-pattern=\"/^[0-9]{9}[0-9]?$/\" ng-blur=\"\" required=\"\"></div><div class=\"help-block\" ng-messages=\"friend5Form.phone5.$error\" ng-show=\"friend5Form.phone5.$touched\"><div ng-message=\"pattern\"><small>Inserisci un numero di telefono valido.</small><br>Inserisci il tuo numero di telefono (9 o 10 cifre) senza spazi ne altri caratteri.</div></div></div><div class=\"cta-wrap centered\"><button id=\"btn-pf-step5\" wz-next=\"\" class=\"btn btn-success btn-mega\" ng-disabled=\"saving || friend5Form.phone5.$invalid || friend5Form.firstname5.$invalid\" ng-click=\"saveProspect(5)\"><img src=\"assets/images/loading.svg\"> <span>Fine</span></button></div></form></wz-step></wizard><button id=\"btn-pf-step2_fine\" class=\"btn btn-success btn-mega\" ng-if=\"phonefriends.user && phonefriends.step!=4\" ng-click=\"phonefriends.back()\"><img src=\"assets/images/loading.svg\"> <span>Esci</span></button></div></div></div></div></section><div class=\"footer full-width\">© {{phonefriends.env.company}} - tutti i diritti riservati<br><br>Contatti:<br><a href=\"mailto:{{phonefriends.env.info_email}}\">{{phonefriends.env.info_email}}</a><br><a href=\"tel:{{phonefriends.env.info_number}}\">{{phonefriends.env.info_number}}</a><br><a href=\"{{phonefriends.env.privacy_url}}\" class=\"iubenda-nostyle no-brand iubenda-embed\" title=\"Privacy Policy\">Privacy Policy</a></div><footer class=\"main-header full-width\"><div ng-if=\"phonefriends.env.tenant != \'Bios\'\" class=\"logo\"></div><div ng-if=\"phonefriends.env.tenant == \'Bios\'\" class=\"logo-bios\"></div></footer></div>");
$templateCache.put("app/components/radio-buttons/radio-buttons.html","<div class=\"radio-buttons-wrap\" ng-class=\"{disabled: option.disabled == true }\" ng-repeat=\"option in options\"><div value=\"{{option.value}}\" ng-click=\"$parent.select($parent.scope, option.value)\" ng-class=\"{active: option.active == true }\" class=\"radio-buttons {{ option.icon }}\"><span class=\"radio-buttons-txt\" ng-if=\"option.label\" ng-bind-html=\"option.label | labelRadioButtonFilter:option.type\"></span></div><div class=\"radio-buttons-desc\" ng-if=\"option.description\">{{ option.description }}</div><div class=\"radio-buttons-times opacity-70\" ng-if=\"option.start\">{{ option.start| limitTo:5 }} - {{ option.end | limitTo:5 }}</div></div>");}]);